<div class="dialog-header" *ngIf="data.type == 1">
  <h2 mat-dialog-title class="py-4 px-3 d-flex justify-content-between align-items-center"
    *ngIf="edit_customer_step != 3">
    <span class="px-3">Update Customer Details </span>

    <mat-icon (click)="edit_customer_step !=3?dialogRef.close():dialogRef.close(1)" class="close text-dark"
      style="position: relative !important; transform: none !important;">close</mat-icon>
  </h2>
  <div mat-dialog-content class="pt-0">
    <div *ngIf="edit_customer_step == 2">
      <form class="row g-0" [formGroup]="customerDetails" (ngSubmit)="customerDetailsSubmit()" autocomplete="_away">
        <div class="pe-3 w-100 make_payment" style="max-height: calc(100vh - 225px);overflow-y: auto;">
          <label for="" class="m-0 text-bold mb-3" style="color: #313A44;" id="personal-details">
            Personal Information
          </label>
          <ng-container *ngIf="doctorSettings.showCustomerMinorQuestion">
            <div class="row form-group m-0 d-flex" *ngIf="data && data.send_data && data.send_data.contract_type != 5">
            <label class="form-label f-c-p-4 fs-14 text-bold p-0" style="width: max-content;">Is Customer a
              Minor* ?
            </label>
            <span class="d-flex" style="width: auto;">
              <div class="radio ms-5 me-4">
                <input type="radio" [(ngModel)]="customerMinor" name="customerMinor" [value]=1 id="customerMinor_1"
                  formControlName="customerMinor">
                <label for="customerMinor_1">
                  <span class="ps-2">Yes</span>
                </label>
              </div>
              <div class="radio">
                <input type="radio" [(ngModel)]="customerMinor" name="customerMinor" [value]=0 id="customerMinor_2"
                  formControlName="customerMinor">
                <label for="customerMinor_2">
                  <span class="ps-2">No</span>
                </label>
              </div>
            </span>
          </div>
          <div class="w-100" *ngIf="customerMinor">
            <div class="custom-form mt-3"
              [ngClass]="[customerDetails.controls && customerDetails.controls.guardianFirstName && customerDetails.controls.guardianFirstName.touched && customerDetails.controls.guardianFirstName.invalid  ? 'inputContainer' : '']">
              <input type="text" class="input_field pt-2 px-3" name="guardianFirstName"
                formControlName="guardianFirstName" trim required />
              <label for="text" class="label-name">
                <span class="content-name f-c-p-3">
                  Guardian First Name
                </span>
              </label>
            </div>
            <p class="mat-error"
              *ngIf="customerDetails.controls && customerDetails.controls.guardianFirstName && customerDetails.controls.guardianFirstName.touched && customerDetails.controls.guardianFirstName.invalid">
              Please enter valid guardian first name.</p>
          </div>
          <div class="w-100" *ngIf="customerMinor">
            <div class="custom-form mt-3"
              [ngClass]="[customerDetails.controls && customerDetails.controls.guardianLastName && customerDetails.controls.guardianLastName.touched && customerDetails.controls.guardianLastName.invalid  ? 'inputContainer' : '']">
              <input type="text" class="input_field pt-2 px-3" name="guardianLastName"
                formControlName="guardianLastName" trim required autocomplete="_away" />
              <label for="text" class="label-name">
                <span class="content-name f-c-p-3">
                  Guardian Last Name
                </span>
              </label>
            </div>
            <p class="mat-error"
              *ngIf="customerDetails.controls && customerDetails.controls.guardianLastName && customerDetails.controls.guardianLastName.touched && customerDetails.controls.guardianLastName.invalid">
              Please enter valid guardian last name.</p>
          </div>
          </ng-container>
          <div class="w-100">
            <div class="custom-form mt-3"
              [ngClass]="[customerDetails.controls && customerDetails.controls.customerFirstName && customerDetails.controls.customerFirstName.touched && customerDetails.controls.customerFirstName.invalid  ? 'inputContainer' : '']">
              <input type="text" class="input_field pt-2 px-3" name="customerFirstName"
                formControlName="customerFirstName" trim required autocomplete="_away" />
              <label for="text" class="label-name">
                <span class="content-name f-c-p-3">
                  Customer First Name
                </span>
              </label>
            </div>
            <p class="mat-error"
              *ngIf="customerDetails.controls && customerDetails.controls.customerFirstName && customerDetails.controls.customerFirstName.touched && customerDetails.controls.customerFirstName.invalid">
              Please enter valid customer first name.</p>
          </div>
          <div class="w-100">
            <div class="custom-form mt-3"
              [ngClass]="[customerDetails.controls && customerDetails.controls.customerLastName && customerDetails.controls.customerLastName.touched && customerDetails.controls.customerLastName.invalid  ? 'inputContainer' : '']">
              <input type="text" class="input_field pt-2 px-3" name="customerLastName"
                formControlName="customerLastName" trim required autocomplete="_away" />
              <label for="text" class="label-name">
                <span class="content-name f-c-p-3">
                  Customer Last Name
                </span>
              </label>
            </div>
            <p class="mat-error"
              *ngIf="customerDetails.controls && customerDetails.controls.customerLastName && customerDetails.controls.customerLastName.touched && customerDetails.controls.customerLastName.invalid">
              Please enter valid customer last name.</p>
          </div>
          <div class="form-group row w-100 m-0 mt-3">
            <div class="w-100 p-0">
              <div class="w-100 d-flex align-items-center b-10 m-h-56"
                [ngClass]="[(customerDetails.controls.customerDob.touched && customerDetails.controls.customerDob.invalid) || mainService.warningText  ? 'inputContainer' : (customerDetails.controls.customerDob.disabled ? 'disabled-input' : '')]">
                <div class="custom-form ">
                  <input type="tel" class="pointer input_field px-3 pt-3 notranslate" id="birthdate-numeric"
                    formControlName="customerDob" placeholder="MM/DD/YYYY" autocomplete="off" maxlength="12"
                    [mask]="dobMask" (keyup)="mainService.checkDOB($event)">
                  <label for="text" class="label-name">
                    <span class="content-name f-c-p-3">
                      Customer Date of Birth
                    </span>
                  </label>
                </div>
              </div>
              <p class="mat-error mb-0 ms-0 ps-0"
                *ngIf="customerDetails.controls.customerDob.touched && customerDetails.controls.customerDob.invalid && mainService.warningText.length == 0">
                Please enter valid date of birth.
              </p>
              <p class="mat-error mb-0 ms-0 ps-0">{{mainService.warningText}}</p>
            </div>
          </div>
          <div class="row form-group w-100 m-0 mt-3">
            <label class="form-label f-c-p-4 fs-14 text-bold p-0" style="width: max-content;">Gender*</label>
            <div class="col-12 p-0 d-flex justify-content-between align-items-center" style="width: auto;">
              <div class="radio ms-4 me-3">
                <label class="pointer">
                  <input type="radio" name="gender" [value]=1 id="gender" formControlName="gender">
                  <label for="gender">
                    <span class="fs-14 f-c-p-1 ps-2">Male</span>
                  </label>
                </label>
              </div>
              <div class="radio me-3">
                <label class="pointer">
                  <input type="radio" name="gender" [value]=2 id="gender1" formControlName="gender">
                  <label for="gender1">
                    <span class="fs-14 f-c-p-1 ps-2">Female</span>
                  </label>
                </label>
              </div>
              <div class="radio">
                <label class="pointer">
                  <input type="radio" name="gender" [value]=3 id="gender2" formControlName="gender">
                  <label for="gender2">
                    <span class="fs-14 f-c-p-1 ps-2">Others</span>
                  </label>
                </label>
              </div>
            </div>
            <p class="mat-error"
              *ngIf="customerDetails.controls.gender.invalid && customerDetails.controls.gender.touched">
              Please select a valid gender.</p>
          </div>
          <div class="w-100">
            <div class="custom-form mt-3"
              [ngClass]="[customerDetails.controls && customerDetails.controls.socailSecuityNumber && customerDetails.controls.socailSecuityNumber.touched && customerDetails.controls.socailSecuityNumber.invalid  ? 'inputContainer' : '']">
              <input type="text" class="input_field pt-2 px-3" name="socailSecuityNumber"
                formControlName="socailSecuityNumber" autocomplete="_away" required maxlength="9" minlength="9"
                onkeydown="if(event.key==='.'){event.preventDefault();}"
                oninput="event.target.value = event.target.value.replace(/[^0-9]*/g,'');"
                [readonly]="customerInfo && customerInfo[0] && customerInfo[0].patient_ssn" />
              <label for="text" class="label-name">
                <span class="content-name f-c-p-3">
                  Social Security Number
                </span>
              </label>
            </div>
            <p class="mat-error"
              *ngIf="customerDetails.controls && customerDetails.controls.socailSecuityNumber && customerDetails.controls.socailSecuityNumber.touched && customerDetails.controls.socailSecuityNumber.invalid">
              Please enter valid social security number.</p>
          </div>
          <div class="col-12 p-0">
            <div class="custom-form mt-3"
              [ngClass]="[(customerDetails.controls.phoneNumber.invalid && customerDetails.controls.phoneNumber.touched) || (customerDetails.controls.phoneNumber.invalid && customerDetails.controls.phoneNumber.touched) ? 'inputContainer' : '']">
              <!-- <input class="input_field pt-2 px-3" name="phoneNumber" formControlName="phoneNumber" [mask]="mask"
                required> -->
              <span
                *ngIf="customerDetails.controls.phoneNumber &&  (customerDetails.controls.phoneNumber.value !== null && customerDetails.controls.phoneNumber.value !== '')"
                class="pt-2 pe-1 fw-bold dollar_input" style="position: absolute;left: 14px;bottom: 8px;">+1
              </span>
              <input class="input_field pt-3" autocomplete="_away"
                [ngStyle]="{'padding-left': customerDetails.controls.phoneNumber.value !== '' ? '40px' : '1rem'}"
                name="phoneNumber" formControlName="phoneNumber" [mask]="mask" required />
              <label for="text" class="label-name">
                <span class="content-name f-c-p-3">
                  Phone Number
                </span>
              </label>
            </div>
            <p class="mat-error"
              *ngIf="(!customerDetails.get('phoneNumber').hasError('PhoneNumber') && customerDetails.controls.phoneNumber.invalid && customerDetails.controls.phoneNumber.touched)">
              Please enter valid phone number</p>
            <p class="mat-error" *ngIf="customerDetails.get('phoneNumber').hasError('PhoneNumber')">
              Customer Phone Number Cannot be same as Business Phone.</p>

          </div>
          <div class="col-12 p-0">
            <div class="custom-form mt-3"
              [ngClass]="[(customerDetails.controls.emailAddress.invalid && customerDetails.controls.emailAddress.touched) ? 'inputContainer' : '']">
              <input autocomplete="_away" class="input_field pt-2 px-3" name="emailAddress"
                formControlName="emailAddress" trim readonly required>
              <label for="text" class="label-name">
                <span class="content-name f-c-p-3">
                  Email Address
                </span>
              </label>
            </div>
          </div>
          <div class="w-100">
            <div class="custom-form mt-3"
              [ngClass]="[customerDetails.controls && customerDetails.controls.dlNumber && customerDetails.controls.dlNumber.touched && customerDetails.controls.dlNumber.invalid  ? 'inputContainer' : '']">
              <input type="text" autocomplete="_away" class="input_field pt-2 px-3" name="dlNumber"
                formControlName="dlNumber" trim maxlength="20" [required]='doctorSettings.is_DL_mandatory == 1'
                (keypress)="omit_special_char($event)" (keydown.space)="$event.preventDefault();" autofocus />
              <label for="text" class="label-name">
                <span class="content-name f-c-p-3">
                  DL Number
                </span>
              </label>
            </div>
            <p class="mat-error"
              *ngIf="customerDetails.controls && customerDetails.controls.dlNumber && customerDetails.controls.dlNumber.touched && customerDetails.controls.dlNumber.invalid">
              Please enter valid DL number.</p>
          </div>
          <div class="w-100">
            <div class="custom-form mt-3"
              [ngClass]="[customerDetails.controls && customerDetails.controls.address && customerDetails.controls.address.touched && customerDetails.controls.address.invalid  ? 'inputContainer' : '']">
              <input autocomplete="_away" type="text" class="input_field pt-2 px-3" name="address"
                formControlName="address" trim required />
              <label for="text" class="label-name">
                <span class="content-name f-c-p-3">
                  Address
                </span>
              </label>
            </div>
            <p class="mat-error"
              *ngIf="customerDetails.controls && customerDetails.controls.address && customerDetails.controls.address.touched && customerDetails.controls.address.invalid">
              Please enter valid address.</p>
          </div>
          <div class="w-100 d-padding mt-3">
            <!-- <zip-selector (zipSelected)="getZipselected($event)" [placeholder]=""
              [customClass]="[customerDetails.controls.zipPostalCode.touched && customerDetails.controls.zipPostalCode.invalid ? 'inputContainer' : 'custom-form']"
              t="2" [isRequired]="true" id="zipPostalCode" name="zipPostalCode" [model]="zipPostalCode" ngDefaultControl
              [defaultzip]="zipCode">
            </zip-selector> -->
            <app-google-api (setAddress)="getZipselected($event)"
              [customClass]="[customerDetails.controls.zipPostalCode.touched && customerDetails.controls.zipPostalCode.invalid ? 'inputContainer' : 'custom-form']"
              [t]="1" id="zipPostalCode" name="zipPostalCode" [model]="zipPostalCode" ngDefaultControl
              [defaultzip]="zipCode">
            </app-google-api>
          </div>
          <p class="mat-error"
            *ngIf="customerDetails.controls && customerDetails.controls.zipPostalCode && customerDetails.controls.zipPostalCode.touched && (customerDetails.controls.zipPostalCode.invalid || !(customerDetails.controls.zipPostalCode && zipCode && zipCode.zip))">
            Please enter valid zip.
          </p>

          <div class="w-100">
            <div class="custom-form mt-3">
              <input type="text" class="input_field pt-2 px-3 disabled_field" name="state" formControlName="state"
                trim />
              <label for="text" [ngClass]="[ customerDetails.controls.state.value ? 'label-name' : '']">
                <span class="content-name f-c-p-3">
                  State
                </span>
              </label>
            </div>
          </div>

          <div class="w-100">
            <div class="custom-form mt-3"
              [ngClass]="[customerDetails.controls && customerDetails.controls.city && customerDetails.controls.city.touched && customerDetails.controls.city.invalid  ? 'inputContainer' : '']">
              <input autocomplete="_away" type="text" class="input_field pt-2 px-3" name="city" formControlName="city"
                trim required autocomplete="disabled"
                (blur)="updateCity(customerDetails.controls.city.value, 'user_data')" />
              <label for="text" [ngClass]="[ customerDetails.controls.city.value ? 'label-name' : '']">
                <span class="content-name f-c-p-3">
                  City
                </span>
              </label>
            </div>
            <p class="mat-error"
              *ngIf="customerDetails.controls && customerDetails.controls.city && customerDetails.controls.city.touched && customerDetails.controls.city.invalid">
              Please enter valid city.
            </p>
          </div>

          <ng-container *ngIf="data.send_data.contract_type != 5">
            <div class="mt-4">
              <label for="" class="m-0 text-bold" style="color: #313A44;">
                Employment Information
              </label>
            </div>
            <div class="w-100 py-3 mt-2">
              <p class="fw-bold fs-14 f-c-p-4 m-0">Are you Employed?</p>

              <input class="form-check-input d-none" formControlName="employed" required>

            </div>
            <div class="d-flex align-items-center w-100">
              <div class="form-check me-2 ps-0">
                <label class="form-check-label pointer p-2" for="flexRadioDefault1">
                  <input class="form-check-input" name="employed" type="radio" value='0' id="flexRadioDefault1"
                    (change)="changeFeilds(0)"
                    [checked]="(customerDetails.value.employed === '0' || customerDetails.value.employed === 0) ? true : false">
                  <label for="flexRadioDefault1">
                    <span class="ps-2">Yes</span>
                  </label>
                </label>
              </div>
              <div class="form-check me-2 ps-0">
                <label class="form-check-label pointer p-2" for="flexRadioDefault2">
                  <input class="form-check-input" name="employed" type="radio" value='1' id="flexRadioDefault2"
                    (change)="changeFeilds(1)"
                    [checked]="(customerDetails.value.employed === '1' || customerDetails.value.employed === 1) ? true : false" />
                  <label for="flexRadioDefault2">
                    <span class="ps-2">No</span>
                  </label>
                </label>
              </div>
              <div class="form-check ps-0">
                <label class="form-check-label pointer p-2" for="flexRadioDefault3">
                  <input class="form-check-input" name="employed" (change)="changeFeilds(2)"
                    [checked]="(customerDetails.value.employed === '2' || customerDetails.value.employed === 2) ? true : false"
                    type="radio" value='2' id="flexRadioDefault3">
                  <label for="flexRadioDefault3">
                    <span class="ps-2">
                      Self Employed
                    </span>
                  </label>
                </label>
              </div>
            </div>
            <p class="mat-error"
              *ngIf="customerDetails.controls.employed.invalid && customerDetails.controls.employed.touched">
              Please select a valid employed option.</p>
            <ng-container
              *ngIf="customerDetails.controls && customerDetails.controls.employed && customerDetails.controls.employed.value == 1">
              <div class="w-100">
                <div class="wrap m-h-56 h-100 h-56 border_10 d-block mt-3"
                  [ngClass]="[customerDetails.controls && customerDetails.controls.payment_source && customerDetails.controls.payment_source.touched && customerDetails.controls.payment_source.invalid ? 'inputContainer_select' : '']">
                  <div class="select w-100 h-100 h-56 d-flex justify-content-between align-items-center">
                    <div class="w-100 h-100">
                      <select id="img_logo_emp" formControlName="payment_source" (change)="changeSelection()"
                        class="select-text pt-3 px-3 mt-1 input_field fw-bold m-h-56 h-100 w-100" required>
                        <option *ngFor="let item of allowed_payback_methods" [value]="item">
                          {{item}}</option>
                      </select>
                      <span class="select-highlight"></span>
                      <span class="select-bar"></span>
                      <span class="select-bar-1"></span>
                      <span class="select-bar-1"></span>
                      <label class="select-label f-c-p-3">Please select your payment
                        source</label>
                    </div>
                  </div>
                </div>
                <p class="mat-error w-100"
                  *ngIf="customerDetails.controls && customerDetails.controls.payment_source && customerDetails.controls.payment_source.touched && customerDetails.controls.payment_source.invalid">
                  Please Select a valid Payment Source</p>
              </div>
              <div class="w-100"
                *ngIf="customerDetails && customerDetails?.controls && customerDetails?.controls?.payment_source && customerDetails?.controls?.payment_source.value === 'Others'">
                <div class="custom-form mt-3"
                  *ngIf="customerDetails.controls && customerDetails.controls.payment_source_reference"
                  [ngClass]="[customerDetails.controls && customerDetails.controls.payment_source_reference && customerDetails.controls.payment_source_reference?.touched && customerDetails.controls.payment_source_reference.invalid  ? 'inputContainer' : '']">
                  <input autocomplete="_away" type="text" class="input_field pt-2 px-3" name="payment_source_reference"
                    formControlName="payment_source_reference" trim required />
                  <label for="text" class="label-name">
                    <span class="content-name f-c-p-3">
                      Payment Source Name
                    </span>
                  </label>
                </div>
                <p class="mat-error"
                  *ngIf="customerDetails.controls && customerDetails.controls.payment_source_reference && customerDetails.controls.payment_source_reference?.touched && customerDetails.controls.payment_source_reference.invalid ">
                  Please choose a valid payback source</p>
              </div>
            </ng-container>
            <ng-container *ngIf="customerDetails.controls.employed.value == '0'">
              <div class="w-100">
                <div class="custom-form mt-3 p-0"
                  [ngClass]="[customerDetails.controls && customerDetails.controls.empName && customerDetails.controls.empName.touched && customerDetails.controls.empName.invalid  ? 'inputContainer' : '']">
                  <input autocomplete="_away" type="text" class="input_field pt-2 px-3" name="empName"
                    formControlName="empName" trim required />
                  <label for="text" class="label-name">
                    <span class="content-name f-c-p-3">
                      Employer Name
                    </span>
                  </label>
                </div>
                <p class="mat-error"
                  *ngIf="customerDetails.controls && customerDetails.controls.empName && customerDetails.controls.empName.touched && customerDetails.controls.empName.invalid">
                  Please enter valid employer name.</p>
              </div>
              <div class="col-12 p-0">
                <div class="custom-form mt-3"
                  [ngClass]="[(customerDetails.controls.empPhoneNumber && customerDetails.controls.empPhoneNumber.invalid && customerDetails.controls.empPhoneNumber.touched) || (customerDetails.controls.empPhoneNumber && customerDetails.controls.empPhoneNumber.invalid && customerDetails.controls.empPhoneNumber.touched) ? 'inputContainer' : '']">
                  <!-- <input class="input_field pt-2 px-3" name="empPhoneNumber" formControlName="empPhoneNumber"
                  [mask]="mask" required> -->
                  <span
                    *ngIf="customerDetails.controls.empPhoneNumber &&  (customerDetails.controls.empPhoneNumber.value !== null && customerDetails.controls.empPhoneNumber.value !== '')"
                    class="pt-2 pe-1 fw-bold dollar_input" style="position: absolute;left: 14px;bottom: 8px;">+1
                  </span>
                  <input autocomplete="_away" class="input_field pt-3"
                    [ngStyle]="{'padding-left': customerDetails.controls.empPhoneNumber.value !== '' ? '40px' : '1rem'}"
                    name="empPhoneNumber" formControlName="empPhoneNumber" [mask]="mask" required />
                  <label for="text" class="label-name">
                    <span class="content-name f-c-p-3">
                      Employer Phone Number
                    </span>
                  </label>
                </div>
                <p class="mat-error"
                  *ngIf="(!customerDetails.get('empPhoneNumber').hasError('empPhoneNumber') && customerDetails.controls.empPhoneNumber && customerDetails.controls.empPhoneNumber.invalid && customerDetails.controls.empPhoneNumber.touched)">
                  Please enter valid employer phone number</p>
                <p class="mat-error" *ngIf="customerDetails.get('empPhoneNumber').hasError('empPhoneNumber')">
                  Employer Phone Number Cannot be same as Business Phone.</p>
              </div>
              <div class="w-100">
                <div class="custom-form mt-3"
                  [ngClass]="[customerDetails.controls && customerDetails.controls.empAddress && customerDetails.controls.empAddress.touched && customerDetails.controls.empAddress.invalid  ? 'inputContainer' : '']">
                  <input autocomplete="_away" type="text" class="input_field pt-2 px-3" name="empAddress"
                    formControlName="empAddress" trim required />
                  <label for="text" class="label-name">
                    <span class="content-name f-c-p-3">
                      Employer Address
                    </span>
                  </label>
                </div>
                <p class="mat-error"
                  *ngIf="customerDetails.controls && customerDetails.controls.empAddress && customerDetails.controls.empAddress.touched && customerDetails.controls.empAddress.invalid">
                  Please enter valid employer address.</p>
              </div>
              <div class="w-100 d-padding mt-2">
                <!-- <zip-selector (zipSelected)="getEmpZipselected($event)" [placeholder]=""
                [customClass]="[customerDetails.controls.empZipCode && customerDetails.controls.empZipCode.touched && customerDetails.controls.empZipCode.invalid ? 'inputContainer' : 'custom-form']"
                t="2" [isRequired]="true" id="empZipCode" name="empZipCode" [model]="empZipCode" ngDefaultControl
                [defaultzip]="empZipCodeData">
              </zip-selector> -->
                <app-google-api (setAddress)="getEmpZipselected($event)"
                  [customClass]="[customerDetails.controls && customerDetails.controls.empZipCode && customerDetails.controls.empZipCode.touched && customerDetails.controls.empZipCode.invalid? 'inputContainer' : 'custom-form']"
                  [t]="2" id="empZipCode" name="empZipCode" [model]="empZipCode" ngDefaultControl
                  [defaultzip]="empZipCodeData">
                </app-google-api>
              </div>
              <p class="mat-error"
                *ngIf="customerDetails.controls && customerDetails.controls.empZipCode && customerDetails.controls.empZipCode.touched && (customerDetails.controls.empZipCode.invalid || !(customerDetails.controls.empZipCode && empZipCodeData && empZipCodeData.zip))">
                Please enter valid zip.
              </p>

              <div class="w-100">
                <div class="custom-form mt-3"
                  [ngClass]="[customerDetails.controls && customerDetails.controls.empState && customerDetails.controls.empState.touched && customerDetails.controls.empState.invalid  ? 'inputContainer' : '']">
                  <input class="input_field pt-2 px-3 disabled_field" type="text" name="empState"
                    formControlName="empState" />
                  <label for="text" [ngClass]="[ customerDetails.controls.empState.value ? 'label-name' : '']">
                    <span class="content-name f-c-p-3">
                      State
                    </span>
                  </label>
                </div>
              </div>

              <div class="w-100">
                <div class="custom-form mt-3"
                  [ngClass]="[customerDetails.controls && customerDetails.controls.empCity && customerDetails.controls.empCity.touched && customerDetails.controls.empCity.invalid  ? 'inputContainer' : '']">
                  <input autocomplete="_away" class="input_field pt-2 px-3" type="text" name="empCity" trim
                    formControlName="empCity" required autocomplete="disabled"
                    (blur)="updateCity(customerDetails.controls.empCity.value, 'employed_data')" />
                  <label for="text" class="label-name">
                    <span class="content-name f-c-p-3">
                      City
                    </span>
                  </label>
                </div>
                <p class="mat-error"
                  *ngIf="customerDetails.controls && customerDetails.controls.empCity && customerDetails.controls.empCity.touched && customerDetails.controls.empCity.invalid">
                  Please enter valid city.
                </p>
              </div>

              <div class="w-100">
                <div class="custom-form mt-3"
                  [ngClass]="[(customerDetails.controls && customerDetails.controls.empAnnualIncome && customerDetails.controls.empAnnualIncome.touched && customerDetails.controls.empAnnualIncome.invalid) || (customerDetails.controls.empAnnualIncome.errors && customerDetails.controls.empAnnualIncome.errors?.err)  ? 'inputContainer' : '']">
                  <span
                    *ngIf="customerDetails.controls && customerDetails.controls.empAnnualIncome && customerDetails.controls.empAnnualIncome && (customerDetails.controls.empAnnualIncome.value !== null && customerDetails.controls.empAnnualIncome.value !== '' && customerDetails.controls.empAnnualIncome.value !== 0 )"
                    class="pt-2 pe-1 fw-bold dollar_input notranslate"
                    style="position: absolute;left: 14px;bottom: 8px;">$</span>
                  <input autocomplete="_away" class="input_field pt-2 px-3 ps-4 pt-3 " type="text"
                    name="empAnnualIncome" formControlName="empAnnualIncome" (keypress)="enterNumberOnly($event)"
                    onKeyPress="if(this.value.length==7) return false;" required />
                  <label for="text" class="label-name">
                    <span class="content-name f-c-p-3">
                      Annual Income
                    </span>
                  </label>
                </div>
                <p class="mat-error"
                  *ngIf="customerDetails.controls && customerDetails.controls.empAnnualIncome && ((customerDetails.controls.empAnnualIncome.touched && customerDetails.controls.empAnnualIncome.invalid) ||
                (customerDetails.controls.empAnnualIncome.errors && customerDetails.controls.empAnnualIncome.errors?.err))">
                  Please enter valid annual income.</p>
              </div>
            </ng-container>
            <ng-container *ngIf="(customerDetails.value.employed == 2 ||  customerDetails.value.employed == '2')">
              <div class="w-100 mi-w-180 my-3"
                *ngIf="(customerDetails.value.employed == 2 ||  customerDetails.value.employed == '2') && customerDetails.controls.profession">
                <div
                  [ngClass]="[customerDetails.controls && customerDetails.controls.profession && customerDetails.controls.profession?.touched && customerDetails.controls && customerDetails.controls.profession && customerDetails.controls.profession.invalid  ? 'inputContainer custom-form' : 'custom-form']">
                  <input type="text" class="input_field px-3 pt-3" name="profession" formControlName="profession" trim
                    required />
                  <label for="text" class="label-name">
                    <span class="content-name f-c-p-3">
                      Profession
                    </span>
                  </label>
                </div>
                <p class="mat-error"
                  *ngIf="customerDetails.controls && customerDetails.controls.profession && customerDetails.controls.profession?.touched && customerDetails.controls && customerDetails.controls.profession && customerDetails.controls.profession.invalid ">
                  Please enter your profession.</p>
              </div>
              <!-- office address -->
              <div class="w-100 mi-w-180 mb-3"
                *ngIf="(customerDetails.value.employed == 2 ||  customerDetails.value.employed == '2') && customerDetails.controls.office_address">
                <div
                  [ngClass]="[customerDetails.controls && customerDetails.controls.office_address && customerDetails.controls.office_address && customerDetails.controls.office_address.touched && customerDetails.controls && customerDetails.controls.office_address && customerDetails.controls.office_address && customerDetails.controls.office_address.invalid  ? 'inputContainer custom-form' : 'custom-form']">
                  <input class="input_field px-3 pt-3" type="text" name="office_address"
                    formControlName="office_address" trim required />
                  <label for="text" class="label-name">
                    <span class="content-name f-c-p-3">
                      Office Address
                    </span>
                  </label>
                </div>
                <p class="mat-error"
                  *ngIf="customerDetails.controls && customerDetails.controls.office_address && customerDetails.controls.office_address?.touched && customerDetails.controls && customerDetails.controls.office_address && customerDetails.controls.office_address.invalid ">
                  Please enter your office address.</p>
              </div>
              <!-- rest changes -->
              <div class="col-sm-12 px-0 pb-2">
                <input type="checkbox" class="pointer" name="same_office_address_value" formControlName="check_office"
                  id="same_office_address_value" style="margin-right: 8px;" (change)="FillOfficeAddress($event)"
                  [checked]="SameAddress">
                <label for="same_office_address_value">
                  <span>
                    Office Address Same as Home Address.
                  </span>
                </label>
              </div>

              <div class="w-100 d-padding">
                <app-google-api (setAddress)="getOfficeZipselected($event)"
                  [customClass]="[customerDetails.controls.office_zip.touched && customerDetails.controls.office_zip.invalid ? 'inputContainer' : 'custom-form']"
                  label="Office Zip" [t]="2" [isRequired]="true" id="office_zip" name="office_zip"
                  [defaultzip]="office_zip" [model]="office_zip" ngDefaultControl>
                </app-google-api>
                <p class="mat-error"
                  *ngIf="customerDetails.controls.office_zip.touched && customerDetails.controls.office_zip.invalid">
                  Please enter a valid Office zip.
                </p>
              </div>

              <div class="row g-0 mb-3">
                <div class="col-md-6 col-12 ps-md-0 form-group mi-w-180 p-0 pe-md-3 mb-0"
                  *ngIf="customerDetails.controls.office_city">

                  <div
                    [ngClass]="[customerDetails.controls && customerDetails.controls.office_city && customerDetails.controls.office_city && customerDetails.controls.office_city.touched && customerDetails.controls && customerDetails.controls.office_city && customerDetails.controls.office_city && customerDetails.controls.office_city.invalid  ? 'inputContainer custom-form mt-3' : 'custom-form mt-3']">
                    <input class="input_field px-3 pt-3" type="text" required name="office_city"
                      formControlName="office_city" trim [(ngModel)]="office_cityy" autocomplete="disabled"
                      (blur)="updateCity(customerDetails.controls.office_city.value, 'office_data')">
                    <label for="text" class="label-name">
                      <span class="content-name f-c-p-3">
                        City
                      </span>
                    </label>
                  </div>
                  <p class="mat-error mb-0"
                    *ngIf="customerDetails.controls && customerDetails.controls.office_city && customerDetails.controls.office_city?.touched && customerDetails.controls && customerDetails.controls.office_city && customerDetails.controls.office_city.invalid">
                    Please enter a valid Office city.</p>
                </div>

                <div class="col-md-6 col-12 pe-md-0 form-group mi-w-180 p-0 mb-0"
                  *ngIf="customerDetails.controls.office_state">
                  <div
                    [ngClass]="[(customerDetails.controls.office_state.invalid && customerDetails.controls.office_state.touched) || (customerDetails.controls.office_state.invalid && customerDetails.controls.office_state.dirty) ? 'custom-form   inputContainer mt-3' : 'custom-form mt-3']">
                    <input class="input_field px-3 pt-3" type="text" name="office_state" formControlName="office_state"
                      trim>
                    <label for="text" class="label-name">
                      <span class="content-name f-c-p-3">
                        State
                      </span>
                    </label>
                  </div>
                </div>
              </div>

              <!-- rest changes -->
              <div class="w-100 mi-w-180 mb-3">
                <div
                  [ngClass]="[customerDetails.controls && customerDetails.controls.annual_income && customerDetails.controls.annual_income && customerDetails.controls.annual_income.touched && customerDetails.controls && customerDetails.controls.annual_income && customerDetails.controls.annual_income && customerDetails.controls.annual_income.invalid  ? 'inputContainer custom-form' : 'custom-form']">
                  <span
                    *ngIf="customerDetails.controls && customerDetails.controls.annual_income && customerDetails.controls.annual_income && (customerDetails.controls.annual_income.value !== null && customerDetails.controls.annual_income.value !== '' && customerDetails.controls.annual_income.value !== 0 )"
                    class="pt-2 pe-1 fw-bold dollar_input notranslate"
                    style="position: absolute;left: 14px;bottom: 8px;">$</span>
                  <input class="input_field px-3 pt-3" type="text" name="annual_income" maxlength="7"
                    formControlName="annual_income" trim (keypress)="enterNumberOnly($event)"
                    onKeyPress="if(this.value.length==7) return false;" required appDecimaNumber
                    [ngClass]="[customerDetails.value.annual_income == '' ? 'px-3' : 'px-4']" />
                  <label for="text" class="label-name">
                    <span class="content-name f-c-p-3">
                      Annual Income
                    </span>
                  </label>
                </div>
                <p class="mat-error" *ngIf="customerDetails.controls && customerDetails.controls.annual_income && ((customerDetails.controls.annual_income.touched && customerDetails.controls.annual_income.invalid) ||
              (customerDetails.controls.annual_income.errors && customerDetails.controls.annual_income.errors?.err))">
                  Please enter valid annual income.</p>
              </div>
            </ng-container>
          </ng-container>
        </div>
        <div class="form-group row w-100 mt-4 m-0">
          <button button-primary-auth style="width: 81px !important;">Save</button>
        </div>
      </form>
    </div>





    <div *ngIf="edit_customer_step == 3" class="text-center d-flex align-items-center" style="height: 100vh;">
      <div class="m-auto text-center">
        <img src="assets/img/png/check_signup.png" width="90px" alt="">
        <h3 class="text-bold my-4">Details updated successfully!</h3>
        <div class="form-group">
          <button button-primary-auth (click)="dialogRef.close(1)">Done</button>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="dialog-header" *ngIf="data.type == 7">
  <h2 mat-dialog-title class="py-4 px-3 d-flex justify-content-between align-items-center">
    <!-- <span class="px-3">Cancel Contract </span> -->
    <span class="px-3" *ngIf="cancel_contract_step == 1">Cancel Contract </span>
    <span class="px-3" *ngIf="cancel_contract_step == 2">Choose Payment Method </span>
    <span class="px-3" *ngIf="cancel_contract_step == 3">Confirmation of Contract Cancelation </span>
    <span class="px-3" *ngIf="cancel_contract_step == 4 && payment_result.is_error == 0">{{payment_option.paymentType &&
      selected_option == 5 ? 'Transaction Initiated' : 'Contract Canceled Successfully'}}
    </span>
    <span class="px-3" *ngIf="cancel_contract_step == 4 && payment_result.is_error == 1">Payment Failed </span>
    <span class="px-3" *ngIf="cancel_contract_step == 5">Email/Text Sent Successfully </span>
    <mat-icon (click)="(cancel_contract_step >= 4 && payment_result.is_error == 0)?dialogRef.close(1):dialogRef.close()"
      class="close text-dark" style="position: relative !important; transform: none !important;">close</mat-icon>
  </h2>
  <div mat-dialog-content class="pt-0">
    <!-- step 1-->
    <div *ngIf="cancel_contract_step == 1">
      <div class="full-payment-details-left text-center">
        <label style="font-size: 14px; line-height: 24px; color: #313A44;">Service Amount</label>
        <h1 style="font-weight: 800;" class="notranslate">{{contractData.treatment_amount | currency}}</h1>
        <label class="px-3 py-2 financed-label mt-2">
          Payment Plan Amount:
          <span class="notranslate">{{contractData.financed_amount | currency}}</span>
        </label>
        <div class="row mt-4" style="margin: 0 30px; color: #313A44;">
          <div class="col-6" style="border-right: 1px solid #c6d0d9; border-bottom: 1px solid #c6d0d9">
            Recurring Amount
            <h4 *ngIf="showTransactionWord" class="financing-values">
              <span
                *ngIf="getTransactionFee(contractData,contractData.recurring_amount) && contractData.credit_reporting_status > 0 && contractData.credit_reporting_fee > 0">(</span>
              <span class="notranslate">{{contractData.recurring_amount|currency}}</span>
              <span class="notranslate" *ngIf="getTransactionFee(contractData,contractData.recurring_amount)"> +
                {{getTransactionFee(contractData,contractData.recurring_amount)}}<span
                  *ngIf="contractData.credit_reporting_status > 0 && contractData.credit_reporting_fee > 0">) +
                  ${{contractData.credit_reporting_fee}}</span></span>
            </h4>
            <h4 *ngIf="!showTransactionWord" class="financing-values">
              <span class="notranslate" *ngIf="getTransactionFee(contractData,contractData.recurring_amount)">
                {{( contractData.recurring_amount +
                mainService.getCalculatedTransactionFee(contractData,contractData.recurring_amount) +
                ((contractData.credit_reporting_status > 0 && contractData.credit_reporting_fee > 0) ?
                contractData.credit_reporting_fee : 0)) | currency}}
              </span>
            </h4>
          </div>
          <div class="col-6" style="border-bottom: 1px solid #c6d0d9;">
            {{(contractData.is_arv2 && contractData.downpayment_amount) > 0 ? 'Partial Payment' : 'Downpayment'}}
            <h4 class="financing-values notranslate">{{contractData.downpayment_amount | currency}}</h4>
          </div>
        </div>
        <div class="row" style="margin: 0 30px; color: #313A44;">
          <div class="col-6 pt-3" style="border-right: 1px solid #c6d0d9;">
            Interest Rate
            <h4 class="financing-values notranslate">
              {{contractData.interest_rate_to_show || contractData.interest_rate}}%
              <sup>
                {{!contractData.interest_rate_to_show || (contractData.interest_rate ==
                contractData.interest_rate_to_show) ? (contractData.interest_rate>0?'C':'') : 'F'}}
              </sup>
            </h4>
          </div>
          <div class="col-6 pt-3">
            Total Payments
            <h4 class="financing-values">{{contractData.number_of_payments}}</h4>
          </div>
        </div>
      </div>
      <div class="mt-2 row mx-0 p-2" style="background: #DEE8F1;border-radius: 6px;">
        <div class="col">Remaining Payments</div>
        <div class="col text-end">{{contractData.remaining_payments}}</div>
      </div>
    </div>
    <!-- step 2-->
    <div *ngIf="cancel_contract_step == 2">
      <button (click)="backCancelContractStep()" class="mb-4 bck-btn">
        <img src="assets/img/svg/bckArrow.svg">
        Back
      </button>
      <label class=" d-flex m-0 px-2 py-2 text-bold"
        style="background-color: #FFF4E9;font-weight: 700;border-radius: 6px;">

        <span class="pay-text" style="color: #05141F;">Contract Cancelation Fee: </span>
        <span class="pay-text" style="color: #ed9b49;">${{contractData.cancel_contract_fee}}</span>

        <!-- Contract Cancelation Fee: <strong style="color: #ed9b49;"> $30.00</strong> -->
      </label>
      <div class="row m-0">
        <h5 class="mt-3 mb-4 d-flex align-items-center"
          style="font-weight: 700;font-size: 14px;line-height: 24px; color: #05141F;">
          <span class="me-1"> Who will be responsible for the payment? </span>
          <span [tooltip]="'Usually, the party requesting to  cancel the contract will be responsible for the payment.'"
            [customClass]="'dark-theme-tooltip'" [placementModal]="'1'" [placement]="'right'">
            <img src="assets\img\svg\tooltip_icon.svg" alt="" style="width: 20px;">
          </span>
        </h5>
        <div class="row w-100">
          <div class="col-xs-6 col-6 p-0 ps-3">
            <input id="paymentType" type="radio" name="a" [(ngModel)]="payment_option.paymentType" [value]="1">
            <label for="paymentType">
              <span tappable (click)="payment_option.paymentType = 1">Customer</span>
            </label>
          </div>
          <div class="col-xs-6 col-6 p-0" *ngIf="contractData.contract_type != 3">
            <input id="paymentType1" type="radio" name="a" [(ngModel)]="payment_option.paymentType" [value]="2">
            <label for="paymentType1">
              <span tappable (click)="payment_option.paymentType = 2">Business</span>
            </label>
          </div>
          <div class="col-xs-6 col-6 p-0"
            *ngIf="contractData.contract_type == 3 && doctorSettings.can_cancel_ihf_contract == 1">
            <input id="paymentType1" type="radio" name="a" [(ngModel)]="payment_option.paymentType" [value]="2">
            <label for="paymentType1">
              <span tappable (click)="payment_option.paymentType = 2">Business</span>
            </label>
          </div>
        </div>
        <h5 class="mt-4 mb-4" style="font-weight: 700;font-size: 14px;line-height: 24px; color: #05141F;"
          *ngIf="payment_option.paymentType">
          Select Payment Method
        </h5>
        <div class="col-lg-12 col-xs-12" *ngIf="payment_option.paymentType == 1">
          <div class="row">
            <div class="col-md-6 text-start p-0" style="display:flex;align-items:center;"
              *ngIf="changePaymentDateCardList && changePaymentDateCardList.length > 0">
              <input id="selected_option1" type="radio" name="b" [(ngModel)]="selected_option" [value]="1"
                class="pull-left">
              <label for="selected_option1">
                <span tappable (click)="selected_option = 1">Customer’s existing
                  card(s)</span>
              </label>
            </div>
            <div class="col-md-6 text-start p-0" style="display:flex;align-items:center;">
              <input id="selected_option2" type="radio" name="b" [(ngModel)]="selected_option" [value]="4"
                class="pull-left" (change)="mountCard(false)">
              <label for="selected_option2">
                <span tappable (click)="selected_option = 4; mountCard(false);">Pay with a new card</span>
              </label>
            </div>
            <div class="col-md-6 text-start p-0 mt-1" style="display:flex;align-items:center;"
              *ngIf="contractData.plaidAccount && contractData.plaidAccount[0] && contractData.plaidAccount[0].last4 && contractData.plaidAccount[0].status == 'verified'">
              <input id="selected_option3" type="radio" name="b" [(ngModel)]="selected_option" [value]="5"
                class="pull-left">
              <label for="selected_option3">
                <span tappable (click)="selected_option = 5">Customer Bank Account
                  ({{contractData.plaidAccount[0].last4}})</span>
              </label>
            </div>
          </div>
        </div>

        <!-- Card List -->
        <div class="col-lg-12 col-xs-12 mt-4 card-list customer-card-list mb-1"
          *ngIf="payment_option.paymentType == 1 && selected_option == 1">

          <div class="card_list" *ngIf="changePaymentDateCardList.length > 0">
            <ng-container *ngFor="let card of changePaymentDateCardList; let i=index">
              <div class="pointer  py-1" (click)="selPaymentCard(card);">
                <label [for]="i" class="d-flex pointer align-items-center w-100 justify-content-between mb-0"
                  style="height: 35px;">
                  <p class="d-flex mt-3"> <img style="width:24px;" [src]="getCardBrandImage(card)"
                      *ngIf="['mastercard', 'discover', 'jcb', 'visa', 'american express', 'unionpay', 'diners club', 'diners', 'amex'].includes(card.brand.toLowerCase()); else no_card">
                    <ng-template #no_card>
                      <img style="width:24px;" [src]="'assets/img/svg/card-type/no_card.svg'">
                    </ng-template>&nbsp;&nbsp;XXXX XXXX XXXX {{card.last4}}
                  </p>
                  <p *ngIf="card.source_id== contractData.source_id" class="text-success-custom pt-4"
                    style="font-size:12px;display: flex; flex-direction:row-reverse;">
                    <mat-icon class="check">check_circle_outline</mat-icon>Default
                  </p>
                  <span style="margin-bottom: 1.9rem;">
                    <input type="radio" [id]="card.source_id"
                      [checked]="card.source_id == changePaymentDateCard.source_id" name="doctorPaymentCard"
                      [value]="card.source_id" class="pointer">
                    <label for="card.source_id"></label>
                  </span>
                </label>
              </div>
            </ng-container>
          </div>

          <!-- <div *ngFor="let card of changePaymentDateCardList; let i=index" style="cursor:pointer"
            class="border rounded p-2 mb-2" (click)="selPaymentCard(card);">
            <div class="d-flex align-item-center">
              <div class="me-2">
                <input [id]="card.source_id" type="radio"
                  [checked]="card.source_id == changePaymentDateCard.source_id" [value]="card.source_id">
                <label for="card.source_id" class="mb-0 d-flex">
                  <span>
                    <mat-icon class="cred-card">credit_card</mat-icon>
                  </span>
                  <span class="card-num">&nbsp;&nbsp;XXXX-XXXX-XXXX-{{card.last4}}</span>
                  <p *ngIf="card.last_error" class="m-0 ps-3" style="font-size:12px;"
                    [ngClass]="{'text-danger-custom':card.source_id!=contractData.source_id}">
                    {{card.last_error}}</p>
                  <p *ngIf="card.source_id==contractData.source_id" class="m-0 text-success-custom ps-3"
                    style="font-size:12px;display: flex; flex-direction:row-reverse;">
                    <mat-icon class="check">check_circle_outline</mat-icon>Default
                  </p>
                </label>
              </div>
            </div>
          </div> -->
        </div>

        <div class="col-lg-12 col-xs-12" *ngIf="payment_option.paymentType == 2">
          <div class="row mb-1">
            <div class="col-md-7 text-start p-0" style="display:flex;align-items:center;"
              *ngIf="this.cancelContractConnectedAccountAllow == 1 && (contractData.stripe_account_id || contractData.contract_type != 5)">
              <input id="selected_option4" type="radio" name="business" [(ngModel)]="selected_option" [value]="3"
                class="pull-left">
              <label for="selected_option4">
                <span tappable (click)="selected_option = 3">Pay from your <span class="notranslate">Denefits</span>
                  account</span>
              </label>
            </div>

            <div class="col-md-5 text-start p-0" style="display:flex;align-items:center;">
              <input id="selected_option5" type="radio" name="business" [(ngModel)]="selected_option" [value]="2"
                class="pull-left" (change)="mountCard(true)">
              <label for="selected_option5">
                <span tappable (click)="selected_option = 2; mountCard(true);">Pay with a new card</span>
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="d-block" *ngIf="cancel_contract_step == 2 && payment_option.paymentType == 2 && selected_option == 3">
      <ul style="list-style: disc;" class="px-3">
        <li style="font-size: 12px;font-weight: 400;line-height: 20px;color: #596775">Use this option, if you want to
          pay using
          your Business connected bank account.</li>
      </ul>
    </div> -->
    <div class="d-block" *ngIf="cancel_contract_step == 2 && payment_option.paymentType == 1 && selected_option == 1">
      <ul style="list-style: disc;" class="px-3">
        <li style="font-size: 12px;font-weight: 400;line-height: 20px;color: #596775">Use this option, if you want to
          pay using
          the customer’s existing card(s) for this contract.</li>
      </ul>
    </div>
    <div class="d-block" *ngIf="cancel_contract_step == 2 && payment_option.paymentType == 1 && selected_option == 5">
      <ul style="list-style: disc;" class="px-3">
        <li style="font-size: 12px;font-weight: 400;line-height: 20px;color: #596775">Use this option, if you want to
          pay using
          the customer’s connected bank account for this contract.</li>
      </ul>
    </div>
    <div class="card-hidden" [ngClass]="{'show-card mt-2':cancel_contract_step == 2 &&((payment_option.paymentType == 2 && selected_option == 2) ||
        (payment_option.paymentType == 1 && selected_option == 4))}">
      <div class="row m-0">
        <div class="col-12 p-0 mb-3">
          <div class="form-group h-100">
            <div class="custom-form mt-3 px-2 border border-10">
              <div class="form-group h-100">
                <input class="input_field px-2 pt-3" [(ngModel)]="payment_option.cardName" autofocus
                  name="cardholder_name" #cardholder_name="ngModel" trim maxlength="100" minlength="2" required>
                <label for="text" class="label-name">
                  <span class="content-name f-c-p-3">
                    Card Holder Name
                  </span>
                </label>
              </div>
            </div>
            <p *ngIf="cardholder_name.invalid" class="mat-error m-0">
              Please enter a card holder name
            </p>
          </div>

        </div>
        <div class="col-12 p-0">
          <div class="stripe-card border_8 w-100 py-2 mb-0" style="height: 54px !important;align-content: center;"
            id="payment-element"></div>
        </div>
      </div>
    </div>
    <div class="d-block py-2" *ngIf="cancel_contract_step == 2 && payment_option.paymentType == 2">
      <ul style="list-style: disc;" class="px-3">
        <li *ngIf="selected_option == 3" style="font-size: 12px;font-weight: 400;line-height: 20px;color: #596775">Use
          this option, if you want to pay using your Business connected bank account.</li>
        <li *ngIf="selected_option == 2" style="font-size: 12px;font-weight: 400;line-height: 20px;color: #596775">Use
          this option, if you want to pay using the business new card.</li>
        <li *ngIf="selected_option == 2" style="font-size: 12px;font-weight: 400;line-height: 20px;color: #596775">We
          will not save the card for this contract.
        </li>
      </ul>
    </div>

    <!-- step 3-->
    <div *ngIf="cancel_contract_step == 3" class="px-0">
      <button (click)="backCancelContractStep()" class="mb-4 bck-btn">
        <img src="assets/img/svg/bckArrow.svg">
        Back
      </button>
      <div class="row m-0" style="background: #DEE8F1;border-radius: 6px;">
        <div class="bg-faint row m-0 w-100" style="border-bottom: 0.5px solid #c6d6e5;">
          <div class="col-6" style="border-right: 0.5px solid #c6d6e5;">
            <label>Contract Id</label>
            <h4>{{contractData.contract_code}}</h4>
          </div>
          <div class="col-6">
            <label>Total Payable Today</label>
            <h4 class="notranslate">${{skipCancellationFee ? 0 : contractData.cancel_contract_fee}}</h4>
          </div>
        </div>
        <div class="bg-faint row m-0 w-100" *ngIf="!skipCancellationFee">
          <div class="col-6" style="border-right: 0.5px solid #c6d6e5;">
            <label>Payable by</label>
            <h4>
              <span *ngIf="payment_option.paymentType == 1">
                <span *ngIf="selected_option == 1 || selected_option == 4 || selected_option == 5">
                  {{contractData.patient_first_name + ' ' + contractData.patient_last_name}}
                </span>
              </span>
              <span *ngIf="payment_option.paymentType == 2">
                <span *ngIf="selected_option == 3 || selected_option == 2 || selected_option == 5">
                  {{contractData.practice_name || contractData.doctor_first_name + ' ' +
                  contractData.doctor_last_name}}
                </span>
              </span>
            </h4>
          </div>
          <div class="col-6">
            <label>Payment Method</label>
            <h4>
              <span class="d-flex" *ngIf="selected_option == 1">
                <img src="assets/img/svg/pay.svg" class="me-2" />
                {{changePaymentDateCard.last4 ? changePaymentDateCard.last4 :
                contractData.default_card_last4}}
              </span>
              <span class="d-flex" *ngIf="selected_option == 5">
                <mat-icon class="me-2">account_balance</mat-icon>
                {{contractData.plaidAccount[0].last4}}
              </span>
              <span class="d-flex" *ngIf="selected_option == 4">
                <img src="assets/img/svg/pay.svg" class="me-2" />
                {{payment_stripe_data.card.last4}}
              </span>
              <span class="d-flex" *ngIf="selected_option == 3">
                <span class="notranslate">Denefits</span> account
              </span>
              <span class="d-flex" *ngIf="selected_option == 2">
                <img src="assets/img/svg/pay.svg" class="me-2" />
                {{payment_stripe_data.card.last4}}
              </span>
            </h4>
          </div>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-12 custom-form">
          <textarea class="p-1 pt-2 w-100" placeholder="Reason" [(ngModel)]="changeReason"
            style="resize: none;"></textarea>
        </div>
        <div class="col-xs-12 mt-4 px-3">
          <input type="checkbox" class="pointer" name="terms" id="terms_1" required style="margin-top: 8px;"
            [(ngModel)]="payment_option.terms">
          <label for="terms_1">
            <span>
              By clicking on
              this box, you agree with our <a class="text-primary-custom" [routerLink]="['/terms/contracts-terms']"
                target="_blank">Terms &
                Conditions</a>.
              This acceptance will have the same legal effect as a handwritten signature. You agree that all
              information in this contract is true and has been fully disclosed and agreed upon between you and your
              customer prior to making this contract adjustment. You are responsible for all of the changes to this
              contract. In no event will <span class="notranslate">Denefits</span> be liable for any user errors. ANY
              ATTEMPTED MISUSE OR FRAUD MAY
              RESULT IN SUSPENSION OF ALL Protected PAYMENTS.
            </span>
          </label>
        </div>
      </div>
    </div>

    <!--step 4-->
    <div *ngIf="cancel_contract_step == 4">
      <div *ngIf="payment_result.is_error == 0">
        <div class="text-center my-4">
          <img src="assets/img/png/check_signup.png" width="90px" alt="">
          <h3 class="text-bold my-4">{{selected_option !== 5 ? 'Contract Canceled Successfully' : "Thank you. We have
            initiated your
            transaction"}}</h3>
        </div>
        <span *ngIf="selected_option !== 5 && contractData.dnd == 0">
          <p>Send the Canceled Contract details to your customer:</p>
        </span>
        <span *ngIf="selected_option !== 5 && contractData.dnd == 0">
          <div class="form-cont">
            <div class="custom-form  flex-grow-1 me-md-3 form-group mb-3">
              <input type="text" class="input_field px-3 pt-3" required [(ngModel)]="send_email" name="email"
                #email="ngModel" autofocus />
              <label for="text" class="label-name">
                <span class="content-name f-c-p-3">
                  Email Address
                </span>
              </label>
            </div>
            <div class="custom-form flex-grow-1 me-md-3 form-group">
              <input type="text" class="input_field px-3 pt-3" required [(ngModel)]="send_phone" name="phone"
                #phone="ngModel" autofocus [mask]="mask" />
              <label for="text" class="label-name">
                <span class="content-name f-c-p-3">
                  Text Message
                </span>
              </label>
            </div>
          </div>
        </span>
      </div>
      <div *ngIf="payment_result.is_error == 1">
        <div class="text-center">
          <img src="assets/img/svg/fail-icon.svg" width="90px" alt="" class="mb-3">
          <h3 class="m-b-20">Payment Failed!</h3>
          <p>{{payment_result.override_text}}</p>

          <!--Buttons in Error-->
          <div class="col-xs-12 col-sm-12 text-center">
            <button mat-raised-button class="px-4 sup-btn" (click)="gotoNextStepCancelContract()">
              Retry
            </button>
            <button class="ms-3 px-4 sup-btn" mat-raised-button
              (click)="cancel_contract_step = 2; payment_result = {};">
              Change Card
            </button>
          </div>
          <br>
          <div class="col-xs-12 col-sm-12 text-center">
            <span class="f-c-p-8 fw-600 me-5">Need Support?</span>
            <br>
            <button mat-raised-button class="mt-4 px-4 sup-btn" (click)="goTo('app/help/support')">
              Write to us
            </button>
            <button mat-raised-button class="mt-4 ms-3 px-4 sup-btn" (click)="goTo('app/help/support')">
              Have us call you back
            </button>
            <button mat-raised-button class="me-5 mt-3 px-4 sup-btn" (click)="goTo('app/help/support')">
              Chat with us
            </button>
          </div>
          <br>
        </div>
      </div>
    </div>
  </div>
  <!--Step 5-->
  <div *ngIf="cancel_contract_step == 5">
    <div class="text-center">
      <img src="assets/img/svg/sent.svg" alt="Contract sent successfully">
      <p class="h4">Email/Text Sent Successfully</p>
    </div>
  </div>
  <!--all buttons -->
  <div class="d-flex justify-content-between px-4 mx-2" mat-dialog-actions>
    <div *ngIf="cancel_contract_step < 4">
      <button class="px-4 py-1 sup-btn" mat-raised-button autocomplete="off" (click)="gotoNextStepCancelContract()"
        style="height: 45.9px !important;" [disabled]="(cancel_contract_step == 2 && (!payment_option.paymentType || !selected_option)) ||
      (cancel_contract_step == 3 && (payment_option && !payment_option.terms))">
        <span *ngIf="cancel_contract_step == 1">Proceed to Cancel</span>
        <span *ngIf="cancel_contract_step == 2">Continue</span>
        <span *ngIf="cancel_contract_step == 3">{{skipCancellationFee ? 'Continue' : 'Pay Now'}}</span></button>
    </div>
    <div *ngIf="cancel_contract_step == 4">
      <button mat-raised-button class="sup-btn"
        *ngIf="contractData.dnd == 0 && !(payment_option.paymentType && selected_option == 5) && payment_result && payment_result.is_error == 0"
        (click)="sendContractPdf('cancel_contract_step')">Send</button>
    </div>
  </div>
</div>

<div class="dialog-header" *ngIf="data.type == 9">
  <h2 mat-dialog-title class="py-4 px-3 d-flex justify-content-between align-items-center">
    <!-- <span class="px-3">Change Payment Date</span> -->
    <span class="px-3" *ngIf="edit_recurring_step == 1">Change Payment Date</span>
    <span class="px-3" *ngIf="edit_recurring_step == 2">Choose Payment Method </span>
    <span class="px-3" *ngIf="edit_recurring_step == 3">Confirmation of Change Payment Date </span>
    <span class="px-3" *ngIf="edit_recurring_step == 4 && payment_result.is_error == 0">{{selected_option !== 5 ?
      'Payment Date Changed
      Successfully' : 'Transaction Initiated'}}</span>
    <span class="px-3" *ngIf="edit_recurring_step == 4 && payment_result.is_error == 1">Payment Failed </span>
    <span class="px-3" *ngIf="edit_recurring_step == 5">Email/Text Sent Successfully </span>
    <span class="me-2">
      <mat-icon (click)="(edit_recurring_step == 4 || edit_recurring_step == 5) ? confirmAction() : dialogRef.close()"
        class="close text-dark" style="position: relative !important; transform: none !important;">close</mat-icon>
    </span>
  </h2>
  <div mat-dialog-content class="pt-0 form-cont">
    <div *ngIf="edit_recurring_step == 1">
      <label class="px-2 py-2 text-bold" style="background-color: #FFF4E9;font-weight: 700;border-radius: 6px;">
        <span class="pay-text" style="color: #05141F;">Next Payment Due: </span>
        <span class="pay-text notranslate" style="color: #ed9b49;">{{contractData.next_payment_date | date:"MM/dd/yyyy":
          '+0000'}}</span>
      </label>
      <div>
        <h5 class="mt-3 mb-2" style="font-weight: 700;font-size: 16px;color: #0E2535;">When would you like the next
          payment to be made? </h5>
        <div class="text-start date_padding" [ngClass]="{date_padding: showDeferredNote}">
          <mat-form-field appearance="outline" class="col-12 p-0 date-picker rounded-0 mat-short-height notranslate">
            <input matInput [matDatepicker]="picker" placeholder="Choose a date" (click)="picker.open()" readonly
              class="whiteBg" [(ngModel)]="edit_recurring_data.payment_date" [max]="edit_recurring_data.maxDate"
              (ngModelChange)="updateNote($event)" [min]="edit_recurring_data.minDate" required>
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker disabled="false" startView="month"></mat-datepicker>
          </mat-form-field>
        </div>
        <label
          *ngIf="contractData.contract_type == 6 && contractData.is_contract_deferred == 1 && showDeferredBenefitsNote && !edit_recurring_data.showLabel"
          class="px-2 py-2 text-bold wraning--wrapper" style="background-color: #fdeced;border-radius: 6px;">
          <span class="pay-text" style="color: #05141F; font-weight: 600;font-size: 16px;"><img
              src="assets/img/svg/alert.svg">If you change the payment date, your deferred duration will remain
            unchanged. Your Deferred duration will end on <span class="date">{{contractData.deferred_end_date |
              date:"MM/dd/yyyy":
              timezone}}</span></span>
        </label>
        <p *ngIf="(contractData.contract_type == 6 && contractData.is_contract_deferred == 1 && showDeferredNote) || edit_recurring_data.showLabel"
          style="margin: 0.25rem 0 0 0.2rem; padding-bottom: 1.34375em; margin-bottom: 0.25rem; font-size: 14px; font-weight: 600; color: #6d6d6d;">
          Note: Deferred Benefits will be removed from the contract.</p>
      </div>
    </div>
    <!-- step 2-->
    <div *ngIf="edit_recurring_step == 2">
      <button (click)="backRecurringDateStep()" class="mb-4 bck-btn">
        <img src="assets/img/svg/bckArrow.svg">
        Back
      </button>
      <div class="row m-0 mb-4" style="background: #DEE8F1;border-radius: 6px;">
        <div class="bg-faint row m-0 w-100"
          [ngStyle]="{'border-bottom': contractData.missing_payments > 0 ? '0.5px solid #c6d6e5' : ''}">
          <div class="col-6" style="border-right: 0.5px solid #c6d6e5;">
            <label>Total Due Today</label>
            <h4 class="notranslate">${{((contractData.late_fee * contractData.missing_payments)+
              edit_recurring_data.edit_recurring_amount)
              |
              number : '1.2-2'}}</h4>
          </div>
          <div class="col-6">
            <label>Payment Change Fee
              <ng-template #paymentCharge>
                <div>
                  <p>The <span class="notranslate">Denefits</span> system automatically calculates the Payment Change
                    Fee depending on the
                    number of days and
                    the recurring payment amount. For more information.</p>
                  <a href="javascript:void(0);" (click)="paymentChargeFee()" class="text-decoration-none">For
                    more information <svg width="22" height="16" viewBox="0 0 22 16" fill="none"
                      xmlns="http://www.w3.org/2000/svg">
                      <path d="M13 8L9.5 10V6L13 8Z" fill="white" stroke="white" stroke-width="1.5"
                        stroke-linecap="round" stroke-linejoin="round" />
                      <path
                        d="M1 8.70739V7.29239C1 4.39739 1 2.94939 1.905 2.01839C2.811 1.08639 4.237 1.04639 7.088 0.965391C8.438 0.927391 9.818 0.900391 11 0.900391C12.181 0.900391 13.561 0.927391 14.912 0.965391C17.763 1.04639 19.189 1.08639 20.094 2.01839C21 2.94939 21 4.39839 21 7.29239V8.70739C21 11.6034 21 13.0504 20.095 13.9824C19.189 14.9134 17.764 14.9544 14.912 15.0344C13.562 15.0734 12.182 15.1004 11 15.1004C9.819 15.1004 8.439 15.0734 7.088 15.0344C4.237 14.9544 2.811 14.9144 1.905 13.9824C1 13.0504 1 11.6024 1 8.70839V8.70739Z"
                        stroke="white" stroke-width="1.5" />
                    </svg>
                  </a>
                </div>
              </ng-template>
            </label>
            <h4 class="notranslate">
              {{edit_recurring_data.edit_recurring_amount?'$'+(edit_recurring_data.edit_recurring_amount
              |
              number : '1.2-2'):'$0.00'}}</h4>
          </div>
        </div>
        <div class="bg-faint row m-0 w-100" *ngIf="contractData.missing_payments>0">
          <div class="col-12">
            <label>Late fee</label>
            <h4>${{contractData.late_fee}} X {{contractData.missing_payments}}months</h4>
          </div>
        </div>
      </div>

      <div class="row m-0">
        <h5 class="mt-3 mb-4 d-flex align-items-center"
          style="font-weight: 700;font-size: 14px;line-height: 24px; color: #05141F;">
          <span class="me-1"> Who will be responsible for the payment?</span>
          <span [tooltip]="'Usually, the party requesting the payment date change will be responsible for the payment.'"
            [placementModal]="'1'" [customClass]="'dark-theme-tooltip'" [placement]="'right'">
            <img src="assets\img\svg\tooltip_icon.svg" alt="" style="width: 20px;">
          </span>
        </h5>
        <div class="row w-100">
          <div class="col-xs-6 col-6 p-0 ps-3">
            <input id="paymentType" type="radio" name="a" [(ngModel)]="payment_option.paymentType" [value]="1">
            <label for="paymentType">
              <span tappable (click)="payment_option.paymentType = 1">Customer</span>
            </label>
          </div>
          <div class="col-xs-6 col-6 p-0" *ngIf="contractData.contract_type != 3">
            <input id="paymentType1" type="radio" name="a" [(ngModel)]="payment_option.paymentType" [value]="2">
            <label for="paymentType1">
              <span tappable (click)="payment_option.paymentType = 2">Business</span>
            </label>
          </div>
        </div>
        <h5 class="mt-4 mb-4" style="font-weight: 700;font-size: 14px;line-height: 24px; color: #05141F;"
          *ngIf="payment_option.paymentType">
          Select Payment Method
        </h5>
        <div class="col-lg-12 col-xs-12" *ngIf="payment_option.paymentType == 1">
          <div class="row">
            <div class="col-md-6 text-start p-0" style="display:flex;align-items:center;"
              *ngIf="changePaymentDateCardList && changePaymentDateCardList.length > 0">
              <input id="selected_option1" type="radio" name="b" [(ngModel)]="selected_option" [value]="1"
                class="pull-left">
              <label for="selected_option1">
                <span tappable (click)="selected_option = 1">Customer’s existing
                  card(s)</span>
              </label>
            </div>
            <div class="col-md-6 text-start p-0" style="display:flex;align-items:center;">
              <input id="selected_option2" type="radio" name="b" [(ngModel)]="selected_option" [value]="4"
                class="pull-left" (change)="mountCard(false)">
              <label for="selected_option2">
                <span tappable (click)="selected_option = 4; mountCard(false);">Pay with a new card</span>
              </label>
            </div>
            <div class="col-md-6 text-start p-0 mt-1" style="display:flex;align-items:center;"
              *ngIf="contractData.plaidAccount && contractData.plaidAccount[0] && contractData.plaidAccount[0].last4 && contractData.plaidAccount[0].status == 'verified'">
              <input id="selected_option3" type="radio" name="b" [(ngModel)]="selected_option" [value]="5"
                class="pull-left">
              <label for="selected_option3">
                <span tappable (click)="selected_option = 5">Customer Bank Account
                  ({{contractData.plaidAccount[0].last4}})</span>
              </label>
            </div>
          </div>
        </div>

        <!-- Card List -->
        <div class="col-lg-12 col-xs-12 mt-4 card-list customer-card-list mb-1"
          *ngIf="payment_option.paymentType == 1 && selected_option == 1">
          <div class="card_list" *ngIf="changePaymentDateCardList.length > 0">
            <ng-container *ngFor="let card of changePaymentDateCardList; let i=index">
              <div class="pointer  py-1" (click)="selPaymentCard(card);">
                <label [for]="i" class="d-flex pointer align-items-center w-100 justify-content-between mb-0"
                  style="height: 35px;">
                  <p class="d-flex mt-3"> <img style="width:24px;" [src]="getCardBrandImage(card)"
                      *ngIf="['mastercard', 'discover', 'jcb', 'visa', 'american express', 'unionpay', 'diners club', 'diners', 'amex'].includes(card.brand.toLowerCase()); else no_card">
                    <ng-template #no_card>
                      <img style="width:24px;" [src]="'assets/img/svg/card-type/no_card.svg'">
                    </ng-template>&nbsp;&nbsp;XXXX XXXX XXXX {{card.last4}}
                  </p>
                  <p *ngIf="card.source_id==contractData.source_id" class="text-success-custom pt-4"
                    style="font-size:12px;display: flex; flex-direction:row-reverse;">
                    <mat-icon class="check">check_circle_outline</mat-icon>Default
                  </p>
                  <span style="margin-bottom: 1.9rem;">
                    <input type="radio" [id]="card.source_id"
                      [checked]="card.source_id == changePaymentDateCard.source_id" name="doctorPaymentCard"
                      [value]="card.source_id" class="pointer">
                    <label for="card.source_id"></label>
                  </span>
                </label>
              </div>
            </ng-container>
          </div>

          <!-- <div class="d-flex align-item-center">
              <div class="me-2">
                <input [id]="card.source_id" type="radio"
                  [checked]="card.source_id == changePaymentDateCard.source_id" [value]="card.source_id">
                <label for="card.source_id" class="mb-0 d-flex">
                  <span>
                    <mat-icon class="cred-card">credit_card</mat-icon>
                  </span>
                  <span class="card-num">&nbsp;&nbsp;XXXX-XXXX-XXXX-{{card.last4}}</span>
                  <p *ngIf="card.last_error" class="m-0 ps-3" style="font-size:12px;"
                    [ngClass]="{'text-danger-custom':card.source_id!=contractData.source_id}">
                    {{card.last_error}}</p>
                  <p *ngIf="card.source_id==contractData.source_id" class="m-0 text-success-custom ps-3"
                    style="font-size:12px;display: flex; flex-direction:row-reverse;">
                    <mat-icon class="check">check_circle_outline</mat-icon>Default
                  </p>
                </label>
              </div>
            </div> -->
          <!-- </div> -->
        </div>

        <div class="col-lg-12 col-xs-12" *ngIf="payment_option.paymentType == 2">
          <div class="row mb-1">
            <div *ngIf="contractData.stripe_account_id || contractData.contract_type != 5"
              class="col-md-7 text-start p-0" style="display:flex;align-items:center;">
              <input id="selected_option4" type="radio" name="business" [(ngModel)]="selected_option" [value]="3"
                class="pull-left">
              <label for="selected_option4">
                <span tappable (click)="selected_option = 3">Pay from your <span class="notranslate">Denefits</span>
                  account</span>
              </label>
            </div>
            <div class="col-md-5 text-start p-0" style="display:flex;align-items:center;">
              <input id="selected_option5" type="radio" name="business" [(ngModel)]="selected_option" [value]="2"
                class="pull-left" (change)="mountCard(true)">
              <label for="selected_option5">
                <span tappable (click)="selected_option = 2; mountCard(true);">Pay with a new card</span>
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card-hidden" [ngClass]="{'show-card':edit_recurring_step == 2 &&((payment_option.paymentType == 2 && selected_option == 2) ||
      (payment_option.paymentType == 1 && selected_option == 4))}">
      <div class="row m-0">
        <div class="col-12 p-0 mb-3">

          <div class="form-group h-100">
            <div class="custom-form mt-3 px-2 border border-10">
              <div class="form-group h-100">
                <input class="input_field px-2 pt-3" [(ngModel)]="payment_option.cardName" autofocus
                  name="cardholder_name" #cardholder_name="ngModel" trim maxlength="100" minlength="2" required>
                <label for="text" class="label-name">
                  <span class="content-name f-c-p-3">
                    Card Holder Name
                  </span>
                </label>
              </div>
            </div>
            <p *ngIf="cardholder_name.touched && cardholder_name.invalid" class="mat-error m-0">Please enter a
              cardholder
              name</p>
          </div>

          <!-- <div class="w-100 ">
            <label class="form-label d-block ">Card Holder Name</label>
            <input [(ngModel)]="payment_option.cardName" name="cardholder_name" #cardholder_name="ngModel" matInput
              placeholder="Enter cardholder name" trim  maxlength="100" minlength="2" class="form-input w-100"
              style="min-height: 56px !important;">
            <p *ngIf="cardholder_name.invalid" class="mat-error">Please enter a cardholder name</p>
          </div> -->
        </div>
        <div class="col-12 p-0">
          <!-- <label class="form-label d-block ">Card details</label> -->
          <div class="stripe-card border_8 w-100 py-2 mb-0" style="height: 54px !important;align-content: center;"
            id="payment-element"></div>
        </div>
      </div>
    </div>
    <div class="d-block py-2" *ngIf=" edit_recurring_step == 2 && payment_option.paymentType == 2">
      <ul style="list-style: disc;" class="px-3">
        <li *ngIf="selected_option == 3" style="font-size: 12px;font-weight: 400;line-height: 20px;color: #596775">Use
          this option, if you want to pay using your Business connected bank account.</li>
        <li *ngIf="selected_option == 2" style="font-size: 12px;font-weight: 400;line-height: 20px;color: #596775">Use
          this option, if you want to pay using the business new card.</li>
        <li *ngIf="selected_option == 2" style="font-size: 12px;font-weight: 400;line-height: 20px;color: #596775">We
          will not save the card for this contract.
        </li>
      </ul>
    </div>
    <div class="d-block  py-2" *ngIf=" edit_recurring_step == 2 && payment_option.paymentType == 1">
      <ul style="list-style: disc;" class="px-3">
        <li *ngIf="selected_option == 1" style="font-size: 12px;font-weight: 400;line-height: 20px;color: #596775">Use
          this option, if you want to pay using the customer’s existing card(s) for this contract.</li>
        <li *ngIf="selected_option == 4" style="font-size: 12px;font-weight: 400;line-height: 20px;color: #596775">Use
          this option, if you want to pay using the customer’s new card.</li>
        <li *ngIf="selected_option == 4" style="font-size: 12px;font-weight: 400;line-height: 20px;color: #596775">
          Newly
          added card will not be used as default payment method for future payments for this contract.</li>
        <li *ngIf="selected_option == 4" style="font-size: 12px;font-weight: 400;line-height: 20px;color: #596775"> We
          will not save the card for this contract.</li>
        <li *ngIf="selected_option == 5" style="font-size: 12px;font-weight: 400;line-height: 20px;color: #596775">Use
          this
          option, if you want to pay using the
          customer’s bank account for this contract.</li>
      </ul>
    </div>
    <!-- step 3-->
    <div *ngIf="edit_recurring_step == 3">
      <button (click)="backRecurringDateStep()" class="mb-4 bck-btn">
        <img src="assets/img/svg/bckArrow.svg">
        Back
      </button>
      <div class="row m-0" style="background: #DEE8F1;border-radius: 6px;">
        <div class="bg-faint row m-0 w-100" style="border-bottom: 0.5px solid #c6d6e5;">
          <div class="col-6" style="border-right: 0.5px solid #c6d6e5;">
            <label>Contract Id</label>
            <h4>{{contractData.contract_code}}</h4>
          </div>
          <div class="col-6">
            <label>Total Payable Today</label>
            <h4 class="notranslate">${{((contractData.late_fee * contractData.missing_payments)+
              edit_recurring_data.edit_recurring_amount)
              |
              number :
              '1.2-2'}}</h4>
          </div>
        </div>
        <div class="bg-faint row m-0 w-100" style="border-bottom: 0.5px solid #c6d6e5;"
          *ngIf="edit_recurring_data.total_rec_amount > 0">
          <div class="col-6" style="border-right: 0.5px solid #c6d6e5;">
            <label>Payable by</label>
            <h4>
              <span *ngIf="payment_option.paymentType == 1">
                <span *ngIf="selected_option == 1 || selected_option == 4 || selected_option == 5">
                  {{contractData.patient_first_name + ' ' + contractData.patient_last_name}}
                </span>
              </span>
              <span *ngIf="payment_option.paymentType == 2">
                <span *ngIf="selected_option == 3 || selected_option == 2 || selected_option == 5">
                  {{contractData.practice_name || contractData.doctor_first_name + ' ' +
                  contractData.doctor_last_name}}
                </span>
              </span>
            </h4>
          </div>
          <div class="col-6">
            <label>Payment Method</label>
            <h4>
              <span class="d-flex" *ngIf="selected_option == 1">
                <img src="assets/img/svg/pay.svg" class="me-2" />
                {{changePaymentDateCard.last4 ? changePaymentDateCard.last4 :
                contractData.default_card_last4}}
              </span>
              <span class="d-flex" *ngIf="selected_option == 5">
                <mat-icon class="me-2">account_balance</mat-icon>
                {{contractData.plaidAccount[0].last4}}
              </span>
              <span class="d-flex" *ngIf="selected_option == 4">
                <img src="assets/img/svg/pay.svg" class="me-2" />
                {{payment_stripe_data.card.last4}}
              </span>
              <span class="d-flex" *ngIf="selected_option == 3">
                <span class="notranslate">Denefits</span> account
              </span>
              <span class="d-flex" *ngIf="selected_option == 2">
                <img src="assets/img/svg/pay.svg" class="me-2" />
                {{payment_stripe_data.card.last4}}
              </span>
            </h4>
          </div>
        </div>
        <div class="bg-faint row m-0 w-100">
          <div class="col-6" style="border-right: 0.5px solid #c6d6e5;">
            <label>Old Payment Date</label>
            <h4 class="notranslate">{{contractData.next_payment_date | date:"MM/dd/yyyy": '+0000'}}</h4>
          </div>
          <div class="col-6">
            <label>New Payment Date</label>
            <h4 class="text-success-custom notranslate">{{edit_recurring_data.payment_date | date:"MM/dd/yyyy"}}</h4>
          </div>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-12 custom-form">
          <textarea class="p-1 pt-2 w-100" placeholder="Reason" [(ngModel)]="changeReason"
            style="resize: none;"></textarea>
        </div>
        <div class="col-xs-12 mt-4">
          <input type="checkbox" class="pointer" name="terms" id="terms_2" required style="margin-right: 8px;"
            [(ngModel)]="payment_option.terms">
          <label for="terms_2">
            <span>
              By clicking on this box, you agree with our
              <a class="text-primary-custom notranslate" [routerLink]="['/terms/contracts-terms']" target="_blank">
                Terms & Conditions</a>.
              This acceptance will have the same legal effect as a handwritten signature. You agree that all information
              in this
              contract is true and has been fully disclosed and agreed upon between you and your customer prior to
              making this
              contract adjustment. You are responsible for all of the changes to this contract. In no event will
              <span class="notranslate">Denefits</span> be liable
              for any user errors. ANY ATTEMPTED MISUSE OR FRAUD MAY RESULT IN SUSPENSION OF ALL Protected PAYMENTS.
            </span>
          </label>
        </div>
      </div>
    </div>
    <!--step 4-->
    <div *ngIf="edit_recurring_step == 4">
      <div *ngIf="payment_result.is_error == 0">
        <div class="text-center my-4">
          <img src="assets/img/png/check_signup.png" width="90px" alt="">
          <h3 class="text-bold my-4">{{selected_option !== 5 ? 'Payment Date Changed Successfully' : "Thank you. We have
            initiated your
            transaction"}}</h3>
        </div>
        <span *ngIf="selected_option !== 5 && contractData.dnd == 0">
          <p>Send the updated contract to your customer:</p>
        </span>
        <span *ngIf="selected_option !== 5 && contractData.dnd == 0">
          <div class="form-cont">
            <div class="custom-form me-md-3 form-group mb-3">
              <input type="text" class="input_field px-3 pt-3" required [(ngModel)]="send_email" name="email"
                #email="ngModel" autofocus />
              <label for="text" class="label-name">
                <span class="content-name f-c-p-3">
                  Email Address
                </span>
              </label>
            </div>
            <div class="custom-form me-md-3 form-group">
              <input type="text" class="input_field px-3 pt-3" required [(ngModel)]="send_phone" name="phone"
                #phone="ngModel" autofocus [mask]="mask" />
              <label for="text" class="label-name">
                <span class="content-name f-c-p-3">
                  Text Message
                </span>
              </label>
            </div>
          </div>
        </span>
      </div>
      <div *ngIf="payment_result.is_error == 1">
        <div class="text-center">
          <img src="assets/img/svg/fail-icon.svg" width="90px" alt="" class="mb-3">
          <h3 class="m-b-20">Payment Failed!</h3>
          <p>{{payment_result.override_text}}</p>

          <!--Buttons in Error-->
          <div class="col-xs-12 col-sm-12 text-center">
            <button mat-raised-button class="px-4" (click)="nextRecurringStep()">
              Retry
            </button>
            <button class="ms-3 px-2" mat-raised-button (click)="edit_recurring_step = 2; payment_result = {};">
              Change Card
            </button>
          </div>
          <br>
          <div class="col-xs-12 col-sm-12 text-center">
            <span class="f-c-p-8 fw-600 ">Need Support?</span>
            <br>
            <button style="width:177px !important" mat-raised-button class="mt-4 px-4"
              (click)="goTo('app/help/support')">
              Write to us
            </button>
            <button style="width:177px !important" mat-raised-button class="mt-4 ms-3 px-2"
              (click)="goTo('app/help/support')">
              Have us call you back
            </button>
            <button style="width:177px !important" mat-raised-button class=" px-4 mt-4 "
              (click)="goTo('app/help/support')">
              Chat with us
            </button>
          </div>
          <br>
        </div>
      </div>
    </div>
    <!--Step 5-->
    <div *ngIf="edit_recurring_step == 5">
      <div class="text-center">
        <img src="assets/img/svg/sent.svg" alt="Contract sent successfully">
        <p class="h4">Email/Text Sent Successfully</p>
      </div>
    </div>
    <!--all buttons -->
    <div class="d-flex justify-content-between ps-0" mat-dialog-actions>
      <div *ngIf="edit_recurring_step < 4">
        <button class="px-2 py-2 sup-btn" mat-raised-button (click)="nextRecurringStep()"
          [disabled]="(edit_recurring_step == 2 && (!payment_option.paymentType || (!selected_option && !changePaymentDateCard))) || (edit_recurring_step == 3 && (payment_option && !payment_option.terms))">
          <span>{{(edit_recurring_step < 3 ? 'Continue' : (edit_recurring_data.total_rec_amount> 0 ? 'Pay Now' : '
              Continue'))}}</span>
        </button>
      </div>
      <div *ngIf="edit_recurring_step == 4">
        <button class="px-2 py-2" mat-raised-button
          *ngIf="contractData.dnd == 0 && payment_result && payment_result.is_error == 0 && selected_option !== 5"
          (click)="sendContractPdf('edit_recurring_step')">Send</button>
      </div>
    </div>
  </div>
</div>

<div class="dialog-header" *ngIf="data.type == 25">
  <h2 class="py-3 px-3 d-flex justify-content-between align-items-center header_style">
    <span class="px-3">{{data.title}}</span>

    <span class="me-2">
      <mat-icon (click)="dialogRef.close()" class="close text-dark">close</mat-icon>
    </span>
  </h2>
  <div mat-dialog-content class="pt-0 form-cont" style="max-height: 90vh !important">
    <div>
      <div>
        <div class="text-start">
          <form class="container text-start form-cont p-0" #requestCallBackForm="ngForm"
            (ngSubmit)="requestCallBack(requestCallBackForm)">
            <div class="row p-0 mt-3" *ngIf="data && data.send_data">
              <div class="form-group w-100 mat-short-height col-sm-12">

                <div class="custom-form flex-grow-1 me-md-3">
                  <input class="input_field name_input_field px-3 pt-3 modified" [(ngModel)]="data.send_data.name"
                    required name="name" #name="ngModel" placeholder="Customer Name" trim readonly />
                  <label for="text" class="label-name">
                    <span class="content-name f-c-p-3" style="padding-bottom: 4px !important;">
                      Name
                    </span>
                  </label>
                </div>
              </div>

              <div class="form-group w-100 mat-short-height col-sm-12">
                <div class="custom-form flex-grow-1 me-md-3">
                  <span class="pt-2 pe-1 code_input" *ngIf="data.send_data.phone != '' ">+1</span>
                  <input style="padding: 0px 40px;" class="input_field pt-2 modified" [(ngModel)]="data.send_data.phone"
                    name="phone" #phone="ngModel" [mask]="mask" required />
                  <label for="text" class="label-name">
                    <span class="content-name f-c-p-3" style="padding-bottom: 4px !important;">
                      Phone
                    </span>
                  </label>
                </div>
              </div>

              <div class="form-group example-full-width mb-2 col-sm-12" appearance="outline">

                <div class="wrap m-h-56 h-100 h-56 d-block">
                  <div class="select w-100 h-100 h-56 d-flex justify-content-between align-items-center">
                    <div class="w-100 h-100">
                      <select id="img_logo_emp" name="timezone" required [(ngModel)]="callReasonModel"
                        (change)="reasonPrioritySet(callReasonModel)"
                        class="select-text pt-3 px-3 py-0 input_field fw-bold m-h-56 h-100 w-100">
                        <option *ngFor="let d of data.send_data.reason" [value]="d.reason">
                          {{d.reason}}
                        </option>
                      </select>
                      <span class="select-highlight"></span>
                      <span class="select-bar"></span>
                      <span class="select-bar-1"></span>
                      <span class="select-bar-1"></span>
                      <label class="select-label f-c-p-3">Select Reason</label>
                    </div>
                  </div>
                </div>
              </div>

              <div class="form-group example-full-width mb-2 col-sm-12">
                <textarea class="w-100 mt-3 input_field p-3" maxlength="2000" style="border-radius: 10px; resize: none;"
                  rows="5" [(ngModel)]="data.send_data.message" placeholder="Message" name="message"
                  #message="ngModel"></textarea>
                <small class="mt-2 length pull-right notranslate">{{ data.send_data.message.length }}/2000</small>
              </div>

              <div class="form-group col-lg-12">
                <label for="gender" class="calllback-text">Priority *</label>
                <div class="d-flex">

                  <div class="radio me-3 mt-3">
                    <label class="pointer">
                      <input type="radio" [(ngModel)]="data.send_data.priority" name="priority" [value]=1
                        id="customerMinor">
                      <label for="customerMinor">
                        <span class="same_data ms-2">Low</span>
                      </label>
                    </label>
                  </div>
                  <div class="radio me-3 mt-3">
                    <label class="pointer">
                      <input type="radio" [(ngModel)]="data.send_data.priority" name="priority" [value]=2
                        id="customerMinor_no">
                      <label for="customerMinor_no">
                        <span class="same_data ms-2">Medium</span>
                      </label>
                    </label>
                  </div>


                  <div class="radio mt-3">
                    <label class="pointer">
                      <input type="radio" [(ngModel)]="data.send_data.priority" name="priority" [value]=3
                        id="customerMinor_nos">
                      <label for="customerMinor_nos">
                        <span class="same_data ms-2">High</span>
                      </label>
                    </label>
                  </div>
                </div>

              </div>
            </div>
            <div class="mt-1 d-flex justify-content-start align-item-center pe-5 ps-0 pb-4 pt-2">
              <button button-primary-auth type="submit">Submit</button>
            </div>
            <div class="mt-2" style="text-align: justify;font-size: 11px;color: grey;">
              <p [ngStyle]="{'height': tcr_height?'47px':'max-content'}" style="overflow: hidden; margin-bottom: 0;">
                By submitting your information, you agree to our Privacy Policy. By providing my contact information I
                am giving
                <span class="notranslate">Denefits</span>, LLC (<a href="https://www.denefits.com/"
                  target="_blank">denefits.com</a>) permission to
                contact me about this and future offers using the information
                provided. I am providing <span class="notranslate">Denefits</span>, LLC and third parties consent to
                contact me through emails, calls,
                and text
                messages to my wireless telephone numbers. I understand contact may also include but is not limited to
                using an
                automated dialing device and prerecorded messages.
              </p>
              <p style="color:black;font-size: 14px;text-align: right;cursor:pointer;font-weight: bold;margin-bottom: 0;margin-top: 6px;"
                (click)="tcr_height=0" *ngIf="tcr_height==1">
                Show More
              </p>
              <p style="color:black;font-size: 14px;text-align: right;cursor:pointer;font-weight: bold;margin-bottom: 0;margin-top: -12px;"
                (click)="tcr_height=1" *ngIf="tcr_height==0">
                Show Less
              </p>
            </div>
          </form>
        </div>
      </div>
    </div>


    <!--all buttons -->
    <!-- <div class="mt-2 d-flex justify-content-between ps-0" mat-dialog-actions>
      <button mat-raised-button type="submit" class="p-2 sup-btn">Submit</button>
      </button>
    </div> -->
  </div>
</div>

<div class="dialog-header verify-user" *ngIf="data.type == 37">
  <h2 mat-dialog-title class="py-4 px-3 d-flex justify-content-between align-items-start" style="left: 10px">
    <div>
      <div class="row m-0 w-100 payout-heading mb-2">
        {{data.action || 'Add'}} your Business Debit Card to receive your Instant Payout
      </div>
      <div class="row m-0 w-100">
        <p class="payout-note mb-0 p-0">
          To receive your Instant Payout, provide your debit card linked to your bank account.
        </p>
      </div>
    </div>

    <span class="me-2">
      <mat-icon (click)="dialogRef.close()" class="close text-dark"
        style="position: relative !important; transform: none !important;">close</mat-icon>
    </span>
  </h2>
  <div mat-dialog-content class="px-4">
    <div class="row m-0 mt-3">
      <form #addInstantCardPp="ngForm" class="w-100" (ngSubmit)="addInstantCard(addInstantCardPp)">
        <div class="row m-0 w-100">
          <mat-form-field appearance="outline" class="w-100 p-0">
            <mat-label>Cardholder Name</mat-label>
            <input [(ngModel)]="payment_option.cardName" name="cardholder_name" #cardholder_name="ngModel" matInput
              placeholder="Enter cardholder name" trim required>
          </mat-form-field>
        </div>
        <div class="row m-0 w-100">
          <div class="stripe-card" id="add_instant_card"></div>
        </div>
        <p *ngIf="new_address.cardError" class="text-danger-custom text-center row m-0 w-100 mb-3">
          {{new_address.cardError}}</p>
        <a href="javascript:void(0);" (click)="showSupportedDebitCard();" style="text-decoration: none;">
          List of all supported debit cards
        </a>
        <div class="w-100 mt-5 d-flex justify-content-between align-items-center">
          <button class="add_btn" type="submit">{{data.action || 'Add'}}</button>
        </div>
      </form>
    </div>
  </div>
</div>

<div class="dialog-header verify-user" *ngIf="data.type == 38">
  <h2 mat-dialog-title class="py-3 px-3 d-flex justify-content-between align-items-start">
    <div>
      <div class="row m-0 w-100 mb-2">
        <p class="payout-note mb-0 p-0">
          <button (click)="data.type = 37;setStripeElement('add_instant_card')" class="bck-btn mt-2">
            <img src="assets/img/svg/bckArrow.svg">
            Back
          </button>
        </p>
      </div>
      <div class="row m-0 w-100 payout-heading mb-2">
        Banks supported for Instant Payouts
      </div>
    </div>
    <span class="me-2">
      <mat-icon (click)="dialogRef.close()" class="close text-dark"
        style="position: relative !important; transform: none !important;">close</mat-icon>
    </span>
  </h2>
  <div mat-dialog-content class="px-3 py-0 text-center">
    <div class="col-md-12 ">
      <div class="search_container">
        <input type="text" class="input_field pt-2 pb-2 ps-3 w-100 search-box col-12" name="email"
          [(ngModel)]="searchDebitBank" (keydown.enter)="getFilteredInstantPayoutSupoortBanks($event.target.value)"
          required placeholder="Search" />
        <label><img src="assets/img/svg/search-normal.svg"> </label>
        <span *ngIf="searchDebitBank != ''" class="clear_search" [ngClass]="searchDebitBank?'d-block':'d-none'"
          (click)="searchDebitBank = '';getFilteredInstantPayoutSupoortBanks('');">
          <img src="assets/img/svg/search-cross.svg">
        </span>
      </div>
      <div class="mt-4 debit-card-list w-100" style="height: 70vh;overflow-y: auto;"
        *ngIf="filtered_banks && filtered_banks.length > 0">
        <ul>
          <li *ngFor="let d of filtered_banks; let i=index">
            {{d.card_name}}
          </li>
        </ul>
      </div>
      <div class="mt-3" *ngIf="filtered_banks.length === 0">
        No records
      </div>
    </div>
  </div>
</div>

<div class="dialog-header" *ngIf="data.type == 40" style="border-radius: 0px !important;">
  <h2 mat-dialog-title class="py-4 px-3 d-flex justify-content-between align-items-center">
    <span class="px-2">{{data.title}}</span>

    <span class="me-2">
      <mat-icon (click)="closePop()" class="close text-dark"
        style="position: relative !important; transform: none !important;">close</mat-icon>
    </span>
  </h2>
  <div mat-dialog-content class="pt-0 form-cont">
    <div>
      <div>
        <div class="form-group">
          <textarea class="w-100 mt-3 input_field" maxlength="2000"
            style="border-radius: 10px; resize: none;padding: 16px !important;" rows="7" [(ngModel)]="writeToUsMessage"
            placeholder="Message" name="writeToUsMessage"></textarea>
          <small class="mt-2 length pull-right notranslate">{{ writeToUsMessage.length }}/2000</small>
        </div>
      </div>
    </div>

    <!--all buttons -->
    <div class="mt-2 d-flex justify-content-between ps-0 button_send" mat-dialog-actions>
      <button button-primary-auth (click)="addWpQuery()" [disabled]="writeToUsMessage?.length == 0">
        <span>Send Message</span>
      </button>
    </div>
    <div class="mt-2" style="text-align: justify;font-size: 11px;color: grey;">
      <p [ngStyle]="{'height': tcr_height?'47px':'max-content'}" style="overflow: hidden; margin-bottom: 0;">
        By submitting your information, you agree to our
        <a style="color: #1581E5;cursor: pointer;" href="https://www.denefits.com/privacy-policy/"
          target="_blank">Privacy Policy</a>. By providing my contact information I am giving
        <span class="notranslate">Denefits</span>, LLC (<a href="https://www.denefits.com/"
          target="_blank">denefits.com</a>) permission to contact me
        about this and future offers using the information
        provided. I am providing <span class="notranslate">Denefits</span>, LLC and third parties consent to contact me
        through emails, calls, and text
        messages to my wireless telephone numbers. I understand contact may also include but is not limited to using an
        automated dialing device and prerecorded messages.
      </p>
      <p style="color:black;font-size: 14px;text-align: right;cursor:pointer;font-weight: bold;margin-bottom: 0;margin-top: 6px;"
        (click)="tcr_height=0" *ngIf="tcr_height==1">
        Show More
      </p>
      <p style="color:black;font-size: 14px;text-align: right;cursor:pointer;font-weight: bold;margin-bottom: 0;margin-top: 6px;"
        (click)="tcr_height=1" *ngIf="tcr_height==0">
        Show Less
      </p>
    </div>
  </div>
</div>

<div class="dialog-header" *ngIf="data.type == 41">
  <h2 mat-dialog-title class="py-4 px-4 d-flex justify-content-between align-items-center">
    <span>Add Details to Place order</span>
    <mat-icon class="close text-dark pointer" style="position: relative !important; transform: none !important;"
      (click)="dialogRef.close()">close</mat-icon>
  </h2>
  <div mat-dialog-content class="pt-0" style="overflow: auto;">
    <form class="h-100 g-0" [formGroup]="marketControls" (ngSubmit)="placeOrder()">

      <div class="w-100">
        <div class="custom-form mt-3"
          [ngClass]="[(marketControls.controls && marketControls.controls.address && marketControls.controls.address.touched && marketControls.controls.address.invalid) || (marketControls.controls && marketControls.dirty  && marketControls.controls.address.invalid)  ? 'inputContainer' : '']">
          <input type="text" class="input_field pt-2 px-3 modified" name="address" formControlName="address" trim
            required />
          <label for="text" class="label-name">
            <span class="content-name f-c-p-3">
              Address
            </span>
          </label>
        </div>
        <p class="mat-error"
          *ngIf="(marketControls.controls && marketControls.controls.address && marketControls.controls.address.touched && marketControls.controls.address.invalid) || (marketControls.controls && marketControls.dirty && marketControls.controls.address.invalid)">
          Please enter valid address.</p>
      </div>
      <div class="w-100 mt-3">
        <!-- <zip-selector (zipSelected)="getZipselected_v2($event)" [placeholder]=""
          [customClass]="[(marketControls.controls && marketControls.controls.zipCode && marketControls.controls.zipCode.touched && marketControls.controls.zipCode.invalid) || (marketControls.controls && marketControls.dirty && marketControls.controls.zipCode.invalid)  ? 'inputContainer' : '']"
          t="2" [isRequired]="true" id="zipPostalCode" name="zipPostalCode" [model]="zipPostalCode" ngDefaultControl>
        </zip-selector> -->

        <app-google-api (setAddress)="getZipselected_v2($event)" [t]="1" [placeholder]=""
          [customClass]="[(marketControls.controls && marketControls.controls.zipCode && marketControls.controls.zipCode.touched && marketControls.controls.zipCode.invalid) || (marketControls.controls && marketControls.dirty && marketControls.controls.zipCode.invalid)  ? 'inputContainer modified' : 'modified']"
          [isRequired]="true" id="zipPostalCode" name="zipPostalCode" [model]="zipPostalCode" ngDefaultControl>
        </app-google-api>
        <p class="mat-error"
          *ngIf="(marketControls.controls && marketControls.controls.zipCode && marketControls.controls.zipCode.touched && marketControls.controls.zipCode.invalid) || (marketControls.controls && marketControls.dirty && marketControls.controls.zipCode.invalid)">
          Please enter valid zip.</p>
      </div>
      <div class="w-100">
        <div class="custom-form mt-3"
          [ngClass]="[(marketControls.controls && marketControls.controls.state && marketControls.controls.state.touched && marketControls.controls.state.invalid) || (marketControls.controls && marketControls.dirty && marketControls.controls.state.touched && marketControls.controls.state.invalid)  ? 'inputContainer' : '']">
          <input type="text" class="input_field pt-2 px-3 modified" name="state" formControlName="state" trim
            required />
          <label for="text" class="label-name">
            <span class="content-name f-c-p-3">
              State
            </span>
          </label>
        </div>
        <p class="mat-error"
          *ngIf="(marketControls.controls && marketControls.controls.state && marketControls.controls.state.touched && marketControls.controls.state.invalid) || (marketControls.controls && marketControls.dirty && marketControls.controls.state.touched && marketControls.controls.state.invalid)">
          Please enter valid state.</p>
      </div>
      <div class="w-100">
        <div class="custom-form mt-3"
          [ngClass]="[(marketControls.controls && marketControls.controls.city && marketControls.controls.city.touched && marketControls.controls.city.invalid) || (marketControls.controls && marketControls.dirty && marketControls.controls.city.touched && marketControls.controls.city.invalid)  ? 'inputContainer' : '']">
          <input type="text" class="input_field pt-2 px-3 modified" name="city" formControlName="city" trim required
            autocomplete="disabled" (blur)="updateCity(marketControls.controls.city.value, 'user_data')" />
          <label for="text" class="label-name">
            <span class="content-name f-c-p-3">
              City
            </span>
          </label>
        </div>
        <p class="mat-error"
          *ngIf="(marketControls.controls && marketControls.controls.city && marketControls.controls.city.touched && marketControls.controls.city.invalid) || (marketControls.controls && marketControls.dirty && marketControls.controls.city.touched && marketControls.controls.city.invalid)">
          Please enter valid city.</p>
      </div>

      <div class="w-100" style="height: 150px;">
        <div class="reason-area mt-3">
          <div class="custom_text_area">
            <textarea class="text_reason mt-2 modified" style="height:112px !important" maxlength="500"
              formControlName="suggestions"></textarea>
            <label for="" class="area_name">
              <span class="label_area" style="background-color: white;width:auto;color: #7A848D !important;">
                Suggestion (Optional)
              </span>
            </label>
            <!-- <label>Amount for</label> -->
          </div>
        </div>
      </div>
      <div class="form-group w-100 mt-1 m-0">
        <button button-primary-auth class="px-5" type="sbumit">Submit</button>
      </div>
    </form>
  </div>
</div>

<div class="dialog-header verify-user" *ngIf="data.type == 48">
  <h2 mat-dialog-title class="py-4 px-3 d-flex justify-content-between align-items-center">
    <!-- <span class="px-3">Edit Contract</span> -->
    <span class="px-3" *ngIf="edit_contract_step < 4">Edit Contract</span>
    <span class="px-3" *ngIf="edit_contract_step == 4">Financing Details</span>
    <span class="px-3" *ngIf="edit_contract_step == 5">Choose Payment Method</span>
    <span class="px-3" *ngIf="edit_contract_step == 6">Contract Edit Confirmation</span>
    <span class="px-3" *ngIf="edit_contract_step == 9">Update Service Cost Breakdown</span>
    <span class="px-3" *ngIf="edit_contract_step == 7 && editContractResult.is_error == 0">
      {{payment_option.paymentType && selected_option == 5 ? 'Transaction Initiated' : 'Contract Edited
      Successfully'}}
    </span>
    <span class="px-3" *ngIf="edit_contract_step == 7 && editContractResult.is_error == 1">Payment Failed</span>
    <span class="px-3" *ngIf="edit_contract_step == 8">Email/Text Sent Successfully</span>
    <mat-icon
      (click)="(edit_contract_step >= 7 && editContractResult.is_error == 0)?dialogRef.close(1):dialogRef.close()"
      class="close text-dark" style="position: relative !important; transform: none !important;">close</mat-icon>
  </h2>
  <div mat-dialog-content class="py-3 px-4" style="max-height: unset !important;">
    <!--Step 1-->
    <div *ngIf="edit_contract_step == 1 || edit_contract_step == 2">
      <div class="full-payment-details-left row m-0 ms-1">
        <div class="col pe-0">
          <label style="font-size: 14px;font-weight: 700; line-height: 24px; color: #596775;">Estimated Service
            Amount</label>
          <h3 style="font-weight: 800;" class="notranslate">{{contractData.treatment_amount | currency}}</h3>
          <label class="px-2 py-2 financed-label" style="font-size: 13px;">
            <span class="notranslate">{{(!showTransactionWord ? contractData.recurring_amount +
              mainService.getCalculatedTransactionFee(contractData,contractData.recurring_amount) +
              ((contractData.credit_reporting_status > 0 && contractData.credit_reporting_fee > 0) ?
              contractData.credit_reporting_fee : 0) : contractData.recurring_amount +
              ((contractData.credit_reporting_status > 0 && contractData.credit_reporting_fee > 0) ?
              contractData.credit_reporting_fee : 0)) | currency}}</span> Current Recurring
          </label>
        </div>
        <div class="col">
          <div class="row m-0 w-100 upper-text">
            <span class="col-11 p-0">Current Contract Term:</span>
            <span class="col-1 p-0 text-center">{{contractData.number_of_payments}}</span>
          </div>
          <div class="row m-0 w-100 upper-text mt-1">
            <span class="col-11 p-0">Total Paid Payments:</span>
            <span class="col-1 p-0 text-center">{{contractData.number_of_payments -
              contractData.remaining_payments}}</span>
          </div>
          <div class="row m-0 w-100 upper-text mt-1">
            <span class="col-11 p-0">Remaining Payments:</span>
            <span class="col-1 p-0 text-center">{{contractData.remaining_payments}}</span>
          </div>
          <div class="row m-0 w-100 upper-text mt-1">
            <span class="col-11 p-0">Overdue Payments:</span>
            <span class="col-1 p-0 text-center">{{contractData.missing_payments}}</span>
          </div>
        </div>
      </div>
      <div class="row m-0 mt-3 ms-1">
        <div class="bg-faint w-100 mb-2 p-0">
          <h4>
            Add new details for plan
          </h4>
        </div>
        <!-- NEW EDIT CONTRACT -->
        <div width="100%" *ngIf="contract_types_new_edit.includes(contractData.contract_type)">
          <div class="form-group col-12 w-100 p-0 mb-3">
            <div class="custom-form flex-grow-1 me-md-3">
              <input appDecimaNumber class="input_field px-3 pt-3" focus-on="true"
                [(ngModel)]="new_edit_contract_values.new_treatment_amount" required name="new_treatment_amount"
                [min]="edit_contract_data.minimum_amount" [max]="edit_contract_data.maximum_amount"
                (focus)="edit_contract_step = 1" />
              <label for="text" class="label-name">
                <span class="content-name f-c-p-3">
                  Enter the New Service Amount
                </span>
              </label>
            </div>
          </div>

          <div class="d-flex">
            <div class="custom-form flex-grow-1 col-5 px-0">
              <input type="text" class="input_field px-3 pt-3"
                [disabled]="new_edit_contract_values.desired_recurring_amount !== undefined && new_edit_contract_values.desired_recurring_amount !== '' && new_edit_contract_values.desired_recurring_amount != null"
                [(ngModel)]="new_edit_contract_values.new_number_of_payments" required maxlength="2"
                (keypress)="enterNumberOnly($event)" trim />
              <label for="text" class="label-name">
                <span class="content-name f-c-p-3">
                  New Contract Term
                </span>
              </label>
            </div>
            <div class="col-2 p-0 d-flex justify-content-center align-items-center" style="color: #C3C8CD;">OR</div>
            <div class="custom-form col-5 px-0">
              <span
                *ngIf="new_edit_contract_values.desired_recurring_amount && new_edit_contract_values.desired_recurring_amount > 0"
                class="sign_input">$</span>
              <input required type="text" class="input_field px-4 notranslate"
                [disabled]="new_edit_contract_values.new_number_of_payments !== undefined && new_edit_contract_values.new_number_of_payments !== ''"
                [(ngModel)]="new_edit_contract_values.desired_recurring_amount"
                (focus)="new_edit_contract_values.desired_recurring_amount = null" appDecimaNumber />
              <label for="text" class="label-name">
                <span class="content-name f-c-p-3">
                  Expected Recurring
                </span>
              </label>
            </div>
          </div>
        </div>
        <!-- OLD EDIT CONTRACT -->
        <div class="form-group col-12 w-100 p-0 mb-3" *ngIf="contractData.contract_type != 6">
          <div class="custom-form flex-grow-1 me-md-3">
            <input type="number" class="input_field px-3 pt-3" required focus-on="true"
              [(ngModel)]="edit_contract_data.treatment_amount" name="treatment_amount"
              min="edit_contract_data.minimum_amount" max="edit_contract_data.maximum_amount"
              (focus)="edit_contract_step = 1"
              onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57" />
            <label for="text" class="label-name">
              <span class="content-name f-c-p-3">
                Enter the New Service Amount
              </span>
            </label>
          </div>
        </div>
      </div>
      <!--Step 2-->
      <div class="row m-0" *ngIf="edit_contract_step == 2 && contractData.contract_type !== 6">
        <div class="custom-form flex-grow-1 col-5 px-1">
          <input type="text" class="input_field px-3 pt-3" required [(ngModel)]="edit_contract_data.tenure"
            maxlength="2" (ngModelChange)="CalculateNewRecurringAmount();" (keypress)="enterNumberOnly($event)" trim />
          <label for="text" class="label-name">
            <span class="content-name f-c-p-3">
              New Contract Term
            </span>
          </label>
        </div>
        <div class="col-2 p-0 d-flex justify-content-center align-items-center" style="color: #C3C8CD;">
          OR
        </div>
        <div class="custom-form col-5 px-1">
          <span class="sign_input">$</span>
          <input type="text" class="input_field px-4 notranslate"
            [(ngModel)]="edit_contract_data.new_recurring_amount" (focus)="edit_contract_data.tenure = null"
            appDecimaNumber />
          <label for="text" class="label-name">
            <span class="content-name f-c-p-3">
              Expected Recurring
            </span>
          </label>
        </div>
        <div class="row m-0 mt-2 p-0">
          <label *ngIf="edit_contract_data.tenure && edit_contract_data.new_recurring_amount">
            New Term: <span style="color: #1581E5;">{{edit_contract_data.tenure}}</span>, New Recurring:
            <span style="color: #1581E5;" class="notranslate">${{(edit_contract_data.new_recurring_amount) |
              number:'1.2-2'}}</span>
          </label>
        </div>
      </div>
    </div>
    <!--Step 4-->
    <div *ngIf="edit_contract_step == 4">
      <button
        (click)="edit_contract_step = contract_types_new_edit.includes(contractData.contract_type) ? edit_contract_step - 3 : edit_contract_step - 2;"
        class="mb-4 bck-btn">
        <img src="assets/img/svg/bckArrow.svg">
        Back
      </button>
      <div class="col-xs-12 p-0">
        <div class="col-xs-12" style="padding:0 8px">
          <table class="w-100" focus-on="true">
            <thead>
              <tr class="heading --modify">
                <td class="text-bold py-2 ps-2" style="border-top-left-radius: 7px;">Financing Details</td>
                <td class="text-bold text-center">Old</td>
                <td class="text-bold text-center" style="border-top-right-radius: 7px;">New</td>
              </tr>
            </thead>
            <tbody style="background: #DEE8F1;">
              <tr class="text-font">
                <td class="f-s-14 py-2 ps-2 detail">Service Amount:</td>
                <td class="text-bold f-s-18 text-center old-data amount notranslate">
                  ${{edit_contract_data.oldFinanceDetails.treatment_amount | number:'1.2-2'}}
                </td>
                <td class="text-bold f-s-18 text-center new-data amount notranslate">
                  ${{edit_contract_data.newFinanceDetails.treatment_amount | number:'1.2-2'}}
                </td>
              </tr>
              <tr class="text-font">
                <td class="f-s-14 py-2 ps-2 detail">
                  {{edit_contract_data.oldFinanceDetails.downpayment_amount > 0 && contractData.is_arv2 ? 'Partial
                  Payment Amount':'Down Payment Amount'}}:
                </td>
                <td class="text-bold f-s-18 text-center old-data amount notranslate">
                  ${{edit_contract_data.oldFinanceDetails.downpayment_amount | number:'1.2-2'}}
                </td>
                <td class="text-bold f-s-18 text-center new-data amount notranslate">
                  ${{edit_contract_data.newFinanceDetails.downpayment_amount | number:'1.2-2'}}
                </td>
              </tr>
              <tr class="text-font">
                <td class="f-s-14 py-2 ps-2 detail">Payment Plan Amount:</td>
                <td class="text-bold f-s-18 text-center old-data amount notranslate">
                  ${{edit_contract_data.oldFinanceDetails.financed_amount | number:'1.2-2'}}
                </td>
                <td class="text-bold f-s-18 text-center new-data amount notranslate">
                  ${{edit_contract_data.newFinanceDetails.financed_amount | number:'1.2-2'}}
                </td>
              </tr>
              <tr class="text-font">
                <td class="f-s-14 py-2 ps-2 detail">Interest Rate:</td>
                <td class="text-bold f-s-18 text-center old-data amount notranslate" *ngIf="deferred_continue_edit">No
                  Interest</td>
                <td class="text-bold f-s-18 text-center old-data amount notranslate"
                  *ngIf="edit_contract_data.oldFinanceDetails.interest_rate > 0 && !deferred_continue_edit">
                  {{edit_contract_data.oldFinanceDetails.interest_rate | number:'1.2-2'}}%
                  <sup>{{!contractData.interest_rate_to_show || (contractData.interest_rate
                    == contractData.interest_rate_to_show) ? (contractData.interest_rate>0?'C':'') : 'F'}}</sup>
                </td>
                <td class="text-bold f-s-18 text-center old-data amount"
                  *ngIf="edit_contract_data.oldFinanceDetails.interest_rate == 0 || deferred_continue_edit">
                  No Interest
                </td>
                <td class="text-bold f-s-18 text-center new-data amount notranslate" *ngIf="(edit_contract_data.newFinanceDetails.interest_rate_to_show > 0 ||
                edit_contract_data.newFinanceDetails.interest_rate > 0) && !deferred_continue_edit">
                  {{edit_contract_data.newFinanceDetails.interest_rate_to_show ||
                  edit_contract_data.newFinanceDetails.interest_rate | number:'1.2-2'}}%
                  <sup>{{!edit_contract_data.newFinanceDetails.interest_rate_to_show ||
                    (edit_contract_data.newFinanceDetails.interest_rate ==
                    edit_contract_data.newFinanceDetails.interest_rate_to_show) ?
                    (edit_contract_data.newFinanceDetails.interest_rate>0?'C':'') :
                    'F'}}</sup>
                </td>
                <td class="text-bold f-s-18 text-center new-data amount" *ngIf="edit_contract_data.newFinanceDetails.interest_rate_to_show == 0 ||
                edit_contract_data.newFinanceDetails.interest_rate == 0">
                  No Interest
                </td>
              </tr>
              <tr class="text-font">
                <td class="f-s-14 py-2 ps-2 detail">Recurring Amount:</td>
                <td class="text-bold f-s-18 text-center old-data amount">

                  <span class="d-flex align-item-center justify-content-center notranslate">
                    ${{(contractData.old_recurring_amount_with_fee + ((contractData.credit_reporting_status > 0 &&
                    contractData.credit_reporting_fee > 0) ? contractData.credit_reporting_fee : 0)) | number:'1.2-2'}}
                  </span>

                </td>
                <td class="text-bold f-s-18 text-center new-data amount">
                  <span class="d-flex align-item-center justify-content-center notranslate">
                    ${{(contractData.new_recurring_amount_with_fee + ((contractData.credit_reporting_status > 0 &&
                    contractData.credit_reporting_fee > 0) ? contractData.credit_reporting_fee : 0)) | number:'1.2-2'}}
                  </span>
                </td>
              </tr>
              <tr class="text-font">
                <td class="f-s-14 py-2 ps-2 detail">Total Payments:</td>
                <td class="text-bold f-s-18 text-center old-data amount">
                  {{edit_contract_data.oldFinanceDetails.number_of_payments}} months
                </td>
                <td class="text-bold f-s-18 text-center new-data amount">
                  {{edit_contract_data.newFinanceDetails.number_of_payments}} months
                </td>
              </tr>
              <tr class="text-font">
                <td class="f-s-14 py-2 ps-2 detail">Remaining Payments:</td>
                <td class="text-bold f-s-18 text-center old-data">
                  {{edit_contract_data.oldFinanceDetails.remaining_payments}} months
                </td>
                <td class="text-bold f-s-18 text-center new-data">
                  {{edit_contract_data.newFinanceDetails.remaining_payments}} months
                </td>
              </tr>
              <tr class="text-font">
                <td class="f-s-14 py-2 ps-2 detail"
                  [ngStyle]="{'border-bottom-left-radius': (contractData.contract_type === 2 ||  contractData.contract_type === 4 || contractData.contract_type === 6) ? '' : '7px'}">
                  Paid
                  Payments:</td>
                <td class="text-bold f-s-18 text-center old-data amount">
                  {{edit_contract_data.oldFinanceDetails.number_of_payments -
                  edit_contract_data.oldFinanceDetails.remaining_payments}} months
                </td>
                <td class="text-bold f-s-18 text-center new-data amount"
                  [ngStyle]="{'border-bottom-right-radius': (contractData.contract_type === 2 ||  contractData.contract_type === 4 || contractData.contract_type === 6) ? '' : '7px'}">
                  {{edit_contract_data.newFinanceDetails.number_of_payments -
                  edit_contract_data.newFinanceDetails.remaining_payments}} months
                </td>
              </tr>
              <tr
                *ngIf="(contractData.contract_type === 2 || contractData.contract_type === 4 || contractData.contract_type === 6)"
                class="text-font">
                <td class="f-s-14 py-2 ps-2 detail" style="border-bottom-left-radius: 7px;">Upfront
                  Payment:</td>
                <td class="text-bold f-s-18 text-center old-data amount">
                  <span class="d-flex justify-content-center notranslate">
                    ${{contractData.old_upfront_with_fee | number:'1.2-2'}}
                  </span>
                </td>
                <td class="text-bold f-s-18 text-center new-data"
                  style="border-bottom-left-radius: 7px; border-bottom-right-radius: 7px;">
                  <span class="d-flex justify-content-center amount notranslate">
                    ${{(contractData.new_upfront_with_fee < contractData.old_upfront_with_fee ?
                      contractData.old_upfront_with_fee : contractData.new_upfront_with_fee) | number:'1.2-2'}} </span>
                </td>
              </tr>
            </tbody>
          </table>
          <p class="mt-3 mb-0 bottom-text">F: Flat Interest, C: Compound Interest</p>
        </div>
      </div>
    </div>
    <!--Step 5-->
    <div *ngIf="edit_contract_step == 5">
      <button (click)="edit_contract_step = edit_contract_step - 1;" class="mb-4 bck-btn">
        <img src="assets/img/svg/bckArrow.svg">
        Back
      </button>
      <h6 class="px-2 py-2" style="background: #DEE8F1;">
        Remaining Upfront Payment:
        <span class="text-bold m-l-5 notranslate">
          ${{contractData.net_remaining_upfront_fee | number:'1.2-2'}}
        </span>
      </h6>
      <div class="row m-0">
        <h5 class="mt-3 mb-4 d-flex align-items-center"
          style="font-weight: 700;font-size: 14px;line-height: 24px; color: #05141F;">
          <span class="me-1"> Who will be responsible for the payment? </span>
          <span [tooltip]="'Usually, the party requesting to edit the contract will be responsible for the payment.'"
            [placementModal]="'1'" [customClass]="'dark-theme-tooltip'" [placement]="'right'">
            <img src="assets\img\svg\tooltip_icon.svg" alt="" style="width: 20px;">
          </span>
        </h5>
        <div class="row w-100">
          <div class="col-xs-6 col-6 p-0 ps-3">
            <input id="paymentType" type="radio" name="a" [(ngModel)]="payment_option.paymentType" [value]="1">
            <label for="paymentType">
              <span tappable (click)="payment_option.paymentType = 1">Customer</span>
            </label>
          </div>
          <div class="col-xs-6 col-6 p-0" *ngIf="contractData.contract_type != 3">
            <input id="paymentType1" type="radio" name="a" [(ngModel)]="payment_option.paymentType" [value]="2">
            <label for="paymentType1">
              <span tappable (click)="payment_option.paymentType = 2">Business</span>
            </label>
          </div>
        </div>
        <h5 class="mt-4 mb-4" style="font-weight: 700;font-size: 14px;line-height: 24px; color: #05141F;"
          *ngIf="payment_option.paymentType">
          Select Payment Method
        </h5>
        <div class="col-lg-12 col-xs-12" *ngIf="payment_option.paymentType == 1">
          <div class="row">
            <div class="col-md-6 text-start p-0" style="display:flex;align-items:center;"
              *ngIf="changePaymentDateCardList && changePaymentDateCardList.length > 0">
              <input id="selected_option1" type="radio" name="b" [(ngModel)]="selected_option" [value]="1"
                class="pull-left">
              <label for="selected_option1">
                <span tappable (click)="selected_option = 1">Customer’s existing
                  card(s)</span>
              </label>
            </div>
            <div class="col-md-6 text-start p-0" style="display:flex;align-items:center;">
              <input id="selected_option2" type="radio" name="b" [(ngModel)]="selected_option" [value]="4"
                class="pull-left" (change)="mountCard(false)">
              <label for="selected_option2">
                <span tappable (click)="selected_option = 4;  mountCard(false);">Pay with a new card</span>
              </label>
            </div>
            <div class="col-md-6 text-start p-0 mt-1" style="display:flex;align-items:center;"
              *ngIf="contractData.plaidAccount && contractData.plaidAccount[0] && contractData.plaidAccount[0].last4 && contractData.plaidAccount[0].status == 'verified'">
              <input id="selected_option3" type="radio" name="b" [(ngModel)]="selected_option" [value]="5"
                class="pull-left">
              <label for="selected_option3">
                <span tappable (click)="selected_option = 5">Customer Bank Account
                  ({{contractData.plaidAccount[0].last4}})</span>
              </label>
            </div>
          </div>
        </div>

        <!-- Card List -->
        <div class="col-lg-12 col-xs-12 mt-4 card-list customer-card-list mb-1"
          *ngIf="payment_option.paymentType == 1 && selected_option == 1">


          <div class="card_list" *ngIf="changePaymentDateCardList.length > 0">
            <ng-container *ngFor="let card of changePaymentDateCardList; let i=index">
              <div class="pointer  py-1" (click)="selPaymentCard(card);">
                <label [for]="i" class="d-flex pointer align-items-center w-100 justify-content-between mb-0"
                  style="height: 35px;">
                  <p class="d-flex mt-3"> <img style="width:24px;" [src]="getCardBrandImage(card)"
                      *ngIf="['mastercard', 'discover', 'jcb', 'visa', 'american express', 'unionpay', 'diners club', 'diners', 'amex'].includes(card.brand.toLowerCase()); else no_card">
                    <ng-template #no_card>
                      <img style="width:24px;" [src]="'assets/img/svg/card-type/no_card.svg'">
                    </ng-template>&nbsp;&nbsp;XXXX XXXX XXXX {{card.last4}}
                  </p>
                  <p *ngIf="card.source_id==contractData.source_id" class="text-success-custom pt-4"
                    style="font-size:12px;display: flex; flex-direction:row-reverse;">
                    <mat-icon class="check">check_circle_outline</mat-icon>Default
                  </p>
                  <span style="margin-bottom: 1.9rem;">
                    <input type="radio" [id]="card.source_id"
                      [checked]="card.source_id == changePaymentDateCard.source_id" name="doctorPaymentCard"
                      [value]="card.source_id" class="pointer">
                    <label for="card.source_id"></label>
                  </span>
                </label>
              </div>
            </ng-container>
          </div>


          <!-- <div *ngFor="let card of changePaymentDateCardList; let i=index" style="cursor:pointer"
            class="border rounded p-2 mb-2" (click)="selPaymentCard(card);">
            <div class="d-flex align-item-center">
              <div class="me-2">
                <input [id]="card.source_id" type="radio"
                  [checked]="card.source_id == changePaymentDateCard.source_id" [value]="card.source_id">
                <label for="card.source_id" class="mb-0 d-flex">
                  <span>
                    <mat-icon class="cred-card">credit_card</mat-icon>
                  </span>
                  <span class="card-num">&nbsp;&nbsp;XXXX-XXXX-XXXX-{{card.last4}}</span>
                  <p *ngIf="card.last_error" class="m-0 ps-3" style="font-size:12px;"
                    [ngClass]="{'text-danger-custom':card.source_id!=contractData.source_id}">
                    {{card.last_error}}</p>
                  <p *ngIf="card.source_id==contractData.source_id" class="m-0 text-success-custom ps-3"
                    style="font-size:12px;display: flex; flex-direction:row-reverse;">
                    <mat-icon class="check">check_circle_outline</mat-icon>Default
                  </p>
                </label>
              </div>
            </div>
          </div> -->
        </div>

        <div class="col-lg-12 col-xs-12" *ngIf="payment_option.paymentType == 2">
          <div class="row mb-1">
            <div *ngIf="contractData.stripe_account_id || contractData.contract_type != 5"
              class="col-md-7 text-start p-0" style="display:flex;align-items:center;">
              <input id="selected_option4" type="radio" name="business" [(ngModel)]="selected_option" [value]="3"
                class="pull-left">
              <label for="selected_option4">
                <span tappable (click)="selected_option = 3">Pay from your <span class="notranslate">Denefits</span>
                  account</span>
              </label>
            </div>

            <div class="col-md-5 text-start p-0" style="display:flex;align-items:center;">
              <input id="selected_option5" type="radio" name="business" [(ngModel)]="selected_option" [value]="2"
                class="pull-left" (change)="mountCard(true)">
              <label for="selected_option5">
                <span tappable (click)="selected_option = 2;  mountCard(true);">Pay with a new card</span>
              </label>
            </div>
          </div>
        </div>
      </div>
      <div class="d-block mt-3">
        <ul style="list-style: disc;" class="px-3" *ngIf="payment_option.paymentType == 2 && selected_option == 3">
          <li style="font-size: 12px;font-weight: 400;line-height: 20px;color: #596775">Use this option, if you want to
            pay using
            your Business connected bank account.</li>
        </ul>
        <ul style="list-style: disc;" class="px-3" *ngIf="payment_option.paymentType == 1 && selected_option == 5">
          <li style="font-size: 12px;font-weight: 400;line-height: 20px;color: #596775">Use this option, if you want to
            pay using
            the customer’s connected bank account for this contract.</li>
        </ul>
        <ul style="list-style: disc;" class="px-3" *ngIf="payment_option.paymentType == 1 && selected_option == 1">
          <li style="font-size: 12px;font-weight: 400;line-height: 20px;color: #596775">Use this option, if you want to
            pay using
            the customer’s existing card(s) for this contract.</li>
        </ul>
      </div>
    </div>
    <div class="card-hidden" [ngClass]="{'show-card':edit_contract_step == 5 &&((payment_option.paymentType == 2 && selected_option == 2) ||
      (payment_option.paymentType == 1 && selected_option == 4))}">
      <div class="row m-0">
        <div class="col-12 p-0 mb-3">

          <div class="form-group h-100">
            <div class="custom-form mt-3 px-2 border border-10">
              <div class="form-group h-100">
                <input class="input_field px-2 pt-3" [(ngModel)]="payment_option.cardName" autofocus
                  name="cardholder_name" #cardholder_name="ngModel" trim maxlength="100" minlength="2" required>
                <label for="text" class="label-name">
                  <span class="content-name f-c-p-3">
                    Card Holder Name
                  </span>
                </label>
              </div>
            </div>
            <p *ngIf="cardholder_name.touched && cardholder_name.invalid" class="mat-error m-0">Please enter a
              cardholder
              name</p>
          </div>

          <!-- <div class="w-100 ">
            <label class="form-label d-block ">Card Holder Name</label>
            <input [(ngModel)]="payment_option.cardName" name="cardholder_name" #cardholder_name="ngModel" matInput
              placeholder="Enter cardholder name" trim  maxlength="100" minlength="2" class="form-input w-100"
              style="min-height: 56px !important;">
            <p *ngIf="cardholder_name.invalid" class="mat-error">Please enter a cardholder name</p>
          </div> -->
        </div>
        <div class="col-12 p-0">
          <!-- <label class="form-label d-block ">Card details</label> -->
          <div class="stripe-card border_8 w-100 py-2 mb-0" style="height: 54px !important;align-content: center;"
            id="payment-element"></div>
        </div>
      </div>
    </div>
    <div class="d-block py-2" *ngIf="edit_contract_step == 5 && ((payment_option.paymentType == 2 && selected_option == 2) ||
    (payment_option.paymentType == 1 && selected_option == 4))">
      <ul style="list-style: disc;" class="px-3 mt-3">
        <li style="font-size: 12px;font-weight: 400;line-height: 20px;color: #596775">Use this option, if you want to
          pay using
          the {{(payment_option.paymentType == 2 && selected_option == 2) ? "customer's" : "business's"}} new card.
        </li>
        <!-- <li style="font-size: 12px;font-weight: 400;line-height: 20px;color: #596775"
          *ngIf="payment_option.paymentType == 1 && selected_option == 4">
          Newly added card will not be used as default payment method for future payments for this contract.
        </li>
        <li style="font-size: 12px;font-weight: 400;line-height: 20px;color: #596775">We will not save the card for
          this
          contract.</li> -->
      </ul>
    </div>

    <!--Step 6-->
    <div *ngIf="edit_contract_step == 6">
      <button class="mb-4 bck-btn" (click)="goBackStepEditContract()">
        <img src="assets/img/svg/bckArrow.svg">Back
      </button>
      <div class="row m-0" style="background: #DEE8F1;border-radius: 6px;">
        <div class="bg-faint row m-0 w-100"
          [ngStyle]="{'border-bottom': (edit_contract_data.newFinanceDetails.advance_interest_amount > edit_contract_data.oldFinanceDetails.advance_interest_amount) ? '0.5px solid #c6d6e5' : ''}">
          <div class="col-6" style="border-right: 0.5px solid #c6d6e5;">
            <label>New Recurring Amount</label>
            <h4 class="notranslate">${{(contractData.new_recurring_amount_with_fee +
              ((contractData.credit_reporting_status > 0 && contractData.credit_reporting_fee > 0) ?
              contractData.credit_reporting_fee : 0)) | number:'1.2-2'}}</h4>
          </div>
          <div class="col-6">
            <label>Remaining Payments</label>
            <h4>{{edit_contract_data.newFinanceDetails.remaining_payments}}</h4>
          </div>
        </div>
        <div class="bg-faint row m-0 w-100" style="border-bottom: 0.5px solid #c6d6e5;"
          *ngIf="(edit_contract_data.newFinanceDetails.advance_interest_amount > edit_contract_data.oldFinanceDetails.advance_interest_amount)">
          <div class="col-6" style="border-right: 0.5px solid #c6d6e5;">
            <label>Next Payment Date</label>
            <h4 class="notranslate">{{contractData.next_payment_date|date:"MM/dd/yyyy"}}</h4>
          </div>
          <div class="col-6">
            <label>Upfront Payment Payable Today</label>
            <h4 class="notranslate">${{contractData.net_remaining_upfront_fee | number:'1.2-2'}}</h4>
          </div>
        </div>
        <div class="bg-faint row m-0 w-100"
          *ngIf="contract_types_new_edit.includes(contractData.contract_type)
            ? contractData.net_remaining_upfront_fee > 0
            : (edit_contract_data.newFinanceDetails.advance_interest_amount > edit_contract_data.oldFinanceDetails.advance_interest_amount)">
          <div class="col-6" style="border-right: 0.5px solid #c6d6e5;">
            <label>Payable by</label>
            <h4>
              <span *ngIf="payment_option.paymentType == 1">
                <span *ngIf="selected_option == 1 || selected_option == 4 || selected_option == 5">
                  {{contractData.patient_first_name + ' ' + contractData.patient_last_name}}
                </span>
              </span>
              <span *ngIf="payment_option.paymentType == 2">
                <span *ngIf="selected_option == 3 || selected_option == 2 || selected_option == 5">
                  {{contractData.practice_name || contractData.doctor_first_name + ' ' +
                  contractData.doctor_last_name}}
                </span>
              </span>
            </h4>
          </div>
          <div class="col-6">
            <label>Payment Method</label>
            <h4>
              <span class="d-flex" *ngIf="selected_option == 1">
                <img src="assets/img/svg/pay.svg" class="me-2" />
                {{changePaymentDateCard.last4 ? changePaymentDateCard.last4 :
                contractData.default_card_last4}}
              </span>
              <span class="d-flex" *ngIf="selected_option == 5">
                <mat-icon class="me-2">account_balance</mat-icon>
                {{contractData.plaidAccount[0].last4}}
              </span>
              <span class="d-flex" *ngIf="selected_option == 4">
                <img src="assets/img/svg/pay.svg" class="me-2" />
                {{payment_stripe_data.card.last4}}
              </span>
              <span class="d-flex" *ngIf="selected_option == 3">
                <span class="notranslate">Denefits</span> account
              </span>
              <span class="d-flex" *ngIf="selected_option == 2">
                <img src="assets/img/svg/pay.svg" class="me-2" />
                {{payment_stripe_data.card.last4}}
              </span>
            </h4>
          </div>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-12 custom-form">
          <textarea class="p-1 pt-2 w-100 px-3 b-10" placeholder="Reason" [(ngModel)]="edit_contract_data.notes"
            style="resize: none;"></textarea>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-12">

          <label for="terms" class="w-100 d-flex align-item-center justify-content-around p-2 pointer mb-0">
            <input type="checkbox" name="terms" id="terms_3" class="" [(ngModel)]="edit_contract_data.terms"
              class="pointer" />
            <label for="terms_3" class="me-0 mt-0" style="margin-top: 3px !important;"></label>
            <p class="flex-grow-1 fs-16 fw-bold mb-0 pointer">
              <span class="back-font">
                By clicking on this box, you agree with our
                <a class="text-primary-custom notranslate" [routerLink]="['/terms/contracts-terms']" target="_blank">
                  Terms & Conditions</a>.
                This acceptance will have the same legal effect as a handwritten signature. You agree that all
                information
                in this
                contract is true and has been fully disclosed and agreed upon between you and your customer prior to
                making
                this
                contract adjustment. You are responsible for all of the changes to this contract. In no event will
                <span class="notranslate">Denefits</span> be liable
                for any user errors. ANY ATTEMPTED MISUSE OR FRAUD MAY RESULT IN SUSPENSION OF ALL Protected PAYMENTS.
              </span>
            </p>
          </label>

        </div>
      </div>
    </div>
    <!--Step 7-->
    <div *ngIf="edit_contract_step == 7">
      <div *ngIf="editContractResult.is_error == 0">
        <div class="text-center my-4">
          <img src="assets/img/png/check_signup.png" width="90px" alt="">
          <h3 *ngIf="!(payment_option.paymentType && selected_option == 5)">
            Contract Edited Successfully
          </h3>
          <h4 *ngIf="payment_option.paymentType && selected_option == 5">
            Thank you. We have initiated your transaction
          </h4>
        </div>
        <span *ngIf="selected_option !== 5 && contractData.dnd == 0">
          <p>Send the Edited Contract details to your customer:</p>
        </span>
        <span *ngIf="selected_option !== 5 && contractData.dnd == 0">
          <div class="form-cont">
            <div class="custom-form flex-grow-1 me-md-3 form-group mb-3">
              <input type="text" class="input_field px-3 pt-3" required [(ngModel)]="send_email" name="email"
                #email="ngModel" autofocus />
              <label for="text" class="label-name">
                <span class="content-name f-c-p-3">
                  Email Address
                </span>
              </label>
            </div>
            <div class="custom-form  flex-grow-1 me-md-3 form-group">
              <span *ngIf="send_phone &&  (send_phone !== null && send_phone !== '')"
                class="pt-2 pe-1 fw-bold dollar_input" style="position: absolute;left: 14px;bottom: 8px;">+1
              </span>
              <input type="text" class="input_field pt-3" required [(ngModel)]="send_phone" name="phone"
                #phone="ngModel" autofocus [mask]="mask"
                [ngStyle]="{'padding-left': send_phone !== '' ? '40px' : '1rem'}" />
              <label for="text" class="label-name">
                <span class="content-name f-c-p-3">
                  Text Message
                </span>
              </label>
            </div>
          </div>
        </span>
      </div>
      <div *ngIf="editContractResult.is_error == 1">
        <div class="text-center">
          <img src="assets/img/svg/fail-icon.svg" width="90px" alt="" class="mb-3">
          <h3 class="m-b-20">Payment Failed!</h3>
          <p>{{editContractResult.override_text}}</p>

          <!--Buttons in Error-->
          <div class="col-xs-12 col-sm-12 text-center">
            <button mat-raised-button class="px-4 sup-btn" (click)="gotoNextStepEditContract()" focus-on="true">
              Retry
            </button>
            <button class="ms-3 px-4 sup-btn" mat-raised-button
              *ngIf="edit_contract_data.newFinanceDetails.advance_interest_amount > edit_contract_data.oldFinanceDetails.advance_interest_amount"
              (click)="edit_contract_step = 5; editContractResult = {is_error: 0, override_text: null};">
              Change Card
            </button>
          </div>
          <br>
          <div class="col-xs-12 col-sm-12 text-center">
            <span class="f-c-p-8 fw-600 me-5">Need Support?</span>
            <br>
            <button mat-raised-button class="mt-4 px-4 sup-btn" (click)="goTo('app/help/support')">
              Write to us
            </button>
            <button mat-raised-button class="mt-4 ms-3 px-4 sup-btn" (click)="goTo('app/help/support')">
              Have us call you back
            </button>
            <button mat-raised-button class="me-5 mt-3 px-4 sup-btn" (click)="goTo('app/help/support')">
              Chat with us
            </button>
          </div>
          <br>
        </div>
      </div>
    </div>
    <!--Step 8-->
    <div *ngIf="edit_contract_step == 8">
      <div class="text-center">
        <img src="assets/img/svg/sent.svg" alt="Contract sent successfully">
        <p class="h4">Email/Text Sent Successfully</p>
      </div>
    </div>
    <!--Step 9-->
    <div *ngIf="edit_contract_step == 9">
      <h4>New Service Cost: <strong class="notranslate">${{ edit_contract_data.newFinanceDetails.treatment_amount |
          number:'1.2-2'}}</strong></h4>
      <div class="py-3 service-list" style="overflow-y: auto; max-height: calc(100vh - 250px) !important;">
        <div *ngFor="let d of serviceBreakDown; let i = index;" class="d-flex row mx-0 mb-3">
          <div class="col-md-5 serv-name p-0 me-3">
            <div class="custom-form flex-grow-1 me-md-3">
              <input type="text" class="input_field px-3 pt-3" name="email" required [(ngModel)]="d.service"
                id="breakDownText{{i}}" [ngModelOptions]="{standalone: true}" (keyup)="services()" tabindex="{{i+1}}1"
                autofocus />
              <label for="text" class="label-name">
                <span class="content-name f-c-p-3">
                  Service Name
                </span>
              </label>
            </div>
          </div>
          <div class="col-md-5 p-0">
            <div class="custom-form flex-grow-1 me-md-3 d-flex align-items-center">
              <span *ngIf="d.price !== null && d.price !== ''" class="pt-2 pe-1 fw-bold dollar_input"
                style="position: absolute;left: 14px;bottom: 8px;">$ </span>
              <input appDecimaNumber class="input_field pt-3 notranslate"
                [ngClass]="[d.price !== null && d.price !== '' ? 'px-4' : 'px-3']" id="breakDownVal{{i}}"
                [disabled]="!d.service" [(ngModel)]="d.price" [ngModelOptions]="{standalone: true}"
                onKeyPress="if(this.value.length==8) return false;" (keyup)="services()" tabindex="{{i+1}}2">
              <label for="text" class="label-name">
                <span class="content-name f-c-p-3">
                  Price
                </span>
              </label>
            </div>
          </div>
          <div class="action-item d-flex justify-content-start align-items-center p-1 w-auto">
            <img tappable class="me-1" src="assets/img/svg/close-circle-red.svg" *ngIf="serviceBreakDown.length > 1"
              (click)="deleteBreakdown(i)" />
          </div>
        </div>
        <a tappable *ngIf="serviceBreakDown.length < 25" (click)="addBreakdown()">+Add New Service</a>
      </div>
    </div>
    <!--Step 10 End-->
  </div>
  <div class="d-flex px-4" mat-dialog-actions *ngIf="edit_contract_step < 7 || edit_contract_step == 9">
    <button mat-raised-button [ngClass]="data.actionClass" (click)="edit_contract_step = 7"
      *ngIf="edit_contract_step == 9">Skip</button>
    <button class="sup-btn ms-2" mat-raised-button [ngClass]="data.actionClass" (click)="gotoNextStepEditContract()"
      style="letter-spacing: normal;">
      {{
      edit_contract_step == 9 ? 'Save' :
      edit_contract_step < 6 ? edit_contract_step==2 && !edit_contract_data.tenure &&
        edit_contract_data.new_recurring_amount ? 'Calculate' :'Continue' :
        contract_types_new_edit.includes(contractData.contract_type) && contractData.net_remaining_upfront_fee==0
        ? 'Save' : edit_contract_data.newFinanceDetails.advance_interest_amount>
        edit_contract_data.oldFinanceDetails.advance_interest_amount ? 'Pay Now' :
        'Save'}}
    </button>
  </div>
  <div class="d-flex px-4" mat-dialog-actions *ngIf="edit_contract_step == 7">
    <button mat-raised-button
      *ngIf="contractData.dnd == 0 && editContractResult && editContractResult.is_error == 0 && !(payment_option.paymentType && selected_option == 5)"
      (click)="sendContractPdf('edit_contract_step')">Send</button>
  </div>
</div>

<div class="dialog-header verify-user" *ngIf="data.type == 49">
  <app-notifications></app-notifications>
</div>
<div class="dialog-header" *ngIf="data.type == 50">
  <h2 mat-dialog-title class="py-4 px-3 d-flex justify-content-between align-items-center">
    <span class="px-3">{{data.title}}</span>

    <span class="me-2">
      <mat-icon (click)="dialogRef.close()" class="close text-dark"
        style="position: relative !important; transform: none !important;">close</mat-icon>
    </span>
  </h2>
  <div mat-dialog-content class="pt-0 form-cont">
    <div>
      <div>
        <div class="text-start">
          <form class="container text-start form-cont p-0" [formGroup]="locationManageForm"
            (ngSubmit)="submitLocation()">
            <div class="row p-0 mt-3">

              <div class="form-group w-100 mat-short-height col-sm-12">
                <div
                  [ngClass]="[locationManageForm.controls.locationFirstName.invalid && locationManageForm.controls.locationFirstName.touched  ? 'inputContainer custom-form flex-grow-1 me-md-3' : 'custom-form flex-grow-1 me-md-3']">
                  <input class="input_field px-3 pt-3" formControlName="locationFirstName" required trim minlength="2"
                    maxlength="50" />
                  <label for="text" class="label-name">
                    <span class="content-name f-c-p-3">
                      Business Owner First Name
                    </span>
                  </label>
                </div>
                <p *ngIf="locationManageForm.controls.locationFirstName.invalid && (locationManageForm.controls.locationFirstName.touched || locationManageForm.controls.locationFirstName.dirty)"
                  class="mat-error mb-0">
                  Please enter a valid business owner first name.
                </p>
              </div>

              <div class="form-group w-100 mat-short-height col-sm-12">
                <div
                  [ngClass]="[locationManageForm.controls.locationLastName.invalid && locationManageForm.controls.locationLastName.touched  ? 'inputContainer custom-form flex-grow-1 me-md-3' : 'custom-form flex-grow-1 me-md-3']">
                  <input class="input_field px-3 pt-3" formControlName="locationLastName" required trim />
                  <label for="text" class="label-name">
                    <span class="content-name f-c-p-3">
                      Business Owner Last Name
                    </span>
                  </label>
                </div>
                <p *ngIf="locationManageForm.controls.locationLastName.invalid && locationManageForm.controls.locationLastName.touched"
                  class="mat-error mb-0">
                  Please enter a valid business owner last name.
                </p>
              </div>

              <div class="form-group w-100 mat-short-height col-sm-12">
                <div
                  [ngClass]="[locationManageForm.controls.emailAddress.invalid && locationManageForm.controls.emailAddress.touched  ? 'inputContainer custom-form flex-grow-1 me-md-3' : 'custom-form flex-grow-1 me-md-3']">
                  <input class="input_field px-3 pt-3"
                    [class.disabled_field]="this.data?.send_data?.doctor_email == locationManageForm.controls.emailAddress.value"
                    formControlName="emailAddress" required name="email" trim
                    [readonly]="this.data?.send_data?.doctor_email == locationManageForm.controls.emailAddress.value" />
                  <label for="text" class="label-name">
                    <span class="content-name f-c-p-3">
                      Email
                    </span>
                  </label>
                </div>
                <p *ngIf="locationManageForm.controls.emailAddress.invalid && locationManageForm.controls.emailAddress.touched"
                  class="mat-error mb-0">
                  Please enter a valid email address
                </p>
              </div>

              <div class="form-group w-100 mat-short-height col-sm-12">
                <div class="custom-form"
                  [ngClass]="[(locationManageForm.controls.phoneNumber.invalid && locationManageForm.controls.phoneNumber.touched) || (locationManageForm.controls.phoneNumber.invalid && locationManageForm.controls.phoneNumber.touched) ? 'inputContainer' : '']">

                  <span
                    *ngIf="locationManageForm.controls.phoneNumber &&  (locationManageForm.controls.phoneNumber.value !== null && locationManageForm.controls.phoneNumber.value !== '')"
                    class="pt-2 pe-1 fw-bold dollar_input" style="position: absolute;left: 14px;bottom: 8px;">+1
                  </span>
                  <input class="input_field pt-3"
                    [ngStyle]="{'padding-left': locationManageForm.controls.phoneNumber.value !== '' ? '40px' : '1rem'}"
                    name="phone" formControlName="phoneNumber" [mask]="mask" required />
                  <label for="text" class="label-name">
                    <span class="content-name f-c-p-3">
                      Phone Number
                    </span>
                  </label>
                </div>
                <p *ngIf="locationManageForm.controls.phoneNumber.invalid && locationManageForm.controls.phoneNumber.touched"
                  class="mat-error mb-0">
                  Please enter a valid phone number.
                </p>
              </div>

              <!-- <div class="form-group w-100 mat-short-height col-sm-12">
                <div
                  [ngClass]="[locationManageForm.controls.address.invalid && locationManageForm.controls.address.touched  ? 'inputContainer custom-form flex-grow-1 me-md-3' : 'custom-form flex-grow-1 me-md-3']">
                  <input class="input_field px-3 pt-3" formControlName="address" required name="address" trim  />
                  <label for="text" class="label-name">
                    <span class="content-name f-c-p-3">
                      Address
                    </span>
                  </label>
                </div>
                <p *ngIf="locationManageForm.controls.address.invalid && locationManageForm.controls.address.touched" class="mat-error">
                  Please enter a valid address.
                </p>
              </div>

              <div class="form-group w-100 mat-short-height col-sm-12">
                <zip-selector (zipSelected)="getLocZipselected($event)" [placeholder]="" t="2" [isRequired]="true"
                  id="zipLocCode" name="zipLocCode" [model]="zipLocCode" ngDefaultControl>
                </zip-selector>
                <p *ngIf="locationManageForm.controls.zip.invalid && isLocationSubmitted" class="mat-error">
                  Please enter a valid zipcode.
                </p>
              </div>

              <div class="form-group w-100 mat-short-height col-sm-6">
                <div class="custom-form">
                  <input type="text" class="input_field pt-2 px-3" formControlName="state" required name="state" trim  />
                  <label for="text" [ngClass]="[ locationManageForm.controls.state.value != '' ? 'label-name' : '']">
                    <span class="content-name f-c-p-3">
                      State
                    </span>
                  </label>
                </div>
              </div>

              <div class="form-group w-100 mat-short-height col-sm-6">
                <div class="custom-form">
                  <input type="text" class="input_field pt-2 px-3" formControlName="city" required name="city" trim  />
                  <label for="text" [ngClass]="[ locationManageForm.controls.city.value != '' ? 'label-name' : '']">
                    <span class="content-name f-c-p-3">
                      City
                    </span>
                  </label>
                </div>
              </div> -->


              <div class="form-group w-100 mat-short-height col-sm-12" *ngIf="!this.isEdit">
                <div
                  [ngClass]="[locationManageForm.controls.ind_id.invalid && locationManageForm.controls.ind_id.touched ? 'wrap m-h-56 h-100 h-56 border_10 d-block inputContainer_select' : 'wrap m-h-56 h-100 h-56 border_10 d-block']">
                  <div class="select w-100 h-100 h-56 d-flex justify-content-between align-items-center">
                    <div class="w-100 h-100">
                      <select id="img_logo_emp" name="ind_id" placeholder="" formControlName="ind_id" required
                        style="padding-top: 15px;"
                        (change)="getSubIndustrylist(locationManageForm.controls.ind_id.value)"
                        class="select-text px-3 mt-1 input_field fw-bold m-h-56 h-100 w-100">
                        <option *ngFor="let industry of industryList" [value]="industry.ind_id">{{industry.ind_name}}
                        </option>
                      </select>
                      <span class="select-highlight"></span>
                      <span class="select-bar"></span>
                      <span class="select-bar-1"></span>
                      <span class="select-bar-1"></span>
                      <label class="select-label f-c-p-3">Industry</label>
                    </div>
                  </div>
                </div>
                <p *ngIf="locationManageForm.controls.ind_id.invalid && isLocationSubmitted" class="mat-error mb-0">
                  Please enter a valid industry.
                </p>
              </div>

              <div class="form-group w-100 mat-short-height col-sm-12"
                *ngIf="this.locationManageForm.value.ind_id != '9999' && !this.isEdit">
                <div
                  [ngClass]="[locationManageForm.controls.sub_ind_id.invalid && locationManageForm.controls.sub_ind_id.touched ? 'wrap m-h-56 h-100 h-56 border_10 d-block inputContainer_select' : 'wrap m-h-56 h-100 h-56 border_10 d-block']">
                  <div class="select w-100 h-100 h-56 d-flex justify-content-between align-items-center">
                    <div class="w-100 h-100">
                      <select id="img_logo_emp" name="sub_ind_id" placeholder="" formControlName="sub_ind_id" required
                        style="padding-top: 15px;" class="select-text px-3 mt-1 input_field fw-bold m-h-56 h-100 w-100">
                        <option *ngFor="let sub_industry of sub_industries" [value]="sub_industry.doctor_speciality">
                          {{sub_industry.speciality_name}}</option>
                      </select>
                      <span class="select-highlight"></span>
                      <span class="select-bar"></span>
                      <span class="select-bar-1"></span>
                      <span class="select-bar-1"></span>
                      <label class="select-label f-c-p-3">Sub Industry</label>
                    </div>
                  </div>
                </div>
                <p *ngIf="locationManageForm.controls.sub_ind_id.invalid && isLocationSubmitted"
                  class="mat-error mb-0 mt-1">
                  Please enter a valid sub industry.
                </p>
              </div>

              <div class="form-group w-100 mat-short-height col-sm-12"
                *ngIf="this.locationManageForm.value.ind_id == '9999' && !this.isEdit">
                <div
                  [ngClass]="[locationManageForm.controls.ind_name.invalid && locationManageForm.controls.ind_name.touched  ? 'inputContainer custom-form flex-grow-1 me-md-3' : 'custom-form flex-grow-1 me-md-3']">
                  <input class="input_field px-3 pt-3" formControlName="ind_name" required trim minlength="2"
                    maxlength="50" />
                  <label for="text" class="label-name">
                    <span class="content-name f-c-p-3">
                      Industry Name
                    </span>
                  </label>
                </div>
                <p *ngIf="locationManageForm.controls.ind_name.invalid && locationManageForm.controls.ind_name.touched"
                  class="mat-error mb-0 mt-1">
                  Please enter a valid industry name.
                </p>
              </div>


              <div class="form-group w-100 mat-short-height col-sm-12"
                *ngIf="(this.locationManageForm.value.ind_id == '9999' && !this.isEdit) || (this.locationManageForm.value.sub_ind_id == '9999' && !this.isEdit)">
                <div
                  [ngClass]="[locationManageForm.controls.sub_ind_name.invalid && locationManageForm.controls.sub_ind_name.touched  ? 'inputContainer custom-form flex-grow-1 me-md-3' : 'custom-form flex-grow-1 me-md-3']">
                  <input class="input_field px-3 pt-3" formControlName="sub_ind_name" required trim minlength="2"
                    maxlength="50" />
                  <label for="text" class="label-name">
                    <span class="content-name f-c-p-3">
                      Sub Industry Name
                    </span>
                  </label>
                </div>
                <p *ngIf="locationManageForm.controls.sub_ind_name.invalid && locationManageForm.controls.sub_ind_name.touched"
                  class="mat-error mb-0">
                  Please enter a valid sub industry name.
                </p>
              </div>

            </div>
            <div class="mt-1 d-flex justify-content-start align-item-center pe-5 ps-0 pb-4 pt-2">
              <button button-primary-auth type="submit">{{isEdit ? 'Update': 'Save'}}</button>
            </div>
          </form>
        </div>
      </div>
    </div>

  </div>
</div>


<div class="dialog-header" *ngIf="data.type == 51">
  <h2 mat-dialog-title class="py-4 px-3 d-flex justify-content-between align-items-center">
    <span class="px-3">{{data.title}}</span>

    <span class="me-2">
      <mat-icon (click)="dialogRef.close()" class="close text-dark"
        style="position: relative !important; transform: none !important;">close</mat-icon>
    </span>
  </h2>
  <div mat-dialog-content class="pt-0 form-cont">
    <div>
      <div>
        <div class="text-start">
          <form class="container text-start form-cont p-0" [formGroup]="businessDetailsForm"
            (ngSubmit)="updateBusinessDetails()">
            <div class="row p-0">
              <span class="px-3 py-3"
                style="font-size: 16px;font-weight: 600; color: #596775;line-height: 20px;">Business Information</span>
              <div class="w-100 form-group col-sm-12">
                <div
                  [ngClass]="[businessDetailsForm.controls.businessName.invalid && businessDetailsForm.controls.businessName.touched  ? 'inputContainer custom-form flex-grow-1 me-md-3' : 'custom-form flex-grow-1 me-md-3']">
                  <input class="input_field px-3 pt-3" formControlName="businessName" required trim minlength="2"
                    maxlength="9" />
                  <label for="text" class="label-name">
                    <span class="content-name f-c-p-3">
                      Business Name
                    </span>
                  </label>
                </div>
                <p *ngIf="businessDetailsForm.controls.businessName.invalid && businessDetailsForm.controls.businessName.touched"
                  class="mat-error m-0">
                  Please enter a valid business name.
                </p>
              </div>


              <div class="w-100 form-group col-sm-12">
                <div
                  [ngClass]="[businessDetailsForm.controls.businessEmail.invalid && businessDetailsForm.controls.businessEmail.touched  ? 'inputContainer custom-form flex-grow-1 me-md-3' : 'custom-form flex-grow-1 me-md-3']">
                  <input class="input_field px-3 pt-3" formControlName="businessEmail" required name="email" trim />
                  <label for="text" class="label-name">
                    <span class="content-name f-c-p-3">
                      Email
                    </span>
                  </label>
                </div>
                <p *ngIf="businessDetailsForm.controls.businessEmail.invalid && businessDetailsForm.controls.businessEmail.touched"
                  class="mat-error m-0">
                  Please enter a valid email address
                </p>
              </div>

              <div class="form-group w-100 col-sm-12">
                <div class="custom-form"
                  [ngClass]="[(businessDetailsForm.controls.businessPhoneNumber.invalid && businessDetailsForm.controls.businessPhoneNumber.touched) || (businessDetailsForm.controls.businessPhoneNumber.invalid && businessDetailsForm.controls.businessPhoneNumber.touched) ? 'inputContainer' : '']">

                  <span
                    *ngIf="businessDetailsForm.controls.businessPhoneNumber &&  (businessDetailsForm.controls.businessPhoneNumber.value !== null && businessDetailsForm.controls.businessPhoneNumber.value !== '')"
                    class="pt-2 pe-1 fw-bold dollar_input" style="position: absolute;left: 14px;bottom: 8px;">+1
                  </span>
                  <input class="input_field pt-3"
                    [ngStyle]="{'padding-left': businessDetailsForm.controls.businessPhoneNumber.value !== '' ? '40px' : '1rem'}"
                    name="phone" formControlName="businessPhoneNumber" [mask]="mask" required />
                  <label for="text" class="label-name">
                    <span class="content-name f-c-p-3">
                      Phone Number
                    </span>
                  </label>
                </div>
                <p *ngIf="businessDetailsForm.controls.businessPhoneNumber.invalid && businessDetailsForm.controls.businessPhoneNumber.touched"
                  class="mat-error m-0">
                  Please enter a valid phone number.
                </p>
              </div>
            </div>
            <div class="row p-0">
              <span class="px-3 py-3" style="font-size: 16px;font-weight: 600; color: #596775;line-height: 20px;">Office
                Manager Information</span>
              <div class="form-group w-100 col-sm-12">
                <div class="custom-form flex-grow-1 me-md-3">
                  <input class="input_field px-3 pt-3" formControlName="managerName" trim minlength="2"
                    maxlength="50" />
                  <label for="text" class="label-name">
                    <span class="content-name f-c-p-3">
                      Manager Name
                    </span>
                  </label>
                </div>

              </div>

              <div class="form-group w-100 col-sm-12">
                <div class="custom-form">

                  <span
                    *ngIf="businessDetailsForm.controls.managerPhoneNumber &&  (businessDetailsForm.controls.managerPhoneNumber.value !== null && businessDetailsForm.controls.managerPhoneNumber.value !== '')"
                    class="pt-2 pe-1 fw-bold dollar_input" style="position: absolute;left: 14px;bottom: 8px;">+1
                  </span>
                  <input class="input_field pt-3"
                    [ngStyle]="{'padding-left': businessDetailsForm.controls.managerPhoneNumber.value !== '' ? '40px' : '1rem'}"
                    name="phone" formControlName="managerPhoneNumber" [mask]="mask" />
                  <label for="text" class="label-name">
                    <span class="content-name f-c-p-3">
                      Phone Number
                    </span>
                  </label>
                </div>

              </div>

              <div class="form-group w-100 col-sm-12">
                <div
                  [ngClass]="[businessDetailsForm.controls.managerEmail.invalid && businessDetailsForm.controls.managerEmail.touched  ? 'inputContainer custom-form flex-grow-1 me-md-3' : 'custom-form flex-grow-1 me-md-3']">
                  <input class="input_field px-3 pt-3" formControlName="managerEmail" name="email" trim />
                  <label for="text" class="label-name">
                    <span class="content-name f-c-p-3">
                      Email
                    </span>
                  </label>
                </div>
                <p *ngIf="businessDetailsForm.controls.managerEmail.invalid && businessDetailsForm.controls.managerEmail.touched"
                  class="mat-error m-0">
                  Please enter a valid email address
                </p>
              </div>

            </div>
            <div class="mt-1 d-flex justify-content-start align-item-center pe-5 ps-0 pb-4 pt-2">
              <button button-primary-auth type="submit">Update</button>
            </div>
          </form>
        </div>
      </div>
    </div>

  </div>
</div>

<div class="dialog-header verify-user" *ngIf="data.type == 56">
  <h2 mat-dialog-title class="py-4 px-3 d-flex justify-content-between align-items-center mb-0">
    <span class="px-3">Business & Bank Details</span>
    <mat-icon (click)="dialogRef.close(0)" class="close text-dark"
      style="position: relative !important; transform: none !important;">close</mat-icon>
  </h2>
  <div mat-dialog-content class="p-3">
    <div class="form-group col-12 col-md-12 ps-0 position-relative">
      <!-- business details -->
      <ul class="p-2">
        <li class="formContainer business_details businessDetailsLi" #businessDetailsLi
          [ngClass]="{'currentStripeFormTransition': currentStripeForm != 1, 'heightContainer1': currentStripeForm == 1}"
          [style.height.px]="liHeight">
          <div class="content_frame">
            <div class="radio me-3 d-flex align-items-center">
              <ng-container *ngIf="businessStripeDetailsForm.valid">
                <img src="/assets/img/png/green_tick.png" width="22px" height="22px"
                  (click)="checkCurrentForm($event, 1)" class="pointer" />
                <span class="fs-14 f-c-p-1 ps-2 fw-600 ms-1 pointer" (click)="checkCurrentForm($event, 1)">Business
                  Details</span>
              </ng-container>
              <ng-container *ngIf="!businessStripeDetailsForm.valid">
                <input type="radio" name="currentStripeForm1" [ngClass]="{'d-none': businessStripeDetailsForm.valid}"
                  (click)="checkCurrentForm($event, 1)" [value]=1 id="bus_1" autocomplete="off"
                  [checked]="currentStripeForm == 1" class="pointer" />
                <label for="bus_1" class="mb-0 pointer">
                  <span class="fs-14 f-c-p-1 ps-2 fw-600">Business Details</span>
                </label>
              </ng-container>
            </div>
            <ul class="ps-4 pe-0">
              <li>
                <form [formGroup]="businessStripeDetailsForm">
                  <div class="col-12 pe-0">
                    <!-- Business Email -->
                    <div class="">
                      <div class="custom-form mt-3"
                        [ngClass]="[(businessStripeDetailsForm.controls.businessEmail.invalid && businessStripeDetailsForm.controls.businessEmail.touched) ? 'inputContainer' : '']">
                        <input (blur)="onFieldBlur()" class="input_field pt-2 px-3" name="businessEmail"
                          formControlName="businessEmail" trim="true" required>
                        <label for="text" class="label-name">
                          <span class="content-name f-c-p-3">
                            Business Email
                          </span>
                        </label>
                      </div>
                      <p class="mat-error mb-0"
                        *ngIf="(businessStripeDetailsForm.controls.businessEmail.invalid && businessStripeDetailsForm.controls.businessEmail.touched)">
                        Please enter a valid email</p>
                    </div>
                    <!-- Business Mobile -->
                    <div class="">
                      <div class="custom-form mt-3"
                        [ngClass]="[(businessStripeDetailsForm.controls.businessPhoneNumber.invalid && businessStripeDetailsForm.controls.businessPhoneNumber.touched) ? 'inputContainer' : '']">
                        <span
                          *ngIf="businessStripeDetailsForm.controls.businessPhoneNumber.value !== null && businessStripeDetailsForm.controls.businessPhoneNumber.value !== ''"
                          class="pt-2 pe-1 fw-bold dollar_input" style="position: absolute;left: 14px;bottom: 8px;">+1
                        </span>
                        <input (blur)="onFieldBlur()" class="input_field pt-3" name="businessPhoneNumber"
                          formControlName="businessPhoneNumber" [mask]="mask"
                          [ngStyle]="{'padding-left': businessStripeDetailsForm.value.businessPhoneNumber !== '' ? '40px' : '1rem' }"
                          required>
                        <label for="text" class="label-name">
                          <span class="content-name f-c-p-3">
                            Business Mobile
                          </span>
                        </label>
                      </div>
                      <p class="mat-error mb-0"
                        *ngIf="(businessStripeDetailsForm.controls.businessPhoneNumber.invalid && businessStripeDetailsForm.controls.businessPhoneNumber.touched)">
                        Please enter a valid phone number</p>
                    </div>
                    <!-- business Address -->
                    <div class="">
                      <div class="custom-form mt-3"
                        [ngClass]="[(businessStripeDetailsForm.controls.businessAddress.invalid && businessStripeDetailsForm.controls.businessAddress.touched) ? 'inputContainer' : '']">
                        <input
                          (blur)="onFieldBlur(); businessStripeDetailsForm.controls.businessAddress.setValue(businessStripeDetailsForm.value.businessAddress.trim())"
                          class="input_field pt-2 px-3" name="businessAddress" formControlName="businessAddress"
                          required>
                        <label for="text" class="label-name">
                          <span class="content-name f-c-p-3">
                            Business Address
                          </span>
                        </label>
                      </div>
                      <p class="mat-error mb-0"
                        *ngIf="(businessStripeDetailsForm.controls.businessAddress.invalid && businessStripeDetailsForm.controls.businessAddress.touched)">
                        Please enter a valid address</p>
                    </div>

                    <div class="w-100 d-padding mt-3">
                      <!-- <zip-selector (zipSelected)="getZipselected($event)" [placeholder]=""
                                [customClass]="[customerDetails.controls.zipPostalCode.touched && customerDetails.controls.zipPostalCode.invalid ? 'inputContainer' : 'custom-form']"
                                t="2" [isRequired]="true" id="zipPostalCode" name="zipPostalCode" [model]="zipPostalCode" ngDefaultControl
                                [defaultzip]="zipCode">
                              </zip-selector> -->
                      <app-google-api (setAddress)="getZipselected($event)"
                        [customClass]="[businessStripeDetailsForm.controls.zipPostalCode.touched && businessStripeDetailsForm.controls.zipPostalCode.invalid ? 'inputContainer' : 'custom-form']"
                        [t]="1" id="zipPostalCode" name="zipPostalCode" [model]="zipPostalCode" ngDefaultControl
                        [defaultzip]="zipCode">
                      </app-google-api>
                    </div>
                    <p class="mat-error mb-0"
                      *ngIf="businessStripeDetailsForm.controls && businessStripeDetailsForm.controls.zipPostalCode && businessStripeDetailsForm.controls.zipPostalCode.touched && (businessStripeDetailsForm.controls.zipPostalCode.invalid || !(businessStripeDetailsForm.controls.zipPostalCode && zipCode && zipCode.zip))">
                      Please enter valid zip.
                    </p>

                    <!-- city & state -->
                    <div class="d-flex gap-4">
                      <!-- city  -->
                      <div class="">
                        <div class="custom-form mt-3"
                          [ngClass]="[(businessStripeDetailsForm.controls.city.invalid && businessStripeDetailsForm.controls.city.touched) ? 'inputContainer' : '']">
                          <input (blur)="onFieldBlur();updateCity(businessStripeDetailsForm.value.city, 'user_data')"
                            class="input_field pt-2 px-3" name="city" formControlName="city" required>
                          <label for="text" class="label-name">
                            <span class="content-name f-c-p-3">
                              City
                            </span>
                          </label>
                        </div>
                        <p class="mat-error mb-0"
                          *ngIf="(businessStripeDetailsForm.controls.city.invalid && businessStripeDetailsForm.controls.city.touched)">
                          Please enter a valid city name</p>
                      </div>

                      <!-- state -->
                      <div class=" ps-3">
                        <div class="custom-form mt-3"
                          [ngClass]="[(businessStripeDetailsForm.controls.state.invalid && businessStripeDetailsForm.controls.state.touched) ? 'inputContainer' : '']">
                          <input (blur)="onFieldBlur()" class="input_field pt-2 px-3" name="state"
                            formControlName="state" required readonly disabled>
                          <label for="text" class="label-name">
                            <span class="content-name f-c-p-3">
                              State
                            </span>
                          </label>
                        </div>
                        <p class="mat-error mb-0"
                          *ngIf="(businessStripeDetailsForm.controls.state.invalid && businessStripeDetailsForm.controls.state.touched)">
                          Please enter a valid state</p>
                      </div>
                    </div>

                    <!-- business type dropdown -->
                    <div class="w-100">
                      <div
                        [ngClass]="[businessStripeDetailsForm.controls && businessStripeDetailsForm.controls.businessType && businessStripeDetailsForm.controls.businessType.touched && businessStripeDetailsForm.controls && businessStripeDetailsForm.controls.businessType && businessStripeDetailsForm.controls.businessType.invalid ? 'wrap m-h-56 h-100 h-56 border_10 d-block inputContainer_select mt-3' : 'wrap m-h-56 h-100 h-56 border_10 d-block mt-3']">
                        <div class="select w-100 h-100 h-56 d-flex justify-content-between align-items-center">
                          <div class="w-100 h-100">
                            <select id="img_logo_emp" formControlName="businessType"
                              (change)="changeSelection();onFieldBlur()"
                              class="select-text pt-3 px-3 mt-1 input_field px-3 pt-3 fw-bold m-h-56 h-100 w-100"
                              required>
                              <option class="w-100 py-3 px-2 d-none" selected>
                              </option>
                              <option class="w-100 py-3 px-2" value="company">
                                Company
                              </option>
                              <option class="w-100 py-3 px-2" value="individual">
                                Individual
                              </option>

                            </select>
                            <span class="select-highlight"></span>
                            <span class="select-bar"></span>
                            <span class="select-bar-1"></span>
                            <span class="select-bar-1"></span>
                            <label class="select-label f-c-p-3">Business Type</label>
                          </div>
                        </div>
                      </div>
                      <p class="mat-error w-100 pt-2 mb-0 mt-0"
                        *ngIf="businessStripeDetailsForm.controls && businessStripeDetailsForm.controls.businessType && businessStripeDetailsForm.controls.businessType.touched && businessStripeDetailsForm.controls && businessStripeDetailsForm.controls.businessType && businessStripeDetailsForm.controls.businessType.invalid">
                        Please
                        Choose a valid option</p>
                    </div>

                    <!-- business EiN / SSN field -->
                    <div [ngClass]="{'d-none': businessStripeDetailsForm.value.businessType == ''}">
                      <div class="custom-form mt-3"
                        [ngClass]="[(businessStripeDetailsForm.controls.business_ein.invalid && businessStripeDetailsForm.controls.business_ein.touched) ? 'inputContainer' : '']">
                        <input (blur)="onFieldBlur()" class="input_field pt-2 px-3" name="business_ein"
                          formControlName="business_ein" required
                          [mask]="businessStripeDetailsForm.value.businessType == 'company' ? EIN : SSN">
                        <label for="text" class="label-name">
                          <span class="content-name f-c-p-3">
                            {{businessStripeDetailsForm.value.businessType == 'individual' ? "SSN" : "EIN"}}
                          </span>
                        </label>
                      </div>
                      <ng-container *ngIf="businessStripeDetailsForm.value.businessType == 'company'">
                        <p class="mat-error"
                          *ngIf="businessStripeDetailsForm.get('business_ein')?.touched && businessStripeDetailsForm.value.business_ein != '' && businessStripeDetailsForm.get('business_ein').errors?.invalidEINFormat">
                          EIN must be in the format 12-3456789
                        </p>
                        <p class="mat-error"
                          *ngIf="businessStripeDetailsForm.get('business_ein')?.touched && businessStripeDetailsForm.value.business_ein != '' && businessStripeDetailsForm.get('business_ein').errors?.invalidEINPrefix">
                          EIN cannot start with 00
                        </p>
                      </ng-container>
                      <ng-container *ngIf="businessStripeDetailsForm.value.businessType == 'individual'">
                        <p class="mat-error"
                          *ngIf="businessStripeDetailsForm.get('business_ein')?.touched && businessStripeDetailsForm.value.business_ein != '' && businessStripeDetailsForm.get('business_ein').errors?.invalidSSNFormat">
                          SSN must be 9 digits <!-- (formatted or unformatted) -->
                        </p>
                        <p class="mat-error"
                          *ngIf="businessStripeDetailsForm.get('business_ein')?.touched && businessStripeDetailsForm.value.business_ein != '' && businessStripeDetailsForm.get('business_ein').errors?.invalidSSNArea">
                          <!-- Invalid SSN area number -->
                          Invalid SSN serial number
                        </p>
                        <p class="mat-error"
                          *ngIf="businessStripeDetailsForm.get('business_ein')?.touched && businessStripeDetailsForm.value.business_ein != '' && businessStripeDetailsForm.get('business_ein').errors?.invalidSSNGroup">
                          <!-- Invalid SSN group number -->
                          Invalid SSN serial number
                        </p>
                        <p class="mat-error"
                          *ngIf="businessStripeDetailsForm.get('business_ein')?.touched && businessStripeDetailsForm.value.business_ein != '' && businessStripeDetailsForm.get('business_ein').errors?.invalidSSNSerial">
                          Invalid SSN number
                        </p>
                      </ng-container>
                      <p class="mat-error mb-3"
                        *ngIf="businessStripeDetailsForm.value.business_ein == '' && (businessStripeDetailsForm.controls.business_ein.invalid && businessStripeDetailsForm.controls.business_ein.touched)">
                        Please enter a valid {{businessStripeDetailsForm.value.businessType == 'individual' ? "SSN" :
                        "EIN"}}</p>
                    </div>

                  </div>
                </form>
              </li>
            </ul>
          </div>
        </li>
        <!-- routing section -->

        <li #bankDetailsLi class="formContainer business_bank_details"
          [ngClass]="{'currentStripeFormTransition': currentStripeForm != 2, 'heightContainer2': currentStripeForm == 2 }"
          [style.height.px]="bankliHeight">
          <div class="content_frame">
            <div class="radio me-3 d-flex align-items-center">
              <ng-container *ngIf="bankDetailsForm.valid">
                <img src="/assets/img/png/green_tick.png" width="22px" height="22px" class="pointer"
                  (click)="checkCurrentForm($event, 2)" />
                <span class="fs-14 f-c-p-1 ps-2 fw-600 ms-1 pointer" (click)="checkCurrentForm($event, 2)">Bank
                  Details</span>
              </ng-container>
              <ng-container *ngIf="!bankDetailsForm.valid">
                <input type="radio" name="currentStripeForm2" (click)="checkCurrentForm($event, 2)" [value]=2 id="bus_2"
                  autocomplete="off" [checked]="currentStripeForm == 2" class="pointer" />
                <label for="bus_2" class="mb-0 pointer">
                  <span class="fs-14 f-c-p-1 ps-2 fw-600">Bank Details</span>
                </label>
              </ng-container>
            </div>
            <ul class="ps-4 pe-0">
              <li>
                <form [formGroup]="bankDetailsForm" class="col-12 pe-0" autocomplete="off">
                  <div class="">
                    <div class="custom-form mt-3"
                      [ngClass]="[bankDetailsForm.controls && bankDetailsForm.controls.entityName && bankDetailsForm.controls.entityName.touched && bankDetailsForm.controls.entityName.invalid  ? 'inputContainer' : '']">
                      <input type="text" (blur)="onFieldBlur2()" class="input_field pt-2 px-3" name="entityName"
                        formControlName="entityName" autocomplete="off" trim="true" required minlength="2"
                        maxlength="22" />
                      <label for="text" class="label-name">
                        <span class="content-name f-c-p-3">
                          Account Holder Name
                        </span>
                      </label>
                    </div>
                    <p class="mb-0 mat-error"
                      *ngIf="bankDetailsForm.controls && bankDetailsForm.controls.entityName && bankDetailsForm.controls.entityName.touched && bankDetailsForm.controls.entityName.invalid">
                      Please enter a valid name.
                      <label
                        [tooltip]="'Must contain atleast 2 and max 22 characters, with atleast 1 alphabet. Special characters are not allowed.'"
                        class="info-tool-tips mb-0" [customClass]="'dark-theme-tooltip'" [placementModal]="'1'"
                        [placement]="'right'">
                        <img src="assets/img/svg/info.svg" style="display: inline-block;">
                      </label>
                    </p>
                  </div>
                  <!-- Routing Number -->
                  <div class="">
                    <div class="custom-form mt-3"
                      [ngClass]="[bankDetailsForm.controls && bankDetailsForm.controls.routingNumber && bankDetailsForm.controls.routingNumber.touched && bankDetailsForm.controls.routingNumber.invalid  ? 'inputContainer' : '']">
                      <input type="password" (blur)="onFieldBlur2()" class="input_field pt-2 px-3" name="routingNumber"
                        formControlName="routingNumber" trim="true" required maxlength="9" />
                      <label for="password" class="label-name">
                        <span class="content-name f-c-p-3">
                          Routing Number
                        </span>
                      </label>
                    </div>
                    <p class="mat-error"
                      *ngIf="bankDetailsForm.controls && bankDetailsForm.controls.routingNumber && bankDetailsForm.controls.routingNumber.touched && bankDetailsForm.controls.routingNumber.invalid">
                      Please enter a valid Routing Number.</p>
                  </div>
                  <div class="">
                    <div class="custom-form mt-3"
                      [ngClass]="[bankDetailsForm.controls && bankDetailsForm.controls.confirmRoutingNumber && bankDetailsForm.controls.confirmRoutingNumber.touched && bankDetailsForm.controls.confirmRoutingNumber.invalid  ? 'inputContainer' : '']">
                      <input type="text" (blur)="onFieldBlur2()" class="input_field pt-2 px-3"
                        name="confirmRoutingNumber" formControlName="confirmRoutingNumber" trim="true" required
                        maxlength="9" />
                      <label for="text" class="label-name">
                        <span class="content-name f-c-p-3">
                          Confirm Routing Number
                        </span>
                      </label>
                    </div>
                    <p class="mat-error"
                      *ngIf="bankDetailsForm.controls && bankDetailsForm.controls.confirmRoutingNumber && bankDetailsForm.controls.confirmRoutingNumber.touched && bankDetailsForm.controls.confirmRoutingNumber.invalid">
                      Your routing number does not match</p>
                  </div>
                  <div class="">
                    <div class="custom-form mt-3"
                      [ngClass]="[bankDetailsForm.controls && bankDetailsForm.controls.accountNumber && bankDetailsForm.controls.accountNumber.touched && bankDetailsForm.controls.accountNumber.invalid  ? 'inputContainer' : '']">
                      <input type="password" (blur)="onFieldBlur2()" class="input_field pt-2 px-3" name="accountNumber"
                        formControlName="accountNumber" trim="true" required minlength="1" maxlength="15" />
                      <label for="password" class="label-name">
                        <span class="content-name f-c-p-3">
                          Account Number
                        </span>
                      </label>
                    </div>
                    <p class="mat-error"
                      *ngIf="bankDetailsForm.controls && bankDetailsForm.controls.accountNumber && bankDetailsForm.controls.accountNumber.touched && bankDetailsForm.controls.accountNumber.invalid">
                      Please enter a valid Account Number.</p>
                  </div>
                  <div class="">
                    <div class="custom-form mt-3"
                      [ngClass]="[bankDetailsForm.controls && bankDetailsForm.controls.confirmAccountNumber && bankDetailsForm.controls.confirmAccountNumber.touched && bankDetailsForm.controls.confirmAccountNumber.invalid  ? 'inputContainer' : '']">
                      <input type="text" (blur)="onFieldBlur2()" class="input_field pt-2 px-3"
                        name="confirmAccountNumber" formControlName="confirmAccountNumber" trim="true" required
                        maxlength="15" />
                      <label for="text" class="label-name">
                        <span class="content-name f-c-p-3">
                          Confirm Account Number
                        </span>
                      </label>
                    </div>
                    <p class="mat-error"
                      *ngIf="bankDetailsForm.controls && bankDetailsForm.controls.confirmAccountNumber && bankDetailsForm.controls.confirmAccountNumber.touched && bankDetailsForm.controls.confirmAccountNumber.invalid">
                      Your account number does not match</p>
                  </div>
                </form>
              </li>
            </ul>
          </div>
        </li>

        <!-- signature section -->

        <li class="formContainer business_signature_details"
          [ngClass]="{'currentStripeFormTransition': currentStripeForm != 3, 'heightContainer3': currentStripeForm == 3 }">
          <div class="content_frame">
            <div class="radio me-3 d-flex align-items-center">
              <ng-container *ngIf="consentForm.valid">
                <img src="/assets/img/png/green_tick.png" width="22px" height="22px" class="pointer"
                  (click)="checkCurrentForm($event, 3)" />
                <span class="fs-14 f-c-p-1 ps-2 fw-600 ms-1 pointer" (click)="checkCurrentForm($event, 3)">Bank
                  Details</span>
              </ng-container>
              <ng-container *ngIf="!consentForm.valid">
                <input type="radio" name="currentStripeForm3" (click)="checkCurrentForm($event, 3)" [value]=3 id="bus_3"
                  autocomplete="off" class="pointer" [checked]="currentStripeForm == 3" />
                <label for="bus_3" class="mb-0 pointer">
                  <span class="fs-14 f-c-p-1 ps-2 fw-600">Signature & Confirmation</span>
                </label>
              </ng-container>
            </div>
            <ul>
              <li class="ps-3">
                <form [formGroup]="consentForm" class="col-12 pe-0">
                  <div class="py-2 pt-0 mt-0 max-payment">
                    <!-- <div class="mb-2">
                    <p class="label-name" style=" font-weight: 600;">
                      Business Owner Signature :
                    </p>
                  </div> -->
                    <div class="col-md-12 col-sm-12 col-xs-12 p-0" #sigContainer1 style="overflow: hidden;">
                      <div class="signature-box purple-border border_10 main_container_signature"
                        style="overflow: hidden;">
                        <app-signature-new name="signatureField" formControlName="signatureField" #signaturePad
                          [name]="(userInfo[0].doctor_first_name + ' ' + userInfo[0].doctor_last_name)"></app-signature-new>

                        <!-- <app-signature-pad name="signatureField" formControlName="signatureField" #signaturePad
                      [canvasHeight]="140">
                    </app-signature-pad>
                    <img src="assets/img/svg/eraser.svg" alt="" (click)="clear()" class="eraser"> -->
                      </div>
                    </div>
                    <p class="mat-error mb-0"
                      *ngIf="consentForm.controls && consentForm.controls.signatureField && consentForm.controls.signatureField.touched && consentForm.controls.signatureField.invalid">
                      Please put your signature in the signature box</p>
                  </div>
                  <div class="py-2">
                    <label class="label-name pointer" style=" font-weight: normal;color: grey;">
                      <input type="checkbox" class="pointer" formControlName="terms" id="terms_4">
                      <label for="terms_4" class="me-1"> <span>By providing this information I agree to
                          all</span></label>
                      <a target="_blank" class="text-decoration-none notranslate" style="color:#1581E5;" tappable
                        title="Terms & Conditions" *ngIf="ind_id == 1 || ind_id == 6"
                        [routerLink]="['/terms/business-owner-med-terms']">Terms &
                        Conditions</a>
                      <a target="_blank" class="text-decoration-none notranslate" style="color:#1581E5;" tappable
                        title="Terms & Conditions" *ngIf="!(ind_id == 1 || ind_id == 6)"
                        [routerLink]="['/terms/business-owner-terms']">Terms &
                        Conditions</a>
                    </label>
                    <p class="mat-error"
                      *ngIf="consentForm.controls && consentForm.controls.terms && consentForm.controls.terms.touched && !consentForm.controls.terms.value">
                      Please give your consent for terms & conditions</p>
                  </div>
                </form>
              </li>
            </ul>
          </div>
        </li>

      </ul>

      <div class="button_business_detaild" style="position: fixed;bottom: 45px;width: 446px;">
        <button button-primary-auth class="mt-3 py-3 w-100" (click)="getStripeToken()" [disabled]="addingBank">{{ (!businessStripeDetailsForm.valid || !bankDetailsForm.valid || !consentForm.valid) ? 'Next' : 'Update'}}</button>
      </div>

    </div>
  </div>
</div>

<div class="dialog-header verify-user" *ngIf="data.type == 57">
  <h2 mat-dialog-title class="py-4 px-3 d-flex justify-content-between align-items-center mb-0">
    <span class="px-3 ms-2">Business Information</span>
    <mat-icon (click)="dialogRef.close(0)" class="close text-dark"
      style="position: relative !important; transform: none !important;">close</mat-icon>
  </h2>
  <div mat-dialog-content class="p-3">
    <div class="form-group col-12 col-md-12">
      <form [formGroup]="otherDetailsForm" (submit)="submitOtherDetails();" class="ms-3 me-3">
        <div class="col-12 p-0">
          <label class="mb-2"><strong>Is your business a Brick-and-Mortar business/Online/Mobile?*</strong></label>
          <div class="d-flex justify-content-between">
            <label class="form-check-label pointer" for="flexRadioDefault1">
              <input id="flexRadioDefault1" formControlName="businessType" name="businessType" type="radio"
                value="Brick-and-Mortar">
              <label class="mb-0" for="flexRadioDefault1">
                <span>Brick-and-Mortar</span>
              </label>
            </label>
            <label class="form-check-label pointer" for="flexRadioDefault2">
              <input id="flexRadioDefault2" formControlName="businessType" name="businessType" type="radio"
                value="Online">
              <label class="mb-0" for="flexRadioDefault2">
                <span>Online</span>
              </label>
            </label>
            <label class="form-check-label pointer" for="flexRadioDefault3">
              <input id="flexRadioDefault3" formControlName="businessType" name="businessType" type="radio"
                value="Mobile">
              <label class="mb-0" for="flexRadioDefault3">
                <span>Mobile</span>
              </label>
            </label>
          </div>
          <p class="mat-error"
            *ngIf="(otherDetailsForm.controls.businessType.invalid && otherDetailsForm.controls.businessType.touched)">
            Please select business type</p>
        </div>
        <div class="col-12 p-0 mt-3">
          <label><strong>Please describe your business model*</strong></label>
          <h6 style="margin-top: 10px;">Minimum 50 characters required</h6>
          <div class="reason-area pb-3">
            <div class="custom_text_area"
              [ngClass]="[otherDetailsForm.controls && otherDetailsForm.controls.businessModel && otherDetailsForm.controls.businessModel.touched && otherDetailsForm.controls.businessModel.invalid ? 'inputContainer' : '']">
              <textarea class="text_reason mt-2" formControlName="businessModel"  required maxlength="2000"
                style="margin-bottom: -8px;"></textarea>
              <label for="" class="area_name">
                <span class="label_area" style="background-color: white;width:auto;color: #7A848D !important;">
                  Business Model
                </span>
              </label>
              <small class="length pull-right notranslate">{{ otherDetailsForm.controls.businessModel.value ?
                otherDetailsForm.controls.businessModel.value.length : '0' }}/2000</small>
              <p class="mat-error"
                *ngIf="(otherDetailsForm.controls.businessModel.invalid && otherDetailsForm.controls.businessModel.touched)">
                Please describe your business model</p>
            </div>
          </div>
        </div>
        <div class="w-100 mt-5">
          <label class="mb-2"><strong>How many employees do you have?*</strong></label>
          <div class="wrap m-h-56 h-100 h-56 border_10 d-block mt-1"
            [ngClass]="[otherDetailsForm.controls && otherDetailsForm.controls.numberOfEmployees && otherDetailsForm.controls.numberOfEmployees.touched && otherDetailsForm.controls.numberOfEmployees.invalid ? 'inputContainer_select' : '']">
            <div class="select w-100 h-100 h-56 d-flex justify-content-between align-items-center">
              <div class="w-100 h-100">
                <select id="img_logo_emp" formControlName="numberOfEmployees" (change)="changeSelection()"
                  class="select-text pt-3 px-3 mt-1 input_field fw-bold m-h-56 h-100 w-100" required>
                  <option value="0-50">0-50</option>
                  <option value="50-150">50-150</option>
                  <option value="150-350">150-350</option>
                  <option value="More than 350">More than 350</option>
                </select>
                <span class="select-highlight"></span>
                <span class="select-bar"></span>
                <span class="select-bar-1"></span>
                <span class="select-bar-1"></span>
                <label class="select-label f-c-p-3">Employees strength</label>
              </div>
            </div>
          </div>
          <p class="mat-error w-100"
            *ngIf="otherDetailsForm.controls && otherDetailsForm.controls.numberOfEmployees && otherDetailsForm.controls.numberOfEmployees.touched && otherDetailsForm.controls.numberOfEmployees.invalid">
            Please select employees strength</p>
        </div>
        <div class="w-100 mt-3">
          <label class="mb-2"><strong>How long has your current business been active?*</strong></label>
          <div class="wrap m-h-56 h-100 h-56 border_10 d-block mt-1"
            [ngClass]="[otherDetailsForm.controls && otherDetailsForm.controls.practiceTenure && otherDetailsForm.controls.practiceTenure.touched && otherDetailsForm.controls.practiceTenure.invalid ? 'inputContainer_select' : '']">
            <div class="select w-100 h-100 h-56 d-flex justify-content-between align-items-center">
              <div class="w-100 h-100">
                <select id="img_logo_emp" formControlName="practiceTenure" (change)="changeSelection()"
                  class="select-text pt-3 px-3 mt-1 input_field fw-bold m-h-56 h-100 w-100" required>
                  <option value="Less than one year">Less than one year</option>
                  <option value="1-3 years">1-3 years</option>
                  <option value="3-5 years">3-5 years</option>
                  <option value="More than 5 years">More than 5 years</option>
                </select>
                <span class="select-highlight"></span>
                <span class="select-bar"></span>
                <span class="select-bar-1"></span>
                <span class="select-bar-1"></span>
                <label class="select-label f-c-p-3">Business tenure</label>
              </div>
            </div>
          </div>
          <p class="mat-error w-100"
            *ngIf="otherDetailsForm.controls && otherDetailsForm.controls.practiceTenure && otherDetailsForm.controls.practiceTenure.touched && otherDetailsForm.controls.practiceTenure.invalid">
            Please select your business tenure</p>
        </div>
        <div class="col-12 p-0 mt-4">
          <label class="m-0"><strong>Please add website/any social media link?*</strong></label>
          <div class="custom-form mt-3"
            [ngClass]="[(otherDetailsForm.controls.websiteUrl.invalid && otherDetailsForm.controls.websiteUrl.touched) ? 'inputContainer' : '']">
            <input class="input_field pt-2 px-3" formControlName="websiteUrl" trim>
            <label for="text" class="label-name">
              <span class="content-name f-c-p-3">
                Business Website/Social Media Link
              </span>
            </label>
          </div>
          <p class="mat-error w-100"
            *ngIf="otherDetailsForm.controls.websiteUrl.invalid && otherDetailsForm.controls.websiteUrl.touched">
            Please enter a valid link</p>
          <!-- <div class="custom-form mt-3"
            [ngClass]="[(otherDetailsForm.controls.facebookUrl.invalid && otherDetailsForm.controls.facebookUrl.touched) ? 'inputContainer' : '']">
            <input class="input_field pt-2 px-3" formControlName="facebookUrl" trim >
            <label for="text" class="label-name">
              <span class="content-name f-c-p-3">
                Facebook URL
              </span>
            </label>
          </div>
          <p class="mat-error w-100"
            *ngIf="otherDetailsForm.controls.facebookUrl.invalid && otherDetailsForm.controls.facebookUrl.touched">
            Please enter a valid link</p>
          <div class="custom-form mt-3"
            [ngClass]="[(otherDetailsForm.controls.instagramUrl.invalid && otherDetailsForm.controls.instagramUrl.touched) ? 'inputContainer' : '']">
            <input class="input_field pt-2 px-3" formControlName="instagramUrl" trim >
            <label for="text" class="label-name">
              <span class="content-name f-c-p-3">
                Instagram URL
              </span>
            </label>
          </div>
          <p class="mat-error w-100"
            *ngIf="otherDetailsForm.controls.instagramUrl.invalid && otherDetailsForm.controls.instagramUrl.touched">
            Please enter a valid link</p>
          <div class="custom-form mt-3"
            [ngClass]="[(otherDetailsForm.controls.yelpUrl.invalid && otherDetailsForm.controls.yelpUrl.touched) ? 'inputContainer' : '']">
            <input class="input_field pt-2 px-3" formControlName="yelpUrl" trim >
            <label for="text" class="label-name">
              <span class="content-name f-c-p-3">
                Yelp URL
              </span>
            </label>
          </div>
          <p class="mat-error w-100"
            *ngIf="otherDetailsForm.controls.yelpUrl.invalid && otherDetailsForm.controls.yelpUrl.touched">
            Please enter a valid link</p>
          <div class="custom-form mt-3"
            [ngClass]="[(otherDetailsForm.controls.otherUrl.invalid && otherDetailsForm.controls.otherUrl.touched) ? 'inputContainer' : '']">
            <input class="input_field pt-2 px-3" formControlName="otherUrl" trim >
            <label for="text" class="label-name">
              <span class="content-name f-c-p-3">
                Other URL
              </span>
            </label>
          </div>
          <p class="mat-error w-100"
            *ngIf="otherDetailsForm.controls.otherUrl.invalid && otherDetailsForm.controls.otherUrl.touched">
            Please enter a valid link</p> -->
        </div>
        <div class="col-12 p-0 mt-3">
          <label class="mb-2"><strong>How many customers will you finance per month?*</strong></label>
          <div class="custom-form mt-1"
            [ngClass]="[(otherDetailsForm.controls.customerFinancePerMonth.invalid && otherDetailsForm.controls.customerFinancePerMonth.touched) ? 'inputContainer' : '']">
            <input appDecimaNumber class="input_field pt-2 px-3" formControlName="customerFinancePerMonth" trim
              maxlength="8" required oncopy="return false" onpaste="return false">
            <label for="text" class="label-name">
              <span class="content-name f-c-p-3">
                Average customer financed per month
              </span>
            </label>
          </div>
          <p class="mat-error"
            *ngIf="(otherDetailsForm.controls.customerFinancePerMonth.invalid && otherDetailsForm.controls.customerFinancePerMonth.touched)">
            Please enter average customer financed per month</p>
        </div>
        <!-- <div class="col-12 p-0 mt-3">
          <label><strong>What is the average service amount per customer you are looking at financing?*</strong></label>
          <div class="custom-form flex-grow-1 me-md-3 d-flex align-items-center"
            [ngClass]="[ (otherDetailsForm.controls.averageServiceAmount.touched && otherDetailsForm.controls.averageServiceAmount.invalid) ? 'inputContainer' : '']">
            <span
              *ngIf="otherDetailsForm.controls.averageServiceAmount.value !== null && otherDetailsForm.controls.averageServiceAmount.value !== ''"
              class="pt-2 pe-1 fw-bold dollar_input notranslate"
              style="position: absolute;left: 14px;bottom: 8px;">$</span>
            <input appDecimaNumber class="input_field pt-3"
              [ngClass]="[otherDetailsForm.controls.averageServiceAmount.value !== null && otherDetailsForm.controls.averageServiceAmount.value !== '' ? 'px-4' : 'px-3']"
              formControlName="averageServiceAmount" maxlength="8" required oncopy="return false"
              onpaste="return false">
            <label for="text" class="label-name">
              <span class="content-name f-c-p-3">
                Average service Amount
              </span>
            </label>
          </div>
          <p class="mat-error"
            *ngIf="otherDetailsForm.controls.averageServiceAmount.touched && otherDetailsForm.controls.averageServiceAmount.invalid">
            Please enter average service amount</p>
            </div> -->
        <div class="row mt-3">
          <label class="col-12 mb-2"><strong>What range of amounts would you like to finance per
              customer?*</strong></label>

          <!-- Minimum Amount -->
          <div class="col-md-6 col-12 mt-2">
            <div class="custom-form flex-grow-1 me-md-3 d-flex align-items-center"
              [ngClass]="[(otherDetailsForm.controls.minimumServiceAmount.touched && otherDetailsForm.controls.minimumServiceAmount.invalid) ? 'inputContainer' : '']">
              <span
                *ngIf="otherDetailsForm.controls.minimumServiceAmount.value !== null && otherDetailsForm.controls.minimumServiceAmount.value !== ''"
                class="pt-2 pe-1 fw-bold dollar_input notranslate"
                style="position: absolute; left: 14px; bottom: 8px;">$</span>
              <input appDecimaNumber class="input_field pt-3"
                [ngClass]="[otherDetailsForm.controls.minimumServiceAmount.value !== null && otherDetailsForm.controls.minimumServiceAmount.value !== '' ? 'px-4' : 'px-3']"
                formControlName="minimumServiceAmount" maxlength="8" required oncopy="return false"
                onpaste="return false">
              <label for="text" class="label-name">
                <span class="content-name f-c-p-3">
                  Min. Service Amount
                </span>
              </label>
            </div>
            <p class="mat-error"
              *ngIf="otherDetailsForm.controls.minimumServiceAmount.touched && otherDetailsForm.controls.minimumServiceAmount.invalid">
              Please enter minimum service amount
            </p>
          </div>

          <!-- Maximum Amount -->
          <div class="col-md-6 col-12 mt-2">
            <div class="custom-form flex-grow-1 me-md-3 d-flex align-items-center"
              [ngClass]="[(otherDetailsForm.controls.maximumServiceAmount.touched && otherDetailsForm.controls.maximumServiceAmount.invalid) ? 'inputContainer' : '']">
              <span
                *ngIf="otherDetailsForm.controls.maximumServiceAmount.value !== null && otherDetailsForm.controls.maximumServiceAmount.value !== ''"
                class="pt-2 pe-1 fw-bold dollar_input notranslate"
                style="position: absolute; left: 14px; bottom: 8px;">$</span>
              <input appDecimaNumber class="input_field pt-3"
                [ngClass]="[otherDetailsForm.controls.maximumServiceAmount.value !== null && otherDetailsForm.controls.maximumServiceAmount.value !== '' ? 'px-4' : 'px-3']"
                formControlName="maximumServiceAmount" maxlength="8" required oncopy="return false"
                onpaste="return false">
              <label for="text" class="label-name">
                <span class="content-name f-c-p-3">
                  Max. Service Amount
                </span>
              </label>
            </div>
            <p class="mat-error"
              *ngIf="otherDetailsForm.controls.maximumServiceAmount.touched && otherDetailsForm.controls.maximumServiceAmount.invalid">
              Please enter maximum service amount
            </p>
          </div>
        </div>
        <div class="col-12 p-0 mt-3">
          <label class="mb-2"><strong>Who do you market your services to?*</strong></label>
          <h6>Minimum 20 characters required</h6>
          <div class="reason-area pb-3">
            <div class="custom_text_area"
              [ngClass]="[otherDetailsForm.controls && otherDetailsForm.controls.clientBase && otherDetailsForm.controls.clientBase.touched && otherDetailsForm.controls.clientBase.invalid ? 'inputContainer' : '']">
              <textarea class="text_reason mt-2" formControlName="clientBase" required maxlength="300"
                style="margin-bottom: -8px;"></textarea>
              <label for="" class="area_name">
                <span class="label_area" style="background-color: white;width:auto;color: #7A848D !important;">
                  Marketing audience
                </span>
              </label>
              <small class="length pull-right notranslate">{{ otherDetailsForm.controls.clientBase.value ?
                otherDetailsForm.controls.clientBase.value.length : '0' }}/300</small>
              <p class="mat-error"
                *ngIf="(otherDetailsForm.controls.clientBase.invalid && otherDetailsForm.controls.clientBase.touched)">
                Please describe your marketing audience</p>
            </div>
          </div>
        </div>
        <div class="col-12 p-0 mt-5">
          <label class="mb-2"><strong>Have you ever been convicted of any crimes?*</strong></label>
          <div class="d-flex">
            <label class="form-check-label pointer" for="flexRadioDefault4">
              <input id="flexRadioDefault4" formControlName="crimeStatus" type="radio" value="Yes"
                (click)="crimeKey(1)">
              <label class="mb-0" for="flexRadioDefault4">
                <span>Yes</span>
              </label>
            </label>
            <label class="form-check-label pointer ms-4" for="flexRadioDefault5">
              <input id="flexRadioDefault5" formControlName="crimeStatus" type="radio" value="No" (click)="crimeKey(2)">
              <label class="mb-0" for="flexRadioDefault5">
                <span>No</span>
              </label>
            </label>
          </div>
          <p class="mat-error"
            *ngIf="(otherDetailsForm.controls.crimeStatus.invalid && otherDetailsForm.controls.crimeStatus.touched)">
            Please select an option
          </p>
        </div>
        <div class="col-12 p-0 mt-3">
          <div class="reason-area pb-3">
            <div class="custom_text_area" *ngIf="is_crime_reason"
              [ngClass]="[otherDetailsForm.controls && otherDetailsForm.controls.crimeReason && otherDetailsForm.controls.crimeReason.touched && otherDetailsForm.controls.crimeReason.invalid ? 'inputContainer' : '']">
              <textarea class="text_reason mt-2" formControlName="crimeReason" required maxlength="300"
                style="margin-bottom: -8px;"></textarea>
              <label for="" class="area_name">
                <span class="label_area" style="background-color: white;width:auto;color: #7A848D !important;">
                  Please explain ?
                </span>
              </label>
              <small *ngIf="is_crime_reason" class="length pull-right">{{ otherDetailsForm.controls.crimeReason.value ?
                otherDetailsForm.controls.crimeReason.value.length : '0' }}/300</small>
              <p class="mat-error"
                *ngIf="(otherDetailsForm.controls.crimeReason.invalid && otherDetailsForm.controls.crimeReason.touched)">
                Please describe your convicted status</p>
            </div>
          </div>
        </div>
        <div class="mt-5">
          <button button-primary-auth type="submit">Continue</button>
        </div>
      </form>
    </div>
  </div>
</div>


<div class="dialog-header" *ngIf="data.type == 99">
  <h2 mat-dialog-title class="py-4 px-3 d-flex justify-content-between align-items-center">
    <span class="px-2"> Finance a Customer</span>
    <mat-icon class="close text-dark pointer" style="position: relative !important; transform: none !important;"
      (click)="dialogRef.close()">close</mat-icon>
  </h2>
  <div mat-dialog-content class="pt-0" style="overflow: hidden;">
    <div class="col-12 col-md-8 custom-offset-2 mt-2 text-center">
      <div class="payplan-profile mb-4">
        <img class="m-3" src="assets/img/png/graphic-finance.png">
      </div>
    </div>

    <div class="payment-block" style="height: 44vh;">
      <mat-accordion class="payment-plann">
        <mat-expansion-panel class="col-12 col-md-8 custom-offset-2">
          <mat-expansion-panel-header [collapsedHeight]="'max-content'" style="min-height: 3rem;" class="ms-2">
            <mat-panel-title>
              How does No Fee Financing work?
            </mat-panel-title>
          </mat-expansion-panel-header>
          <p style="color:#000000;text-align: justify; font-size: 14px;font-weight: 500; line-height: 24px;"
            class="px-2">
            How No Fee Financing works You provide us some details about your service and payment preferences and we
            will do the rest.
            <span class="notranslate" style="padding: 0px 2px 0px 2px;">Denefits</span> will create the contract and
            manage and report the payments to credit bureaus. Customers manage their payments through the <span
              class="notranslate">Denefits</span> customer app.
            When payments come in from customers, <span class="notranslate"
              style="padding: 0px 2px 0px 2px;">Denefits</span> automatically routes the payments to your account. If a
            payment is missed, the system will notify you.
            You can claim the missed payment and get paid the principal amount minus the guarantee fee (10%) for that
            payment. This means you are guaranteed 90% of the principal amount.
          </p>
        </mat-expansion-panel>

        <mat-expansion-panel class="col-12 col-md-8 custom-offset-2">
          <mat-expansion-panel-header [collapsedHeight]="'max-content'"
            style="height: 48px !important;min-height: 3rem;" class="ms-2">
            <mat-panel-title>
              What is needed to claim a missed payment?
            </mat-panel-title>
          </mat-expansion-panel-header>
          <p style="color:#000000;text-align: justify; font-size: 14px;font-weight: 500; line-height: 24px;"
            class="px-2">
            A signed service agreement, a copy of the customer's ID matching the contract, and proof of delivered
            service are needed to verify a contract.
            Additionally, at least one new contract per month has to be made with <span class="notranslate"
              style="padding: 0px 2px 0px 2px;">Denefits</span> to maintain eligibility for Protected payments the
            following month.
            Lastly, the customers first recurring payment must be made on time to qualify the contract for Protected
            payments.
          </p>
        </mat-expansion-panel>

        <mat-expansion-panel class="col-12 col-md-8 custom-offset-2">
          <mat-expansion-panel-header [collapsedHeight]="'max-content'"
            style="height: 90px !important;min-height: 3rem;" class="ms-2">
            <mat-panel-title class="d-inline-block">
              Why would I use <span class="notranslate" style="padding: 0px 2px 0px 2px;">Denefits</span> over my
              conventional lender? What are the advantages?
            </mat-panel-title>
          </mat-expansion-panel-header>
          <p style="color:#000000;text-align: justify; font-size: 14px;font-weight: 500; line-height: 24px;"
            class="px-2">
            <span class="notranslate" style="padding: 0px 2px 0px 2px;">Denefits</span> can be your primary or secondary
            method of financing. You can only get an upfront payment from your preferred lender if your customer
            qualifies for financing.
            <span class="notranslate" style="padding: 0px 2px 0px 2px;">Denefits</span> is a catch-all for customers
            that don’t qualify for financing. When customers don’t qualify for financing, you earn $0. <span
              class="notranslate">Denefits</span> turns that $0 into monthly recurring payments for your business.
            Since <span class="notranslate" style="padding: 0px 2px 0px 2px;">Denefits</span> protected your payments,
            we minimize the risk to your business. We recommend you also collect a down payment to cover any upfront
            costs.
          </p>
        </mat-expansion-panel>

        <mat-expansion-panel class="col-12 col-md-8 custom-offset-2">
          <mat-expansion-panel-header [collapsedHeight]="'max-content'"
            style="height: 50px !important;min-height: 3rem;" class="ms-2">
            <mat-panel-title>
              What will be the impact on my business?
            </mat-panel-title>
          </mat-expansion-panel-header>
          <p style="color:#000000;text-align: justify; font-size: 14px;font-weight: 500; line-height: 24px;"
            class="px-2">
            Other than offering <span class="notranslate" style="padding: 0px 2px 0px 2px;">Denefits</span> as another
            financing option, your business does not have to change anything.
            For the first month or two after adding <span class="notranslate"
              style="padding: 0px 2px 0px 2px;">Denefits</span>, your business will earn money as usual. After that,
            your business will still earn its usual plus extra recurring income.
            Your recurring income increases month to month depending on how many customers you finance.
            The more customers you have under <span class="notranslate"
              style="padding: 0px 2px 0px 2px;">Denefits</span>, the more recurring revenue you make.
          </p>
        </mat-expansion-panel>

        <mat-expansion-panel class="col-12 col-md-8 custom-offset-2">
          <mat-expansion-panel-header [collapsedHeight]="'max-content'"
            style="height: 50px !important;min-height: 3rem;" class="ms-2">
            <mat-panel-title>
              How does <span class="notranslate" style="padding: 0px 2px 0px 2px;">Denefits</span> make money?
            </mat-panel-title>
          </mat-expansion-panel-header>
          <p style="color:#000000;text-align: justify; font-size: 14px;font-weight: 500; line-height: 24px;"
            class="px-2">
            <span class="notranslate">Denefits</span> makes money off interest and fees from each payment. A large
            portion of the money we earn goes toward Protected payments.
          </p>
        </mat-expansion-panel>

        <mat-expansion-panel class="col-12 col-md-8 custom-offset-2">
          <mat-expansion-panel-header [collapsedHeight]="'max-content'"
            style="height: 50px !important;min-height: 3rem;" class="ms-2">
            <mat-panel-title>
              How does using<span class="notranslate" style="padding: 0px 2px 0px 2px;">Denefits</span>benefit my
              customers?
            </mat-panel-title>
          </mat-expansion-panel-header>
          <p style="color:#000000;text-align: justify; font-size: 14px;font-weight: 500; line-height: 24px;"
            class="px-2">
            Customers who do not qualify for traditional lending usually have a bad credit history.
            <span class="notranslate" style="padding: 0px 2px 0px 2px;">Denefits</span> reports all payments made or
            missed so customers can improve their credit.
            Unlike traditional lenders and credit card companies, <span class="notranslate"
              style="padding: 0px 2px 0px 2px;">Denefits</span> does not accrue interest over time.
            Interest is calculated only once, therefore payments made many months after it is due will not accrue any
            additional interest.
            Additionally, customers who need help with making payments can use our Social Payments feature that lets
            friends,
            family and other well wishers contribute any amount towards their contract.
          </p>
        </mat-expansion-panel>

        <mat-expansion-panel class="col-12 col-md-8 custom-offset-2">
          <mat-expansion-panel-header [collapsedHeight]="'max-content'"
            style="height: 50px !important;min-height: 3rem;" class="ms-2">
            <mat-panel-title>
              Is <span class="notranslate" style="padding: 0px 2px 0px 2px;">Denefits</span> a Lender?
            </mat-panel-title>
          </mat-expansion-panel-header>
          <p style="color:#000000;text-align: justify; font-size: 14px;font-weight: 500; line-height: 24px;"
            class="px-2">
            <span class="notranslate" style="padding: 0px 2px 0px 2px;">Denefits</span> is a financing system that
            creates installment payments for businesses with the added benefit of Protected Payments.
          </p>
        </mat-expansion-panel>

      </mat-accordion>

    </div>

  </div>

  <div class="d-flex justify-content-center align-item-center ms-4 pb-4 pt-3 payment-start-btn"
    (click)="getStartedtoFinance(1)">
    <button type="submit">Get Started</button>
  </div>
</div>

<div class="dialog-header" *ngIf="data.type == 100">
  <h2 mat-dialog-title class="py-4 px-3 d-flex justify-content-between align-items-center">
    <span class="px-2">No Fee Payment Processing</span>
    <mat-icon class="close text-dark pointer" style="position: relative !important; transform: none !important;"
      (click)="dialogRef.close()">close</mat-icon>
  </h2>
  <div mat-dialog-content class="pt-0" style="overflow: hidden;">
    <div class="col-12 col-md-8 custom-offset-2 mt-2 text-center">
      <div class="payplan-profile mb-4">
        <img class="m-3" src="assets/img/png/graphic-payment.png">
      </div>
    </div>

    <div class="payment-block" style="height: 44vh;">
      <mat-accordion class="payment-plann">
        <mat-expansion-panel class="col-12 col-md-8 custom-offset-2">
          <mat-expansion-panel-header [collapsedHeight]="'max-content'"
            style="height: 50px !important; min-height: 3rem;" class="ms-0">
            <mat-panel-title>
              The problem with payment processing for businesses:
            </mat-panel-title>
          </mat-expansion-panel-header>
          <p style="color:#000000; font-size: 14px;font-weight: 500; line-height: 24px;" class="px-0 d-inline">
            Payment processing with traditional processors burdens your business with <span class="notranslate"
              style="padding: 0px 2px 0px 2px;">100%</span> the cost of merchant fees.
            High-reward credit cards have become increasingly popular in recent years as consumers look for ways to
            maximize the rewards they earn on their everyday purchases.
            However, while these credit cards may offer generous rewards to cardholders <strong>higher rates are
              actually paid off by merchants.</strong>
          </p>
          <p style="color:#000000; font-size: 14px;font-weight: 500; line-height: 24px;" class="px-0 d-inline">
            When a consumer uses a credit card to purchase, the merchant pays a fee to the credit card issuer.
            This fee is known as a "merchant discount rate" and is based on a percentage of the transaction amount.
            The merchant discount rate for high-reward credit cards is often higher than the rate charged for other
            types of credit cards.
            Merchants don’t even know what rate will be charged before payment is accepted.
          </p>
        </mat-expansion-panel>

        <mat-expansion-panel class="col-12 col-md-8 custom-offset-2">
          <mat-expansion-panel-header [collapsedHeight]="'max-content'"
            style="height: 50px !important; min-height: 3rem;" class="ms-0">
            <mat-panel-title class="d-inline-block">
              How <span class="notranslate" style="padding: 0px 2px 0px 2px;">Denefits</span> Payment Processing can
              help:
            </mat-panel-title>
          </mat-expansion-panel-header>
          <p style="color:#000000; font-size: 14px;font-weight: 500; line-height: 24px;" class="px-0 d-inline">
            Since it is not legal for your business to add a surcharge for credit card fees on your own, <span
              class="notranslate" style="padding: 0px 2px 0px 2px;">Denefits</span> Payment Processing can help.
            <span class="notranslate" style="padding: 0px 2px 0px 2px;">Denefits</span> Payment Processing is a payment
            platform. This means that we charge a <span class="notranslate" style="padding: 0px 2px 0px 2px;">3%</span>
            fee for payments processed using our platform.
            This <span class="notranslate" style="padding: 0px 2px 0px 2px;">3%</span> can be paid by either your
            business or your customers or a combination, meaning your business can pay a percentage and your customer
            can pay a percentage.
            We, in turn, pay the credit card fee.
          </p>
        </mat-expansion-panel>

        <mat-expansion-panel class="col-12 col-md-8 custom-offset-2">
          <mat-expansion-panel-header [collapsedHeight]="'max-content'"
            style="height: 50px !important;min-height: 3rem;" class="ms-0">
            <mat-panel-title>
              How you make money right away:
            </mat-panel-title>
          </mat-expansion-panel-header>
          <p style="color:#000000; font-size: 14px;font-weight: 500; line-height: 24px;" class="px-0 d-inline">
            Once you use <span class="notranslate" style="padding: 0px 2px 0px 2px;">Denefits</span> Payment Processing,
            you get the entire payment from a charge if your customer pays the <span class="notranslate"
              style="padding: 0px 2px 0px 2px;">3% </span>platform fee.
            At the end of the month, say you usually pay <span class="notranslate"
              style="padding: 0px 2px 0px 2px;">$5000</span> in merchant fees; by using <span class="notranslate"
              style="padding: 0px 2px 0px 2px;">Denefits</span> payment processing, you will instead add <span
              class="notranslate" style="padding: 0px 2px 0px 2px;">$5000</span> to your monthly revenue.
          </p>
        </mat-expansion-panel>
      </mat-accordion>

    </div>

  </div>

  <div class="d-flex justify-content-center align-item-center ms-4 pb-4 pt-3 payment-start-btn"
    (click)="getStartedtoFinance(2)">
    <button type="submit">Get Started</button>
  </div>
</div>
<div class="dialog-header" *ngIf="data.type == 103">
  <h2 mat-dialog-title class="py-4 px-3 d-flex justify-content-between align-items-center">
    <span class="px-2">Subscriptions</span>
    <mat-icon class="close text-dark pointer" style="position: relative !important; transform: none !important;"
      (click)="dialogRef.close()">close</mat-icon>
  </h2>
  <div mat-dialog-content class="pt-0" style="overflow: hidden;">
    <div class="col-12 col-md-8 custom-offset-2 mt-2 text-center">
      <div class="payplan-profile mb-4">
        <img class="m-3" src="assets/img/png/graphic-payment.png">
      </div>
    </div>

    <div class="payment-block" style="height: 44vh;">
      <mat-accordion class="payment-plann">
        <mat-expansion-panel class="col-12 col-md-8 custom-offset-2">
          <mat-expansion-panel-header [collapsedHeight]="'max-content'"
            style="height: 50px !important; min-height: 3rem;" class="ms-0">
            <mat-panel-title>
              How do Denefits Subscriptions work?
            </mat-panel-title>
          </mat-expansion-panel-header>
          <p style="color:#000000; font-size: 14px;font-weight: 500; line-height: 24px;" class="px-0 d-inline">
            Once a subscription has been set up, payments are automatically charged on a fixed schedule. It helps ensure predictable cash flow like clockwork without manual follow-ups. The subscriptions stay active for as long as the business renders regular services to the customer.
          </p>
        </mat-expansion-panel>

        <mat-expansion-panel class="col-12 col-md-8 custom-offset-2">
          <mat-expansion-panel-header [collapsedHeight]="'max-content'"
            style="height: 50px !important; min-height: 3rem;" class="ms-0">
            <mat-panel-title class="d-inline-block">
              When should I offer a Subscription to a customer?
            </mat-panel-title>
          </mat-expansion-panel-header>
          <p style="color:#000000; font-size: 14px;font-weight: 500; line-height: 24px;" class="px-0 d-inline">
            You can introduce a subscription at any stage—during consultation, after onboarding, or once an ongoing service relationship begins. The right moment depends on the customer’s needs, readiness, and the value your subscription provides.
          </p>
        </mat-expansion-panel>

        <mat-expansion-panel class="col-12 col-md-8 custom-offset-2">
          <mat-expansion-panel-header [collapsedHeight]="'max-content'"
            style="height: 60px !important;min-height: 3rem;" class="ms-0">
            <mat-panel-title>
              What makes offering subscriptions so tricky for service businesses, and how does Denefits solve the problem?
            </mat-panel-title>
          </mat-expansion-panel-header>
          <p style="color:#000000; font-size: 14px;font-weight: 500; line-height: 24px;" class="px-0 d-inline">
            Offering subscriptions can be challenging for service businesses because it’s more than just collecting recurring payments. You need to deliver ongoing value to customers, manage upgrades or downgrades, handle failed payments, and keep track of churn, all while providing flexible pricing that fits different clients. <strong>Denefits solves this by automating recurring billing, sending payment reminders, managing retries for failed transactions, and supporting flexible subscription plans.</strong>
          </p>
          <p style="color:#000000; font-size: 14px;font-weight: 500; line-height: 24px;" class="px-0 d-inline">
            The result is predictable revenue, less administrative work, and happier clients who enjoy seamless, ongoing service.
          </p>
        </mat-expansion-panel>
      </mat-accordion>

    </div>

  </div>

  <div class="d-flex justify-content-center align-item-center ms-4 pb-4 pt-3 payment-start-btn"
    (click)="getStartedtoFinance(2, true)">
    <button type="submit">Get Started</button>
  </div>
</div>

<div class="dialog-header" *ngIf="data.type == 101">
  <h2 mat-dialog-title class="py-4 px-3 d-flex justify-content-between align-items-center">
    <span class="px-2">Accounts Receivable</span>
    <mat-icon class="close text-dark pointer" style="position: relative !important; transform: none !important;"
      (click)="dialogRef.close()">close</mat-icon>
  </h2>
  <div mat-dialog-content class="pt-0" style="overflow: hidden;">
    <div class="col-12 col-md-8 custom-offset-2 mt-2 text-center">
      <div class="payplan-profile mb-4">
        <img class="m-3" src="assets/img/png/graphic-ar.png">
      </div>
    </div>

    <div class="payment-block" style="height: 44vh;">
      <mat-accordion class="payment-plann">
        <mat-expansion-panel class="col-12 col-md-8 custom-offset-2">
          <mat-expansion-panel-header [collapsedHeight]="'max-content'"
            style="height: 50px !important; min-height: 3rem;" class="ms-2">
            <mat-panel-title class="d-inline-block">
              What is <span class="notranslate" style="padding: 0px 2px 0px 2px;">Denefits</span> A/R and why will it
              benefit my business?
            </mat-panel-title>
          </mat-expansion-panel-header>
          <p style="color:#000000;text-align: justify; font-size: 14px;font-weight: 500; line-height: 24px;"
            class="px-2">
            Accounts receivable or past due balance refer to the amount of money a business is entitled to receive from
            its customers for services they had not been paid for. It is an asset for the business as they expect to
            recover the funds. Managing and collecting overdue accounts is crucial for businesses to maintain cash flow
            and ensure timely payments.
            <br><br>
            <span class="notranslate" style="padding: 0px 2px 0px 2px;">Denefits</span> AR system is different from
            other debt collectors. Unlike others that use aggressive tactics, <span class="notranslate"
              style="padding: 0px 2px 0px 2px;">Denefits</span> takes an ethical and legal approach. It helps you
            maintain a trustworthy reputation while recovering debt and preserving positive relationships with
            customers. All you need to do is add your outstanding accounts to the system. <span class="notranslate"
              style="padding: 0px 2px 0px 2px;">Denefits</span> sends respectful reminders to defaulters, encouraging
            them to clear their dues using various payment options such as full settlement, partial payment with
            installments, or payment plans. This automated process helps recover bad debt while minimizing the financial
            burden on customer.
          </p>
        </mat-expansion-panel>

        <mat-expansion-panel class="col-12 col-md-8 custom-offset-2">
          <mat-expansion-panel-header [collapsedHeight]="'max-content'"
            style="height: 50px !important; min-height: 3rem;" class="ms-2">
            <mat-panel-title class="d-inline-block">
              <span class="notranslate" style="padding: 0px 2px 0px 2px;">Denefits</span> A/R vs. Debt Collection
              Agencies
            </mat-panel-title>
          </mat-expansion-panel-header>
          <p style="color:#000000;text-align: justify; font-size: 14px;font-weight: 500; line-height: 24px;"
            class="px-2">
            <span style="font-weight: 700; font-size: 16px; line-height: 24px; color: #05141F;"> 1. Cost: </span>
            Hiring a debt collection agency can be costly. Depending on the agency and the services you require, you may
            have to pay a hefty fee or a percentage of the collected debt. <br><br>
            <span style="font-weight: 700; font-size: 16px; line-height: 24px; color: #05141F;"> 2. Reputation:</span>
            Debt collection agencies may use aggressive tactics to collect debts, which can harm your reputation.
            Additionally, debtors may view you as overly aggressive or unprofessional if you hire a debt collection
            agency.<br><br>
            <span style="font-weight: 700; font-size: 16px; line-height: 24px; color: #05141F;">3. Limited Control:
            </span>
            When you hire a debt collection agency, you may have little control over the process. The agency may take
            certain actions you do not agree with or do not think are necessary.
            <br><br>
            <span style="font-weight: 700; font-size: 16px; line-height: 24px; color: #05141F;"> 4. Legal Issues:
            </span>
            Debt collection agencies must adhere to certain laws and regulations. You may be held liable for any
            penalties or damages if they violate these laws.
          </p>
        </mat-expansion-panel>

        <mat-expansion-panel class="col-12 col-md-8 custom-offset-2">
          <mat-expansion-panel-header [collapsedHeight]="'max-content'"
            style="height: 50px !important;min-height: 3rem;" class="ms-2">
            <mat-panel-title>
              <span class="notranslate" style="padding: 0px 2px 0px 2px;">Denefits</span> A/R vs. Collecting on My Own

            </mat-panel-title>
          </mat-expansion-panel-header>
          <p style="color:#000000;text-align: justify; font-size: 14px;font-weight: 500; line-height: 24px;"
            class="px-2">
            <span style="font-weight: 700; font-size: 16px; line-height: 24px; color: #05141F;">1. Time-Consuming:
            </span>
            Recovering your debt requires you to send out multiple letters, make phone calls, and send legal notices.
            This can take up a lot of time and resources.<br><br>
            <span style="font-weight: 700; font-size: 16px; line-height: 24px; color: #05141F;">2. No Professional
              Experience: </span>
            Unless you have specific training or experience in debt collection, navigating the legal system and
            enforcing your rights can be difficult.
            You may also need to familiarize yourself with applicable laws and regulations in your state or
            locality.<br><br>
            <span style="font-weight: 700; font-size: 16px; line-height: 24px; color: #05141F;">3. Costly: </span>
            Collecting debt on your own can be expensive. You may need to hire extra employees or a lawyer or other
            professional to help you with the process. Additionally, you may need to pay for court costs and other
            expenses.<br><br>
            <span style="font-weight: 700; font-size: 16px; line-height: 24px; color: #05141F;">4. Stressful: </span>
            Collecting debt can be a stressful experience. It involves dealing with reluctant debtors and the challenges
            of recovering the owed amounts.
          </p>
        </mat-expansion-panel>

        <mat-expansion-panel class="col-12 col-md-8 custom-offset-2">
          <mat-expansion-panel-header [collapsedHeight]="'max-content'"
            style="height: 50px !important;min-height: 3rem;" class="ms-2">
            <mat-panel-title>
              How does <span class="notranslate" style="padding: 0px 2px 0px 2px;">Denefits</span> AR work?
            </mat-panel-title>
          </mat-expansion-panel-header>
          <p style="color:#000000;text-align: justify; font-size: 14px;font-weight: 500; line-height: 24px;"
            class="px-2">
            <span style="font-weight: 700; font-size: 16px; line-height: 24px; color: #05141F;">For Single
              Customer:</span><br><br>
            1. Enter your customer’s name, phone number, email address, and basic information about the debt owed.
            <br><br>
            2. The system will automatically send your customer payment options via email, text, and calls if needed.
            <br><br>
            3. Your customer will be consistently contacted weekly or monthly. The <span class="notranslate"
              style="padding: 0px 2px 0px 2px;">Denefits</span> system will automatically adjust its notification
            pattern and payment methods depending on the customer’s behavior.<br><br>
            4. Your customer can clear dues all at once, make a partial payment and pay rest in installments or opt for
            a payment plan.<br><br>
            5. Receive and manage your payments automatically.<br><br><br>

            <span style="font-weight: 700; font-size: 16px; line-height: 24px; color: #05141F;">For Multiple
              Customers:</span><br><br>
            1. Upload a list of your outstanding accounts to the <span class="notranslate"
              style="padding: 0px 2px 0px 2px;">Denefits</span> business panel.<br><br>
            2. The system will automatically send your customers payment options via email, text, and calls if needed.
            <br><br>
            3. Customers are consistently contacted weekly or monthly. The <span class="notranslate"
              style="padding: 0px 2px 0px 2px;">Denefits</span> system will automatically adjust its notification
            pattern and payment methods depending on customers’ behavior. <br><br>
            4. Your customers can clear dues all at once, make a partial payment and pay rest in installments or opt for
            a payment plan.<br><br>
            5. Receive and manage your payments automatically.

          </p>
        </mat-expansion-panel>

        <mat-expansion-panel class="col-12 col-md-8 custom-offset-2">
          <mat-expansion-panel-header [collapsedHeight]="'max-content'"
            style="height: 50px !important;min-height: 3rem;" class="ms-2">
            <mat-panel-title>
              Why you will love <span class="notranslate" style="padding: 0px 2px 0px 2px;">Denefits</span> A/R ?
            </mat-panel-title>
          </mat-expansion-panel-header>
          <ul
            style="color:#000000;text-align: justify; font-size: 14px;font-weight: 500; line-height: 24px;list-style: disc;"
            class="px-4">
            <li>Recover debt while maintaining good relationships with your customers.</li>
            <li>Transparency - Get a clear and instant view of your receivables with real-time insights.</li>
            <li>Save money by eliminating the need for staff to manage overdue accounts.</li>
            <li>Enjoy peace of mind as the system takes care of sending payment reminders and options to customers until
              they
              settle their dues.</li>
            <li>The system digitally segments overdue accounts and uses analytics to improve the chances of recovering
              debt,
              especially from delinquent customers.</li>
            <li>The system automatically collects payments, transfers money into your bank account, and boosts revenue.
            </li>
            <li>No more printing, stamping, stuffing envelopes, and extra trips to the post office, just enjoy automated
              debt
              recovery.</li>
            <li>You are only charged once a successful payment is made by the customer.</li>
            <li>Secure long-term customer relationships by giving them the flexibility to pay off their debt with
              flexible payment
              options.</li>
          </ul>

        </mat-expansion-panel>

        <mat-expansion-panel class="col-12 col-md-8 custom-offset-2">
          <mat-expansion-panel-header [collapsedHeight]="'max-content'"
            style="height: 50px !important;min-height: 3rem;" class="ms-2">
            <mat-panel-title>
              Why your customers will love <span class="notranslate" style="padding: 0px 2px 0px 2px;">Denefits</span>?
            </mat-panel-title>
          </mat-expansion-panel-header>
          <ul
            style="color:#000000;text-align: justify; font-size: 14px;font-weight: 500; line-height: 24px;list-style: disc;"
            class="px-4">
            <li>No harassment from debt collectors</li>
            <li>Less anxiety and embarrassment when dealing with a system. Your customers don’t feel like they are being
              judged
              based on their ability to pay. </li>
            <li><span class="notranslate" style="padding: 0px 2px 0px 2px;">Denefits</span> offers the convenience of
              multiple payment options to pay off the debt.</li>
            <li>Possible higher credit score since all installment payments are reported to the Credit Bureaus.</li>
            <li>A positive experience to clear their outstanding dues.</li>
          </ul>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
  </div>

  <div class="d-flex justify-content-center align-item-center ms-4 pb-4 pt-3 payment-start-btn"
    (click)="getStartedtoFinance(3)">
    <button type="submit">Get Started</button>
  </div>
</div>
<div class="dialog-header" *ngIf="data.type == 104">
  <h2 mat-dialog-title class="py-4 px-3 d-flex justify-content-between align-items-center">
    <span class="px-2">FAQ – Early Buyout Program</span>
    <mat-icon class="close text-dark pointer" style="position: relative !important; transform: none !important;"
      (click)="dialogRef.close()">close</mat-icon>
  </h2>
  <div mat-dialog-content class="pt-0" style="overflow: hidden;">
    <!-- <div class="col-12 col-md-8 custom-offset-2 mt-2 text-center">
      <div class="payplan-profile mb-4">
        <img class="m-3" src="assets/img/png/graphic-ar.png">
      </div>
    </div> -->

    <div class="payment-block" style="height: 44vh;">
      <mat-accordion class="payment-plann">
        <mat-expansion-panel class="col-12 col-md-8 custom-offset-2">
          <mat-expansion-panel-header [collapsedHeight]="'max-content'"
            style="height: 50px !important; min-height: 3rem;" class="ms-2">
            <mat-panel-title class="d-inline-block">
              What contracts are eligible for Early Buyouts?
            </mat-panel-title>
          </mat-expansion-panel-header>
          <p style="color:#000000;text-align: justify; font-size: 14px;font-weight: 500; line-height: 24px;"
            class="px-2">
            Early Buyouts are available for active contracts on No Fee or EZ Deferred Payment plans that have and algori analys and genert.
          </p>
        </mat-expansion-panel>

        <mat-expansion-panel class="col-12 col-md-8 custom-offset-2">
          <mat-expansion-panel-header [collapsedHeight]="'max-content'"
            style="height: 50px !important; min-height: 3rem;" class="ms-2">
            <mat-panel-title class="d-inline-block">
              When will I receive offers and how long do they last?
            </mat-panel-title>
          </mat-expansion-panel-header>
          <p style="color:#000000;text-align: justify; font-size: 14px;font-weight: 500; line-height: 24px;"
            class="px-2">
            Offers are shown in your Business Panel when eligible contracts qualify. They are available for a limited time, so we recommend reviewing them as soon as they appear.
          </p>
        </mat-expansion-panel>

        <mat-expansion-panel class="col-12 col-md-8 custom-offset-2">
          <mat-expansion-panel-header [collapsedHeight]="'max-content'"
            style="height: 50px !important;min-height: 3rem;" class="ms-2">
            <mat-panel-title>
              How much will I get paid — and when?
            </mat-panel-title>
          </mat-expansion-panel-header>
          <p style="color:#000000;text-align: justify; font-size: 14px;font-weight: 500; line-height: 24px;"
            class="px-2">
            You can receive an early payout for up to three qualifying payments per contract. The exact amount is shown before acceptance, and funds are paid directly to your business within a few business days.
          </p>
        </mat-expansion-panel>

        <mat-expansion-panel class="col-12 col-md-8 custom-offset-2">
          <mat-expansion-panel-header [collapsedHeight]="'max-content'"
            style="height: 50px !important;min-height: 3rem;" class="ms-2">
            <mat-panel-title>
             What happens after I accept an offer?
            </mat-panel-title>
          </mat-expansion-panel-header>
          <p style="color:#000000;text-align: justify; font-size: 14px;font-weight: 500; line-height: 24px;"
            class="px-2">
            Once accepted, Denefits disburses the payout directly to your business. Your customer’s payment schedule continues normally, and funding is handled in the background.
          </p>
        </mat-expansion-panel>

        <mat-expansion-panel class="col-12 col-md-8 custom-offset-2">
          <mat-expansion-panel-header [collapsedHeight]="'max-content'"
            style="height: 50px !important;min-height: 3rem;" class="ms-2">
            <mat-panel-title>
              Does this replace my protected payments?
            </mat-panel-title>
          </mat-expansion-panel-header>
          <p
            style="color:#000000;text-align: justify; font-size: 14px;font-weight: 500; line-height: 24px;list-style: disc;"
            class="px-4">
            No. Early Buyouts are optional and work alongside your existing payment protection, offering additional flexibility when cash flow support is needed.
          </p>

        </mat-expansion-panel>

        <mat-expansion-panel class="col-12 col-md-8 custom-offset-2">
          <mat-expansion-panel-header [collapsedHeight]="'max-content'"
            style="height: 50px !important;min-height: 3rem;" class="ms-2">
            <mat-panel-title>
              Why would I use an Early Buyout?
            </mat-panel-title>
          </mat-expansion-panel-header>
          <p
            style="color:#000000;text-align: justify; font-size: 14px;font-weight: 500; line-height: 24px;list-style: disc;"
            class="px-4">
            Early Buyouts help you access funds sooner, protect cash flow during payment delays, and reduce uncertainty without changing how your customers pay.
          </p>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
  </div>

  <div class="d-flex justify-content-center align-item-center ms-4 pb-4 pt-3 payment-start-btn"
    (click)="getStartedtoFinance(3)">
    <button type="submit">Get Started</button>
  </div>
</div>

<!-- diputes -->
<div class="dialog-header verify-user" *ngIf="data.type == 60" style="min-height: 100vh;">
  <h2 mat-dialog-title class="py-4 px-3 d-flex align-items-center mb-0"
    [ngClass]="[is_submitted ? 'justify-content-end': 'justify-content-between']">
    <span class="px-3" *ngIf="!is_submitted">Dispute Details</span>
    <mat-icon (click)="dialogRef.close(0)" class="close text-dark"
      style="position: relative !important; transform: none !important;">close</mat-icon>
  </h2>
  <div mat-dialog-content class="p-3" *ngIf="!is_submitted">
    <div class="form-group col-12 col-md-12">
      <mat-tab-group *ngIf="!is_submitted">
        <mat-tab label="Documents">
          <div class="col-12 mt-4 px-0" *ngIf="data">
            <ng-container *ngIf="data.code != 3 || (checkRemainingUploads() && data.code == 3)">
              <div class="fs-16 f-c-p-1 fw-800 mb-2">
                Upload Documents <span *ngIf="getPendingFiles(contractDocsRequired) && data.code == 2"
                  class="bg_yellow d-inline-block border_8 px-2 ms-3 fs-12 py-1">{{getPendingFiles(contractDocsRequired)}}</span>
                <span class="fw-600 fs-14 pull-right" *ngIf="data.contract_code">Contract Id:
                  {{data.contract_code}}</span>
                <span class="fw-600 fs-14 pull-right" *ngIf="data.pp_code">Payment Process Id: {{data.pp_code}}</span>
                <span class="fw-600 fs-14 pull-right" *ngIf="data.payment_process_code">Subscription Id:
                  {{data.payment_process_code}}</span>
              </div>
              <div class="fs-14 f-c-p-7 mb-1">Max file size: 10MB | Supported files: pdf, png, jpeg, jpg</div>
              <div class="f-c-p-1 fw-700 fs-14 mb-3">
                Requested Document(s)
              </div>
            </ng-container>
            <ng-container *ngIf="data.code == 3 && !checkRemainingUploads()">
              <div class="fs-16 f-c-p-1 fw-800">Submitted Documents
              </div>
              <div class="fs-14 f-c-p-7 mb-1">Max file size: 10MB | Supported files: pdf, jpeg, jpg</div>
              <div class="d-flex align-items-center justify-content-between mb-4">
                <div class="f-c-p-1 fw-700 fs-14 mb-3">
                  Requested Document(s)
                </div>
                <div>
                  <span class="fw-600 fs-14 pull-right" *ngIf="!data.pp_code && !data.payment_process_code">Contract Id:
                    {{data.contract_code}}</span>
                  <span class="fw-600 fs-14 pull-right" *ngIf="data.pp_code && !data.payment_process_code">Payment
                    Process Id: {{data.pp_code}}</span>
                  <span class="fw-600 fs-14 pull-right" *ngIf="data.payment_process_code">Subscription Id:
                    {{data.payment_process_code}}</span>
                </div>
              </div>
            </ng-container>
            <div class="">
              <ng-container>
                <ol class="fs-13 px-3 ps-4" style="list-style-type: decimal !important;color: #A1A1A1;">
                  <ng-container *ngFor="let doc of contractDocsRequired;let i = index;">
                    <!-- [ngClass]="[((!doc.document_id) || doc.need_more_documents == 1) ? '' : 'd-none']"> -->
                    <li style="display: list-item;" class="ps-2">
                      <div class="d-flex mb-3 flex-noWrap justify-content-between">
                        <div class="fs-14 f-c-p-1 d-flex align-items-start flex-grow-1" style="max-width: 330px;">
                          <!-- <span class="d-inline-block" style="color: #A1A1A1">{{doc.s_no}}.&nbsp;&nbsp;</span> -->
                          <span class="d-inline-block">{{doc.document_name}}<span
                              *ngIf="doc.is_required != 0">*</span></span>
                        </div>
                        <!-- [ngClass]="[(!doc.is_uploaded || doc.need_more_documents == 1) ? '' : 'd-none']" -->
                        <div class="flex-grow-1 text-end"
                          *ngIf="!doc.is_uploaded && doc.need_more_documents == 0 && data.code != 5"
                          [ngClass]="{'d-none' : ((doc.is_submitted == 1 || doc.is_uploaded == 1) && doc.need_more_documents == 0)}">
                          <label [for]="100 + i" class="pointer fs-14"
                            style="background: #FAFAFA;padding: 3px 16px;color: #596775;border: 1px solid #C3C8CD;border-radius: 6px;">Upload
                            <input type="file" name="" [id]="100 + i" class="d-none"
                              (change)="uploadContractDocs(doc,$event)" accept=".pdf,.jpeg,.jpg,.png">
                          </label>
                        </div>
                        <div class="" style="min-width: 64px;"
                          [ngClass]="[doc.need_more_documents == 1 ? 'text-end': '']"
                          *ngIf="doc.is_uploaded == 1 || doc.need_more_documents == 1">
                          <span class="d-inline-block pe-4 pointer" *ngIf="doc.is_uploaded == 1" title="View Document">
                            <a [href]="doc.doc_url" target="_blank" referrerpolicy="https://business.denefits.com/">
                              <img src="assets/img/svg/Eye.svg" alt="">
                            </a>
                          </span>
                          <span class="d-inline-block ps-0 pointer" title="Delete Document"
                            *ngIf="doc.is_submitted == 0 && doc.need_more_documents == 0 && doc.is_uploaded == 1 && doc.is_verified != 1">
                            <img src="assets/img/svg/cross_disputes.svg" alt="" (click)="deleteDoc(doc)">
                          </span>
                          <span class="d-inline-block ps-0 pointer" *ngIf="doc.need_more_documents == 1">
                            <label [for]="100+i" class="mb-0 pointer">
                              <img src="assets/img/svg/upload_1.svg" alt="" title="Upload">
                              <input type="file" name="" [id]="100 + i" class="d-none"
                                (change)="uploadContractDocs(doc,$event)" accept=".pdf,.jpeg,.jpg,.png">
                            </label>
                          </span>
                        </div>
                      </div>

                    </li>
                  </ng-container>
                  <ng-container>
                    <li style="display: list-item;" class="ps-2"
                      *ngFor="let doc of CustomerAdditionalDocs;let i = index;">
                      <div class="align-items-end d-flex f-c-p-1 flex-grow-1 fs-14 py-2 justify-content-between">
                        <div class="fs-14 f-c-p-1 d-flex align-items-start w-100">
                          <span class="d-inline-block flex-grow-1"><input type="text" name="file_name"
                              placeholder="Please enter document name" maxlength="500" class="border-bottom w-100"
                              [(ngModel)]="doc.file_name" /></span>
                        </div>
                        <div class="d-flex align-item-center ">
                          <label [for]="1000 + i" class="pointer fs-14 mb-0 button-login me-2"
                            (click)="customDocument(doc)"
                            style="background: #FAFAFA;padding: 3px 16px;color: #596775;border: 1px solid #C3C8CD;border-radius: 6px;">Upload
                            <input type="file" name="" [id]="1000 + i" minlength="2" *ngIf="doc.file_name"
                              class="d-none" [disabled]="!doc.file_name" (change)="getFileFromInput($event,i);"
                              accept=".pdf,.jpeg,.jpg" [value]="doc.document_file">
                          </label>
                          <label [for]="1000 + i" class="pointer fs-14 mb-0" (click)="CustomerAdditionalDocs=[]"
                            style="background: #FAFAFA;padding: 3px 16px;color: #596775;border: 1px solid #C3C8CD;border-radius: 6px;">Delete
                          </label>
                        </div>

                      </div>
                    </li>
                  </ng-container>
                </ol>
              </ng-container>
            </div>
            <div class="py-2" *ngIf="data.code < 4">
              <button button-login
                *ngIf="this.CustomerAdditionalDocs.length == 0 && ((this.CustomerAdditionalDocs.length + this.contractDocsRequired.length) < 10)"
                class="py-2" (click)="addMoreDocument()"
                style="box-shadow: unset !important;border: 1px solid #1581E5; color: #1581E5;">+ Add More
                Documents</button> <span class="fs-13 f-c-p-7 px-3">You can add upto 10 documents</span>
            </div>
            <div class="py-3" *ngIf="data.code != 5">
              <textarea name="" placeholder="Please enter note" id="" class="p-2" [(ngModel)]="changeReason"
                maxlength="250"
                style="background: #FFFFFF;border: 1px solid #DEE8F1;border-radius: 8px;height: 99px;width: 100%;"></textarea>

              <div class="py-3">
                <button button-primary-auth (click)="submitDocs()">Submit</button>
              </div>
            </div>

            <!-- <div class="d-flex align-item-center justify-content-start flex-wrap pdf_view_block"
              *ngIf="checkRemainingUploads() || data.code == 4">

              <ng-container *ngFor="let pdf of contractDocsRequired;let i = index;">
                <span class="fs-16 f-c-p-1 fw-800 d-block my-4 w-100"
                  *ngIf="(checkRemainingUploads(1) || data.code == 4)  && i==0">
                  Uploaded Documents
                </span>
                <ng-container *ngIf="pdf.is_uploaded && pdf.need_more_documents != 1">
                  <ng-container *ngIf="i==0">
                  </ng-container>
                  <app-pdf-viewer #pdfViewer *ngIf="pdfSrc" [value_for]="100 + i" [delete_doc]="pdf"
                    (deleteDocpressed)="deleteDoc($event)" [code]="data.code" [doc_name]="pdf.document_name"
                    [pdfSrc]="pdf.doc_url" [zoom]="20.0"></app-pdf-viewer>
                </ng-container>
              </ng-container>
            </div> -->

          </div>

        </mat-tab>
        <mat-tab label="Disputed Payments">
          <div class="">
            <table class="table table-responsive" *ngIf="data.disutedPayments">
              <thead>
                <tr>
                  <th class="fs-14 border-top-0">S.No.</th>
                  <th class="fs-14 border-top-0">Disputed Date</th>
                  <th class="fs-14 border-top-0">Payment Type</th>
                  <th class="fs-14 border-top-0">Amount Disputed</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let payment of disutedPayments;let i = index;">
                  <td>{{i+1}}</td>
                  <td class="notranslate">{{payment.dispute_date | date :'MM/dd/yyyy'}}</td>
                  <td style="max-width: 150px;">{{payment.payment_type}}</td>
                  <td class="f-c-p-5 notranslate">{{payment.amount_disputed | currency}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </mat-tab>
      </mat-tab-group>
    </div>
  </div>
  <div class="success_tab text-center mt-5 pt-5" *ngIf="is_submitted">
    <img src="assets/img/gif/right_mark11.gif" style="width: 200px;">

    <p class="fw-700 fs-16 mx-auto text-center">Thanks for submitting documents!</p>
    <p class="px-5 fs-18">
      We appreciate your help. We always trying best to keep smooth payments process for your active contracts
    </p>
    <p class="text-success fs-14" *ngIf="getPendingFiles(contractDocsRequired,2)">
      <img src="assets/img/svg/check1.svg" alt="" class="d-inline"> <span class="px-2 fs-14">
        {{getPendingFiles(contractDocsRequired,2)}}
      </span>
    </p>
    <p class="text-warning fs-14" *ngIf="getPendingFiles(contractDocsRequired,1)">
      <!-- <img src="asstes/img/svg/check1.svg" alt=""> -->
      <img src="assets/img/svg/exclamatory_yellow.svg" alt="" class="d-inline"> <span class="px-2 fs-14">
        {{getPendingFiles(contractDocsRequired,1)}}
      </span>
    </p>
  </div>
</div>

<div class="dialog-header" *ngIf="data.type == 105">
  <h2 mat-dialog-title class="px-4 text-end mb-0">
    <mat-icon class="close text-dark pointer" style="position: relative !important; transform: none !important;"
      (click)="dialogRef.close()">close</mat-icon>
  </h2>
  <div mat-dialog-content class="pt-0" style="overflow: unset !important;z-index: 99;position: relative;">
    <div class="text-center" style="margin-top: -20px;">
      <img src="/assets/img/svg/hari_bijli.svg" alt="hari_bijli">
    </div>
    <h3 style="font-weight: 700;" class="px-4 text-center pt-4">Early Buyout Confirmed!</h3>
    <p style="font-weight: 700;" class="text-center py-4">📩 Your Early Buyout for this contract has been<br/>successfully processed. Funds will be transferred on <br/>your next payout. no further action is needed.</p>
  </div>
  <!-- <div class="text-center">
    <button type="button" [routerLink]="['/app/contract/offer-accepted']"
    [queryParams]="{lt: data.loan_amount, ci: data.contract_id, oi: data.offer_id}"
    class="d-flex justify-content-center align-item-center ms-4 pb-3 pt-3 lendee-offer-btn w-50"
    (click)="dialogRef.close()">Confirm</button>
  </div> -->
</div>
